'use client'
import React, { useCallback, useEffect, useState, useRef, useImperativeHandle } from 'react'
import styled from 'styled-components'
import studentRequest from 'utils/studentRequest'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Completion from './completion'
import { selectors } from '../../selectors'
import AudioPlayer from '../../../../components/AudioPlayer'
import WaveformPlayer from '../../../../components/WaveformPlayer'
import {
  submitAssessment,
  submitPracticeAssessment,
  uploadVideoResponse,
  uploadAudioResponse,
} from '../../actions'
import DoubleTick from '../../../../components/icons/DoubleTick'
import Retry from '../../../../components/icons/Retry'
import WhiteRecordIcon from '../../../../components/icons/WhiteRecordIcon'
import StopRecordIcon from '../../../../components/icons/StopRecordIcon'
import DeleteImage from '../../../../components/Images/OBJECTS.png'
import ParagraphReadingIcon from '../../../../components/icons/paragraphreadingicon'
import SpeakingAbilityIcon from '../../../../components/icons/speakingabilityicon'
import ListeningAbilityIcon from '../../../../components/icons/listeningabilityicon'
import WritingAbilityIcon from '../../../../components/icons/writingabilityicon'
import { Button } from 'antd'
import SuccessModal from '../../../../components/SuccessModal'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
  TouchSensor,
  MouseSensor
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  horizontalListSortingStrategy,
  verticalListSortingStrategy,
  rectSortingStrategy
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import {
  PageContainer,
  ContentWrapper,
  ModalOverlay,
  ModalContent,
  Section,
  Paragraph,
  VideoOverlay,
  VideoContainer,
  VideoElement,
  Question,
  QuestionText,
  Options,
  Option,
  NavigationButtons,
  StyledButton,
  ShortListModalImg,
  ModalText,
  AudioContainer,
  QuestionInstruction,
  AssessmentHeader,
  LogoContainer,
  AssessmentInfo,
  VerticalSeparator,
  AssessmentTitle,
  AssessmentTimer,
  FullPageOverlay,
  FullPageContainer,
  FullPageTimer,
  FullPageContent,
  DisabledQuestion,
  FullscreenModalOverlay,
  FullscreenModalContent,
  FullscreenTitle,
  FullscreenDescription,
  PrimaryButton,
  InfoContainer,
  GreenInfoContainer,
  InfoIcon,
  InfoText,
  LanguageCallout,
  LanguageCalloutIcon,
  LanguageCalloutText,
  LanguagePill,
  StepContainer,
  StepItem,
  StepNumber,
  StepContent,
  StepText,
  ParagraphBox,
  BlurredParagraphText,
  BlurredParagraphOverlay,
  StopRecordingButton,
  ParagraphRecordButton,
  QuestionsPlaceholder,
  RecordingSuccessMessage,
  ProgressIndicator,
  ProgressStep,
  StepCircle,
  StepLabel,
  StepTitle,
  RecordingCountdownButton,
  PreRecordCountdownOverlay,
  PreRecordCountdownLabel,
  PreRecordCountdownNumber,
  SectionContentBox,
  TextArea,
  TimerDisplay,
  QuestionBasedTextArea,
  QuestionBasedWordCount,
} from '../../Style'
import { ButtonDiv } from '../../../Events/Preview/Partials/PreviewBox/style'
import PluginLiveLogo from 'components/icons/PluginLiveLogo'
import {
  trackCopyPasteAttempted,
  trackFullscreenEntered,
  trackFullscreenExited,
  trackRightClick,
  trackViolationDetected,
  trackAssessmentAutoSubmitted,
  trackAssessmentCompleted,
  trackDiagnosisCompleted,
  trackDiagnosisProgressUpdated,
  trackPracticeUnlocked,
  trackQuestionAnswered,
  trackAssessmentDroppedOff,
  trackDiagnosisStarted,
  trackAssessmentStarted,
  trackPracticeSessionCompleted,
  trackPracticeSessionDroppedOff,
  trackDiagnosisDroppedOff,
} from '../../../../utils/assessmentEvents'
import { getUserMediaWithSelectedDevices } from '../../../../utils/mediaDevices'
import { mountHiddenProctorVideo, unmountProctorVideo, watchProctorTrack } from '../../../../utils/proctorVideo'
import useProctoringCollector from '../../../../utils/useProctoringCollector'
import useCameraGuard, { isCameraLive } from '../../../../utils/useCameraGuard'
import { shouldEnforceFullscreen, markMobileInterruption, isMobileInterruptionFullscreenExit } from 'utils/deviceTier'
import { pickAudioMimeType, resolveRecordedMimeType } from 'utils/audioFormat'


// Responsive layout helpers
const TwoColRow = styled.div`
  display: flex;
  gap: 24px;
  margin: 0 47px;
  @media (max-width: 768px) {
    flex-direction: column;
    margin: 0 16px;
  }
`;

const TwoColRowFull = styled.div`
  display: flex;
  gap: 32px;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  padding: 32px;
  margin: 0 0 24px 0;
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 16px;
  }
`;

const LeftPane = styled.div`
  flex: 1;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    min-width: auto;
  }
`;

const RightPane = styled.div`
  flex: 1.2;
  min-width: 380px;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    min-width: auto;
  }
`;

const PromptCard = styled.div`
  flex: 1;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 24px;
  min-width: 320px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @media (max-width: 768px) {
    min-width: auto;
  }
`;

const AnswerCard = styled.div`
  flex: 1.2;
  background: #f9fafb;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  min-width: 380px;
  @media (max-width: 768px) {
    min-width: auto;
    padding: 20px;
  }
`;

// Dictation-specific: stack earlier on tablets/phones
const TwoColRowDictation = styled(TwoColRowFull)`
  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 16px;
  }
`;

const SortableItem = ({ id, content, type, isSelected, onClick, disabled, indexDisplay }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: id, disabled: disabled });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    zIndex: isDragging ? 999 : 'auto',
    position: 'relative',
    touchAction: 'none' // Important for touch devices
  };

  if (type === 'word') {
    return (
      <div
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
        onClick={onClick}
      >
        <div style={{
          padding: '8px 12px',
          background: isSelected ? '#e0e7ff' : '#fff',
          border: isSelected ? '2px solid #4f46e5' : '1px solid #e2e8f0',
          borderRadius: '8px',
          cursor: !disabled ? 'grab' : 'not-allowed',
          fontSize: '16px',
          fontWeight: '500',
          color: '#334155',
          transition: 'all 0.2s',
          userSelect: 'none',
          boxShadow: isSelected ? '0 0 0 4px rgba(79, 70, 229, 0.1)' : '0 1px 2px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          minHeight: '44px'
        }}>
          <span style={{ margin: '0 4px' }}>{content}</span>
        </div>
      </div>
    );
  }

  // Sentence
  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      onClick={onClick}
    >
      <div style={{
        padding: '16px',
        background: isSelected ? '#e0e7ff' : '#fff',
        border: isSelected ? '2px solid #4f46e5' : '1px solid #e2e8f0',
        borderRadius: '8px',
        cursor: !disabled ? 'grab' : 'not-allowed',
        fontSize: '15px',
        lineHeight: '1.5',
        display: 'flex',
        alignItems: 'center',
        transition: 'all 0.2s',
        userSelect: 'none',
        boxShadow: isSelected ? '0 0 0 4px rgba(79, 70, 229, 0.1)' : '0 1px 2px rgba(0,0,0,0.05)',
      }}>
        <div style={{
          background: '#f1f5f9',
          color: '#64748b',
          borderRadius: '50%',
          width: '28px',
          height: '28px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '13px',
          fontWeight: '600',
          flexShrink: 0,
          marginRight: '16px'
        }}>
          {indexDisplay}
        </div>
        <div style={{ width: '100%' }}>
          {content}
        </div>
      </div>
    </div>
  );
};

const isUAT = (process.env.ENVIRONMENT || '').toUpperCase() === 'UAT';

const CommunicationAssessment = ({
  questions: questionsFromProps,
  totalQuestions,
  saveQuestionResponse,
  setAssessment,
  isPractice = false,
  assessment,
  autoStart = false,
}) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [sentenceBuildSelectedItem, setSentenceBuildSelectedItem] = useState(null)
  const [videoBlob, setVideoBlob] = useState(null)
  const [recording, setRecording] = useState(false)
  const [preRecordCountdown, setPreRecordCountdown] = useState(null)
  const [completedAudioSections, setCompletedAudioSections] = useState([])
  const [visitedQuestions, setVisitedQuestions] = useState({})
  const store = useStore()
  const [stream, setStream] = useState(null)
  const [recordedVideo, setRecordedVideo] = useState(null)
  const [mediaRecorder, setMediaRecorder] = useState(null)
  const [remainingAttempts, setRemainingAttempts] = useState(2)
  const [remainingRecordingTime, setRemainingRecordingTime] = useState(60)
  const sentenceBuildTimerLockedRef = useRef({});

  const [isModalVisible, setIsModalVisible] = useState(false)
  const videoRef = useRef(null)
  const chunks = useRef([])
  const timerRef = useRef(null)
  // iPhone tab/app-switch recovery: iOS suspends camera capture when the page is
  // backgrounded, which kills an active video-response recording. These refs let
  // the visibility handler (bound once) see live recording state and discard the
  // orphaned/partial take so the candidate can re-record.
  const recordingRef = useRef(false)
  const activeRecorderRef = useRef(null)
  const interruptedRecordingRef = useRef(false)
  // Track the latest in-flight upload promises so handleSubmit can await
  // them on auto-submit before the browser tears down on page transition.
  const inflightVideoUploadRef = useRef(null)
  const inflightAudioUploadRef = useRef(null)
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  // Touch DnD state for Sentence Build (must be at component top-level)
  const touchDragRef = useRef({ type: null, sourceIndex: null })
  const [dictationAudioCompleted, setDictationAudioCompleted] = useState({})
  // const [showEmailWriting, setShowEmailWriting] = useState(null)
  const currentAssessment = useSelector(
    state => state.assessment.currentAssessment
  )
  const proctoringEnabled = currentAssessment?.allowProctoring !== false
  // Fullscreen lockdown is only enforceable on devices that actually support
  // element fullscreen (desktop / macOS Safari / iPad). iPhone Safari cannot
  // fullscreen a web element, so there we run proctoring in "lite" mode:
  // camera snapshots + tab/app-switch detection stay ON, but the fullscreen
  // entry gate, fullscreen re-entry and fullscreen-exit violations are skipped.
  const enforceFullscreen = proctoringEnabled && shouldEnforceFullscreen()
  const assessmentData = location.state?.assessmentData
  const questionsCommunicationArray = useSelector(selectors.getQuestions)
  const responseLanguage = questionsCommunicationArray?.responseLanguage || null
  const durationMinutes = Number(
    questionsCommunicationArray?.duration_minutes || assessment?.duration_minutes || 30
  )
  const totalDurationSeconds = durationMinutes * 60


  const questions = (() => {

    const rawQuestions = questionsCommunicationArray.communications || questionsFromProps || [];

    // Only process if showEmailWriting has been initialized
    // if (showEmailWriting === null) {
    //   // Get assessment name (title)
    //   const assessmentName =
    //     assessment?.title ||
    //     currentAssessment?.title ||
    //     assessmentData?.title ||
    //     '';

    //   // let shouldShowEmail;
    //   // if (assessmentName.trim() === 'Assessment #1') {
    //   //   shouldShowEmail = true; // Always show Email Writing
    //   // } else if (assessmentName.trim() === 'Assessment #2') {
    //   //   shouldShowEmail = false; // Always show Dictation (disable Email Writing)
    //   // } else {
    //   //   shouldShowEmail = Math.random() >= 0.5; 
    //   //   //  shouldShowEmail = false; // For testing, always show Email Writing
    //   // }

    //   setShowEmailWriting(shouldShowEmail);
    //   return rawQuestions;
    // }

    // Find indices of Email Writing and Dictation sections
    // const emailIndex = rawQuestions.findIndex(q => q.type === 'Email Writing');
    // const dictationIndex = rawQuestions.findIndex(q => q.type === 'Dictation');

    // // If both sections exist, filter out one based on our logic
    // if (emailIndex !== -1 && dictationIndex !== -1) {
    //   return rawQuestions.filter((q, index) =>
    //     !((!showEmailWriting && index === emailIndex) ||
    //       (showEmailWriting && index === dictationIndex))
    //   );
    // }

    // If only one or neither exist, return the original array
    // Enforce correct section order: Reading, Listening, Speaking, then writing sections
    const sectionOrder = {
      'Paragraph Reading': 0,
      'Audio Question': 1,
      'Video Response': 2,
      'Question Based Response': 3,
      'Email Writing': 4,
      'Dictation': 5,
      'Sentence Completion': 6,
      'Sentence Build': 7,
    };
    return [...rawQuestions].sort((a, b) => {
      const orderA = sectionOrder[a.type] ?? 99;
      const orderB = sectionOrder[b.type] ?? 99;
      return orderA - orderB;
    });
  })();
  const [audioQuestionsTimer, setAudioQuestionsTimer] = useState(150) // 2 minutes = 120 seconds
  const [audioQuestionsTimeUp, setAudioQuestionsTimeUp] = useState(false)
  const [audioQuestionsTimerActive, setAudioQuestionsTimerActive] = useState(false)
  const audioQuestionsTimerRef = useRef(null)

  const [currentPage, setCurrentPage] = useState(0)
  const [timeLeft, setTimeLeft] = useState(totalDurationSeconds)
  const [assessmentStartTime, setAssessmentStartTime] = useState(null)
  const [audioDuration, setAudioDuration] = useState(0)
  const [audioRecording, setAudioRecording] = useState(false)
  const [audioStream, setAudioStream] = useState(null)
  const [audioRecorder, setAudioRecorder] = useState(null)
  const [audioBlob, setAudioBlob] = useState(null)
  const [audioRemainingAttempts, setAudioRemainingAttempts] = useState(1)
  const [draggedItem, setDraggedItem] = useState(null)
  const [dragOverIndex, setDragOverIndex] = useState(null)
  const [dropTarget, setDropTarget] = useState(null) // { index, type: 'word'|'sentence', position: 'before'|'after' }

  const audioChunks = useRef([])
  const [audioBlobUrl, setAudioBlobUrl] = useState(null)
  const [audioPositions, setAudioPositions] = useState({})
  const [visitedSections, setVisitedSections] = useState([])
  const [audioRecordingDuration, setAudioRecordingDuration] = useState(0)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isCompleted, setIsCompleted] = useState(false)
  const [timeUp, setTimeUp] = useState(false)
  const [timerStarted, setTimerStarted] = useState(false)
  const [timerPaused, setTimerPaused] = useState(false)
  const [recordingPositionBelow, setRecordingPositionBelow] = useState(false)
  const audioRef = useRef(null)
  const [audioIsPlaying, setAudioIsPlaying] = useState(false)
  const [recordingDuration, setRecordingDuration] = useState(0)
  const [fullscreenPermissionGranted, setFullscreenPermissionGranted] =
    useState(false)
  const [showFullscreenModal, setShowFullscreenModal] = useState(
    // Only gate behind the fullscreen entry modal when fullscreen is enforceable
    // (desktop / iPad). On iPhone (lite mode) the entry modal is skipped.
    enforceFullscreen && !isPractice && !autoStart
  )

  // --- dnd-kit sensors (Moved to top level) ---
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8, // Require slight movement to start drag (prevents checks on simple clicks)
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
  const PARAGRAPH_READING_MAX_TIME = 150; // 2.5 minutes = 150 seconds
  const [errorMessage, setErrorMessage] = useState('');
  const [showError, setShowError] = useState(false);

  const [captureCounter, setCaptureCounter] = useState(0)
  const captureRef = useRef(null)
  const canvasRef = useRef(null)
  const captureInterval = useRef(null)
  const proctoringActive = useRef(false)
  // Report-only gaze collector on the hidden proctor video. Mirrors aptitude.
  const proctoringCollector = useProctoringCollector()
  const proctoringCollectorStarted = useRef(false)
  const snapshotBurstUntilRef = useRef(0)
  const [finalSubmittedTime, setFinalSubmittedTime] = useState(0)
  const [completedAssessmentData, setCompletedAssessmentData] = useState(null)
  const [sentenceCompletionCurrentIndex, setSentenceCompletionCurrentIndex] = useState(0)

  // NEW: State for full-page mode
  const [isFullPageMode, setIsFullPageMode] = useState(false)
  const studentDetails = useSelector(state => state.studentData.studentDetails)

  const MAX_RECORDING_TIME = 120
  const MIN_RECORDING_TIME = 60
  const [localResponses, setLocalResponses] = useState({})
  const [minRecordingReached, setMinRecordingReached] = useState(false)
  const [questionBasedTimer, setQuestionBasedTimer] = useState(300) // 5 minutes = 300 seconds
  const [questionBasedTimeUp, setQuestionBasedTimeUp] = useState(false)
  const [questionBasedTimerActive, setQuestionBasedTimerActive] = useState(false)
  const questionBasedTimerRef = useRef(null)
  const [dictationCurrentIndex, setDictationCurrentIndex] = useState(0)
  const [dictationTimer, setDictationTimer] = useState(25)
  const [dictationTimerActive, setDictationTimerActive] = useState(false)
  const dictationTimerRef = useRef(null)
  const MAX_TAB_SWITCH_WARNINGS = 4
  const [tabSwitchCount, setTabSwitchCount] = useState(0)
  const [showViolationModal, setShowViolationModal] = useState(false)
  const [violationType, setViolationType] = useState('tab-switch')
  const [showReentryModal, setShowReentryModal] = useState(false)
  const assessmentActiveRef = useRef(false)
  const completedRef = useRef(false)
  const handleSubmitRef = useRef(() => { })
  const isAutoSubmittedRef = useRef(false)
  const violationSubmissionStartedRef = useRef(false)
  const violationSubmitTimerRef = useRef(null)
  const submitAfterViolation = () => {
    if (violationSubmissionStartedRef.current) return
    violationSubmissionStartedRef.current = true
    if (violationSubmitTimerRef.current) clearTimeout(violationSubmitTimerRef.current)
    isAutoSubmittedRef.current = true
    handleSubmitRef.current()
  }

  // Camera guard: if the camera turns off mid-assessment, silently try to turn
  // it back on in the background — no popup, no pause.
  const { cameraLost: camGuardLost } = useCameraGuard({
    enabled: proctoringEnabled && !!assessmentStartTime && !isCompleted,
    getStream: () => (captureRef.current && captureRef.current.srcObject) || null,
  })
  const [showFullscreenReentryOverlay, setShowFullscreenReentryOverlay] =
    useState(false)
  const capturingInProgress = useRef(false)
  const [audioProgress, setAudioProgress] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)
  const [silentReadingTime, setSilentReadingTime] = useState(90)
  const [paragraphReadingComplete, setParagraphReadingComplete] =
    useState(false)
  const [questionBasedResponse, setQuestionBasedResponse] = useState('')
  const [emailData, setEmailData] = useState({
    to: '',
    subject: '',
    body: ''
  })
  const [sentenceCompletionTimer, setSentenceCompletionTimer] = useState(25)

  const [sentenceCompletionTimerActive, setSentenceCompletionTimerActive] = useState(false)
  const sentenceCompletionTimerRef = useRef(null)
  const [emailWritingResponse, setEmailWritingResponse] = useState('');

  const [dictationAnswers, setDictationAnswers] = useState({})
  const dictationAnswersRef = useRef(dictationAnswers)
  useEffect(() => {
    dictationAnswersRef.current = dictationAnswers
  }, [dictationAnswers])
  const [sentenceCompletionAnswers, setSentenceCompletionAnswers] = useState({})
  const [sentenceBuildCurrentIndex, setSentenceBuildCurrentIndex] = useState(0)
  const [paragraphQuestionsTimer, setParagraphQuestionsTimer] = useState(90)
  const [paragraphQuestionsTimeUp, setParagraphQuestionsTimeUp] = useState(false)
  const [paragraphQuestionsTimerActive, setParagraphQuestionsTimerActive] = useState(false)
  const paragraphQuestionsTimerRef = useRef(null)
  const [sentenceBuildTimer, setSentenceBuildTimer] = useState(180) // 3 minutes = 180 seconds
  const [sentenceBuildTimerActive, setSentenceBuildTimerActive] = useState(false)
  const sentenceBuildTimerRef = useRef(null)
  const [selectedWords, setSelectedWords] = useState([])
  const [paragraphOrder, setParagraphOrder] = useState([])
  const [userInteractedWithParagraph, setUserInteractedWithParagraph] = useState({})

  const [emailWritingTimer, setEmailWritingTimer] = useState(300); // 5 min
  const [imageResponseTimer, setImageResponseTimer] = useState(240) // 4 minutes = 240 seconds
  const [imageResponseTimeUp, setImageResponseTimeUp] = useState(false)
  const [imageResponseTimerActive, setImageResponseTimerActive] = useState(false)

  const [showAudioCompleteModal, setShowAudioCompleteModal] = useState(false);
  const [audioReplayRequested, setAudioReplayRequested] = useState(false);
  const [audioPlayCount, setAudioPlayCount] = useState({});
  const audioPlayerRef = useRef(null);

  const imageResponseTimerRef = useRef(null)
  const [emailWritingTimeUp, setEmailWritingTimeUp] = useState(false);
  const [emailWritingTimerActive, setEmailWritingTimerActive] = useState(false);
  const emailWritingTimerRef = useRef(null);
  const practiceAccessState = useSelector(state => state.practiceAccess)

  let recordingTimer = null

  // Get current section
  const currentSection = questions[currentPage] || {}

  // NEW: Function to enter fullscreen
  const enterFullscreen = async () => {
    try {
      const element = document.documentElement
      if (element.requestFullscreen) {
        await element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        await element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        await element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        await element.msRequestFullscreen()
      }
      return true
    } catch (error) {
      console.error('Failed to enter fullscreen:', error)
      throw error
    }
  }

  // NEW: Function to hide all layout elements
  const hideLayoutElements = () => {
    // Hide common layout elements
    const elementsToHide = [
      'header',
      'nav',
      '.header',
      '.navigation',
      '.navbar',
      '.sidebar',
      '.top-bar',
      '.main-header',
      '.app-header',
      '.layout-header',
      '.page-header',
      '.site-header',
      '.tabs',
      '.tab-container',
      '.breadcrumb',
      '.breadcrumbs',
      '.menu',
      '.main-menu',
      '.primary-nav',
      '.secondary-nav',
      '.footer',
      '.page-footer',
      '.site-footer',
      '.layout-footer',
    ]

    elementsToHide.forEach(selector => {
      const elements = document.querySelectorAll(selector)
      elements.forEach(element => {
        element.style.display = 'none'
        element.setAttribute('data-hidden-by-assessment', 'true')
      })
    })

    // Hide body overflow to prevent scrolling — ONLY where we enforce fullscreen
    // (desktop / iPad). On iPhone (LITE) the page MUST stay scrollable: the
    // full-page overlay is height:100vh, so locking body scroll traps the bottom
    // action buttons (Next / Submit) behind Safari's un-hideable toolbar and the
    // candidate can never reach them. The App.js `body.assessment-mobile`
    // scroll-unlock CSS only works if the body itself can scroll.
    if (shouldEnforceFullscreen()) {
      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
    }
  }

  // NEW: Function to restore layout elements
  const restoreLayoutElements = () => {
    const hiddenElements = document.querySelectorAll(
      '[data-hidden-by-assessment="true"]'
    )
    hiddenElements.forEach(element => {
      element.style.display = ''
      element.removeAttribute('data-hidden-by-assessment')
    })

    // Restore body overflow
    document.body.style.overflow = ''
    document.documentElement.style.overflow = ''
  }

  // Silently re-acquire the proctor camera in the background — no popup, no pause.
  const reacquiringCameraRef = useRef(false)
  const reacquireCameraSilently = useCallback(async () => {
    if (reacquiringCameraRef.current) return
    reacquiringCameraRef.current = true
    try {
      try {
        if (captureRef.current && captureRef.current.srcObject) {
          captureRef.current.srcObject.getTracks().forEach(t => { try { t.stop() } catch (_) {} })
        }
      } catch (e) { /* noop */ }
      captureRef.current = null
      window.proctorStreamTracks = []
      const blob = await captureImage()
      if (blob) await uploadProctorImage(blob)
    } catch (e) {
      console.warn('[camera-guard] silent re-acquire failed:', e?.message || e)
    } finally {
      reacquiringCameraRef.current = false
    }
  }, [])

  // While the camera is lost mid-assessment, keep retrying silently in the
  // background until it's back — the assessment keeps running uninterrupted.
  useEffect(() => {
    if (!camGuardLost) return undefined
    reacquireCameraSilently()
    const id = setInterval(reacquireCameraSilently, 5000)
    return () => clearInterval(id)
  }, [camGuardLost, reacquireCameraSilently])

  // NEW: Function to enter full-page mode
  const enterFullPageMode = async () => {
    // Best-effort camera start: try to get a live camera before starting, but
    // don't block the assessment on it — the guard keeps retrying in the background.
    if (proctoringEnabled && !isCameraLive(captureRef.current && captureRef.current.srcObject)) {
      try { await captureImage() } catch (e) { /* fall through */ }
    }
    setIsFullPageMode(true)
    hideLayoutElements()
    // Also enter browser fullscreen if supported
    try {
      await enterFullscreen()
    } catch (error) {
      console.error('Failed to enter browser fullscreen:', error)
    }
  }

  // NEW: Function to exit full-page mode
  const exitFullPageMode = () => {
    setIsFullPageMode(false)
    restoreLayoutElements()
    // Exit browser fullscreen
    if (document.exitFullscreen) {
      document.exitFullscreen().catch(console.error)
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen()
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen()
    }
  }

  // Helper functions
  const formatParagraphWithSpacing = paragraph => {
    if (!paragraph) return []
    return paragraph.split('\n\n').filter(p => p.trim())
  }
  const handleDictationAudioComplete = (audioUrl) => {
    setDictationAudioCompleted(prev => ({
      ...prev,
      [audioUrl]: true
    }));

    // Always start timer when audio completes
    setDictationTimerActive(true);

    // Reset timer to full time when audio completes
    setDictationTimer(25);
  }
  // NEW: Function to split text into paragraphs of 3 sentences each
  const formatParagraphIntoSentenceGroups = paragraph => {
    if (!paragraph) return []

    // Split by existing paragraph breaks first
    const existingParagraphs = paragraph.split('\n\n').filter(p => p.trim())
    const sentenceGroups = []

    existingParagraphs.forEach(para => {
      // Split paragraph into sentences using common sentence endings
      const sentences = para
        .split(/(?<=[.!?])\s+/)
        .filter(sentence => sentence.trim())

      // Group sentences into chunks of 3
      for (let i = 0; i < sentences.length; i += 3) {
        const group = sentences.slice(i, i + 3).join(' ')
        if (group.trim()) {
          sentenceGroups.push(group.trim())
        }
      }
    })

    return sentenceGroups
  }
  useEffect(() => {
    if (!assessmentStartTime) {
      setAssessmentStartTime(new Date())
    }
  }, [])

  // Detect page refresh and close events
  useEffect(() => {
    const isActive = isFullPageMode && !isCompleted;

    const handleBeforeUnload = (e) => {
      if (isFullPageMode && fullscreenPermissionGranted && !isCompleted) {
        // Show browser confirmation dialog to prevent accidental exit
        e.preventDefault();
        e.returnValue = '';

        const timeElapsed = assessmentStartTime
          ? Math.floor((new Date() - assessmentStartTime) / 1000)
          : (totalDurationSeconds - timeLeft); // Calculate from time left if no start time

        trackAssessmentDroppedOff(
          timeElapsed,
          currentAssessment?.assessment_assigned_id,
          currentAssessment?.type,
          currentAssessment?.isCorporate,
          currentAssessment?.entityName
        );

        if (currentAssessment?.isPractice === "true" || currentAssessment?.isPractice === true) {
          trackPracticeSessionDroppedOff(currentAssessment?.assessment_assigned_id, currentAssessment?.type, null, timeElapsed, false, currentAssessment?.entityName);
        }

        if (currentAssessment.title === "Assessment #1" || currentAssessment.title === "Assessment #2") {
          const diagnosisNumber = 2 - currentAssessment.CommunicationDiagnosisRemain + 1;
          trackDiagnosisDroppedOff(diagnosisNumber, timeElapsed, currentAssessment?.assessment_assigned_id, currentAssessment?.type, currentAssessment?.entityName);
        }
      }
    };

    const handleUnload = () => {
      if (isFullPageMode && !isCompleted) {
        const timeElapsed = assessmentStartTime
          ? Math.floor((new Date() - assessmentStartTime) / 1000)
          : (totalDurationSeconds - timeLeft);

        trackAssessmentDroppedOff(
          timeElapsed,
          currentAssessment?.assessment_assigned_id,
          currentAssessment?.type,
          currentAssessment?.isCorporate,
          currentAssessment?.entityName
        );

        if (currentAssessment?.isPractice === "true" || currentAssessment?.isPractice === true) {
          trackPracticeSessionDroppedOff(currentAssessment?.assessment_assigned_id, currentAssessment?.type, null, timeElapsed, false, currentAssessment?.entityName);
        }

        if (currentAssessment.title === "Assessment #1" || currentAssessment.title === "Assessment #2") {
          const diagnosisNumber = 2 - currentAssessment.CommunicationDiagnosisRemain + 1;
          trackDiagnosisDroppedOff(diagnosisNumber, timeElapsed, currentAssessment?.assessment_assigned_id, currentAssessment?.type, currentAssessment?.entityName);
        }
      }
    };

    // Prevent browser back button during active assessment
    const handlePopState = () => {
      if (isFullPageMode && !isCompleted) {
        window.history.pushState(null, '', window.location.href);
      }
    };

    // Push initial state to trap back button
    if (isActive) {
      window.history.pushState(null, '', window.location.href);
    }

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isFullPageMode, isCompleted, assessmentStartTime, currentAssessment]);

  // Additional support for mobile browsers (pagehide event)
  useEffect(() => {
    const handlePageHide = () => {
      if (isFullPageMode && !isCompleted) {
        const timeElapsed = assessmentStartTime
          ? Math.floor((new Date() - assessmentStartTime) / 1000)
          : (totalDurationSeconds - timeLeft);

        trackAssessmentDroppedOff(
          timeElapsed,
          currentAssessment?.assessment_assigned_id,
          currentAssessment?.type,
          currentAssessment?.isCorporate,
          currentAssessment?.entityName
        );
      }
    };

    window.addEventListener('pagehide', handlePageHide);

    return () => {
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, [isFullPageMode, isCompleted, assessmentStartTime, currentAssessment]);


  // Response handling with proper state synchronization
  useEffect(() => {
    if (currentAssessment?.responses) {
      setLocalResponses(currentAssessment.responses)
    }
  }, [currentAssessment?.responses])
  useEffect(() => {
    if (currentSection.type === 'Email Writing' && !emailWritingTimerActive && !visitedSections.includes(currentPage)) {
      // Start timer immediately when entering this section for the first time
      setEmailWritingTimerActive(true)
    }
  }, [currentSection.type, currentPage, emailWritingTimerActive, visitedSections])

  // Add useEffect to start Sentence Completion timer when entering a new question
  useEffect(() => {
    if (currentSection.type === 'Sentence Completion') {
      const questions = currentSection.questions || []
      const currentQ = questions[sentenceCompletionCurrentIndex]

      if (currentQ) {
        // Check if this is a new question that hasn't been visited
        const questionKey = `${currentPage}-${currentQ.id}`
        const isNewQuestion = !visitedQuestions[questionKey]

        if (isNewQuestion && !sentenceCompletionTimerActive) {
          // Start timer for new question
          setSentenceCompletionTimerActive(true)
          setSentenceCompletionTimer(25) // Reset to full time
        }
      }
    }
  }, [currentSection.type, sentenceCompletionCurrentIndex, currentPage, sentenceCompletionTimerActive, visitedQuestions])

  // Add useEffect to start Sentence Build timer when entering a new question
  useEffect(() => {
    if (currentSection.type === 'Sentence Build') {
      const questions = currentSection.questions || [];
      const currentQ = questions[sentenceBuildCurrentIndex];
      if (currentQ) {
        const questionKey = `${currentPage}-${currentQ.id}`;

        // CRITICAL: Check if timer is permanently locked
        if (sentenceBuildTimerLockedRef.current[questionKey]) {
          console.log('⏱️ Timer is LOCKED for question:', questionKey);
          setSentenceBuildTimer(0);
          setSentenceBuildTimerActive(false);
          return; // EXIT EARLY - don't restart timer
        }

        const isVisited = visitedQuestions[questionKey];

        // Only start timer if NOT visited and NOT already active
        if (!isVisited && !sentenceBuildTimerActive) {
          setSentenceBuildTimerActive(true);
          setSentenceBuildTimer(180);
          console.log('▶️ Starting fresh timer for question:', questionKey);
        }
      }
    }
  }, [currentSection.type, sentenceBuildCurrentIndex, currentPage, sentenceBuildTimerActive, visitedQuestions]);


  const handleOptionSelect = async (
    questionId,
    subQuestionId,
    selectedOption
  ) => {
    //console.log("Saving response:", { questionId, subQuestionId, selectedOption })

    const assessmentId =
      currentAssessment?.assessment_assigned_id ||
      assessment?.assessment_assigned_id ||
      location.state?.assessmentData?.assessment_assigned_id

    if (!assessmentId) {
      console.error('No assessment_assigned_id found for saving response')
      return
    }
    const sectionType =
      currentSection.type === 'Paragraph Reading'
        ? 'paragraphReading'
        : 'audioQuestion'

    if (!localResponses[sectionType]) {
      // trackQuestionViewed removed (high-frequency event)
    } else {
      let questionEntry = localResponses[sectionType].find(
        q => q.questionId === questionId
      )
      if (!questionEntry) {
        // trackQuestionViewed removed (high-frequency event)
        trackQuestionAnswered(
          currentAssessment.assessment_assigned_id,
          currentAssessment.type,
          questionId, sectionType, selectedOption, null, currentAssessment.isCorporate, currentAssessment.entityName);
      } else {
        // trackAnswerChanged removed (high-frequency event)
      }
    }



    setLocalResponses(prev => {
      const sectionType =
        currentSection.type === 'Paragraph Reading'
          ? 'paragraphReading'
          : 'audioQuestion'

      const newState = JSON.parse(JSON.stringify(prev))

      if (!newState[sectionType]) {
        newState[sectionType] = []
      }

      let questionEntry = newState[sectionType].find(
        q => q.questionId === questionId
      )

      if (!questionEntry) {
        questionEntry = {
          questionId,
          responses: [],
        }
        newState[sectionType].push(questionEntry)
      }

      const responseIndex = questionEntry.responses.findIndex(
        r => r.subQuestionId === subQuestionId
      )

      if (responseIndex >= 0) {
        questionEntry.responses[responseIndex].selectedOption = selectedOption
      } else {
        questionEntry.responses.push({
          subQuestionId,
          selectedOption,
        })
      }

      return newState
    })

    try {
      await dispatch(
        saveQuestionResponse(
          questionId,
          selectedOption,
          assessmentId,
          subQuestionId,
          currentSection.type === 'Paragraph Reading'
            ? 'paragraphReading'
            : 'audioQuestion'
        )
      )
      //console.log("Response saved successfully to database")
    } catch (error) {
      console.error('Error saving response to database:', error)
    }
  }


  useEffect(() => {
    if (currentSection.type === 'Question Based Response' && !questionBasedTimerActive && !visitedSections.includes(currentPage)) {
      // Start timer immediately when entering this section for the first time
      setQuestionBasedTimerActive(true)
    }
  }, [currentSection.type, currentPage, questionBasedTimerActive, visitedSections])

  // Also add useEffect to start Image Response timer  
  useEffect(() => {
    if (currentSection.type === 'Question Based Response' && !imageResponseTimerActive && !visitedSections.includes(currentPage)) {
      // Start image response timer immediately when entering this section for the first time
      setImageResponseTimerActive(true)
    }
  }, [currentSection.type, currentPage, imageResponseTimerActive, visitedSections])


  useEffect(() => {
    if (currentSection.type === 'Paragraph Reading' && paragraphQuestionsTimerActive && !paragraphQuestionsTimeUp) {
      paragraphQuestionsTimerRef.current = setInterval(() => {
        setParagraphQuestionsTimer(prev => {
          if (prev <= 1) {
            setParagraphQuestionsTimeUp(true)
            setParagraphQuestionsTimerActive(false)
            // Auto-move to next section after 1 second delay
            violationSubmitTimerRef.current = setTimeout(() => {
              if (currentPage < questions.length - 1) {
                setCurrentPage(currentPage + 1)
              }
            }, 1000)
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => {
        if (paragraphQuestionsTimerRef.current) {
          clearInterval(paragraphQuestionsTimerRef.current)
        }
      }
    }
  }, [currentSection.type, paragraphQuestionsTimerActive, paragraphQuestionsTimeUp, currentPage, questions.length])
  useEffect(() => {
    if (currentSection.type === 'Audio Question' && audioQuestionsTimerActive && !audioQuestionsTimeUp) {
      audioQuestionsTimerRef.current = setInterval(() => {
        setAudioQuestionsTimer(prev => {
          if (prev <= 1) {
            setAudioQuestionsTimeUp(true)
            setAudioQuestionsTimerActive(false)
            // Auto-move to next section after 1 second delay
            violationSubmitTimerRef.current = setTimeout(() => {
              if (currentPage < questions.length - 1) {
                setCurrentPage(currentPage + 1)
              }
            }, 1000)
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => {
        if (audioQuestionsTimerRef.current) {
          clearInterval(audioQuestionsTimerRef.current)
        }
      }
    }
  }, [currentSection.type, audioQuestionsTimerActive, audioQuestionsTimeUp, currentPage, questions.length])

  useEffect(() => {
    let interval = null;

    if (currentSection.type === 'Question Based Response' && questionBasedTimerActive && !questionBasedTimeUp) {
      interval = setInterval(() => {
        setQuestionBasedTimer(prev => {
          if (prev <= 1) {
            setQuestionBasedTimeUp(true);
            setQuestionBasedTimerActive(false);

            // Auto-move to next section after timer ends
            setTimeout(() => {
              if (currentPage < questions.length - 1) {
                setCurrentPage(currentPage + 1);
              }
            }, 1000);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [
    currentSection.type,
    questionBasedTimerActive,
    questionBasedTimeUp
    // REMOVED: questionBasedResponse, currentAssessment, assessment, dispatch, currentSection.questionId
    // These cause re-renders and timer freezing
  ]);

  useEffect(() => {
    if (questionBasedTimeUp) {
      const assessmentId = currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id;
      if (assessmentId) {
        try {
          // Use "not attempted" if there's no response
          const responseText = questionBasedResponse.trim() || "not attempted";

          // FIXED: Ensure we're saving with the correct structure
          dispatch(saveQuestionResponse(
            currentSection.questionId,
            responseText,
            assessmentId,
            null, // No subQuestionId
            'questionBasedResponse' // Correct section type
          ));
          console.log('Question Based Response saved on timer expiry');
        } catch (error) {
          console.log('Redux error ignored - question based response saved successfully');
        }
      }
    }
  }, [questionBasedTimeUp]);

  useEffect(() => {
    if (imageResponseTimeUp) {
      const assessmentId = currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id;
      if (assessmentId) {
        try {
          // Use "not attempted" if there's no response
          const responseText = questionBasedResponse.trim() || "not attempted";
          dispatch(saveQuestionResponse(
            currentSection.questionId,
            responseText,
            assessmentId,
            null,
            'questionBasedResponse'
          ));
          console.log('Image Response saved on timer expiry');
        } catch (error) {
          console.log('Redux error ignored - image response saved successfully');
        }
      }
    }
  }, [imageResponseTimeUp]);

  useEffect(() => {
    if (emailWritingTimeUp) {
      const assessmentId = currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id;
      if (assessmentId) {
        try {
          // Use "not attempted" if there's no response
          const emailContent = emailWritingResponse.trim();
          const responseText = emailContent ?
            `Subject: ${emailData.subject}\n${emailContent}` :
            "not attempted";

          dispatch(saveQuestionResponse(
            currentSection.questionId,
            responseText,
            assessmentId,
            null,
            'emailWriting'
          ));
          console.log('Email Writing response saved on timer expiry');
        } catch (error) {
          console.log('Redux error ignored - email writing response saved successfully');
        }
      }
    }
  }, [emailWritingTimeUp]);
  // Fix Image Response timer useEffect (around line 480)
  useEffect(() => {
    let interval = null;

    if (currentSection.type === 'Question Based Response' && imageResponseTimerActive && !imageResponseTimeUp) {
      interval = setInterval(() => {
        setImageResponseTimer(prev => {
          if (prev <= 1) {
            setImageResponseTimeUp(true);
            setImageResponseTimerActive(false);

            // Auto-move to next section after timer ends
            setTimeout(() => {
              if (currentPage < questions.length - 1) {
                setCurrentPage(currentPage + 1);
              }
            }, 1000);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [
    currentSection.type,
    imageResponseTimerActive,
    imageResponseTimeUp
    // REMOVED: questionBasedResponse, currentAssessment, assessment, dispatch, currentSection.questionId
  ]);

  useEffect(() => {
    let interval = null;

    if (currentSection.type === 'Email Writing' && emailWritingTimerActive && !emailWritingTimeUp) {
      interval = setInterval(() => {
        setEmailWritingTimer(prev => {
          if (prev <= 1) {
            setEmailWritingTimeUp(true);
            setEmailWritingTimerActive(false);

            // Auto-move to next section after timer ends
            setTimeout(() => {
              if (currentPage < questions.length - 1) {
                setCurrentPage(currentPage + 1);
              }
            }, 1000);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [
    currentSection.type,
    emailWritingTimerActive,
    emailWritingTimeUp
    // REMOVED: emailWritingResponse, emailData.subject, currentAssessment, assessment, dispatch, currentSection.questionId
  ]);
  useEffect(() => {
    if (currentSection.type === 'Sentence Completion' && sentenceCompletionTimerActive && sentenceCompletionTimer > 0) {
      // Clear any existing timer first
      if (sentenceCompletionTimerRef.current) {
        clearInterval(sentenceCompletionTimerRef.current)
      }

      sentenceCompletionTimerRef.current = setInterval(() => {
        setSentenceCompletionTimer(prev => {
          if (prev <= 1) {
            clearInterval(sentenceCompletionTimerRef.current)
            setSentenceCompletionTimerActive(false)

            // Save current sentence completion answer before moving to next
            const currentQ = currentSection.questions[sentenceCompletionCurrentIndex];
            const assessmentId = currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id;
            if (currentQ && assessmentId) {
              try {
                // Use "not attempted" if there's no response
                const answer = sentenceCompletionAnswers[currentQ.id]?.trim() || "not attempted";
                dispatch(saveQuestionResponse(
                  currentSection.questionId,
                  answer,
                  assessmentId,
                  currentQ.id,
                  'sentenceCompletion'
                ));
              } catch (error) {
                // Ignore Redux middleware error - response is still saved
                console.log('Redux error ignored - response saved successfully');
              }
            }
            // **Mark this question as visited, even if answer is empty**
            if (currentQ) {
              setVisitedQuestions(prev => ({
                ...prev,
                [`${currentPage}-${currentQ.id}`]: true
              }));
            }

            // Auto-move to next question after timer ends
            setTimeout(() => {
              const questions = currentSection.questions || []
              if (sentenceCompletionCurrentIndex < questions.length - 1) {
                setSentenceCompletionCurrentIndex(sentenceCompletionCurrentIndex + 1)
                // Timer will restart automatically via the other useEffect
              }
            }, 500)
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => {
        if (sentenceCompletionTimerRef.current) {
          clearInterval(sentenceCompletionTimerRef.current)
        }
      }
    }
  }, [currentSection.type, sentenceCompletionTimerActive, sentenceCompletionTimer, sentenceCompletionCurrentIndex, currentPage])
  // Fix Sentence Build timer useEffect (around line 610)
  useEffect(() => {
    if (currentSection.type === 'Sentence Build' && sentenceBuildTimerActive && sentenceBuildTimer > 0) {
      // Clear any existing timer first
      if (sentenceBuildTimerRef.current) {
        clearInterval(sentenceBuildTimerRef.current)
      }

      sentenceBuildTimerRef.current = setInterval(() => {
        setSentenceBuildTimer(prev => {
          if (prev <= 1) {
            clearInterval(sentenceBuildTimerRef.current)
            setSentenceBuildTimerActive(false)

            // Save current sentence build answer before moving to next
            // Save current sentence build answer before moving to next
            const sentenceBuildQuestions = currentSection.questions || [];
            const currentQ = sentenceBuildQuestions[sentenceBuildCurrentIndex];
            if (currentQ) {
              let arrangedContent = '';
              let hasUserInteracted = false;

              if (currentQ.type === 'unknown' || currentQ.type === 'word_arrangement') {
                // Check if user has interacted with the word arrangement
                const userSelectedWords = selectedWords[sentenceBuildCurrentIndex];
                if (userSelectedWords && userSelectedWords.length > 0) {
                  hasUserInteracted = true;
                  arrangedContent = getArrangedSentenceFromIndices(sentenceBuildCurrentIndex, userSelectedWords);
                }
              } else if (currentQ.type === 'sentence_rearrangement') {
                // Check if user has interacted with the sentence rearrangement
                const userParagraphOrder = paragraphOrder[sentenceBuildCurrentIndex];
                const hasInteracted = userInteractedWithParagraph[`${currentPage}-${currentQ.id}`];
                if (userParagraphOrder && userParagraphOrder.length > 0 && hasInteracted) {
                  hasUserInteracted = true;
                  arrangedContent = getArrangedSentenceFromIndices(sentenceBuildCurrentIndex, userParagraphOrder);
                }
              }

              const assessmentId = currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id;
              if (assessmentId) {
                // FIXED: Wrap in try-catch to ignore Redux error
                try {
                  // Use "not attempted" if user hasn't interacted with the drag and drop
                  const responseText = hasUserInteracted ? arrangedContent.trim() : "not attempted";

                  dispatch(saveQuestionResponse(
                    currentSection.questionId,
                    responseText,
                    assessmentId,
                    currentQ.id,
                    'sentenceBuild'
                  ));
                  console.log(hasUserInteracted ? 'Sentence Build response saved on timer expiry' : 'Not attempted response saved for Sentence Build');

                  // If this is a sentence rearrangement question, submit the assessment immediately
                  if (currentQ.type === 'sentence_rearrangement') {
                    console.log('Sentence rearrangement timer expired - submitting assessment');
                    // Add a small delay to ensure the response is saved first
                    setTimeout(() => {
                      handleSubmit();
                    }, 500);
                    return 0;
                  }

                  const isLastSection = currentPage === questions.length - 1;
                  const isLastQuestion = sentenceBuildCurrentIndex === sentenceBuildQuestions.length - 1;
                  if (isLastSection && isLastQuestion) {
                    console.log('Last question timer expired - submitting assessment');
                    // Add a small delay to ensure the response is saved first
                    setTimeout(() => {
                      handleSubmit();
                    }, 500);
                    return 0;
                  }
                } catch (error) {
                  // Ignore Redux middleware error - response is still saved
                  console.log('Redux error ignored - sentence build response saved successfully');
                }
              }
            }

            // Auto-move to next question after timer ends (only for non-sentence-rearrangement questions)
            setTimeout(() => {
              const questions = currentSection.questions || []
              if (sentenceBuildCurrentIndex < questions.length - 1) {
                setSentenceBuildCurrentIndex(sentenceBuildCurrentIndex + 1)
                // Timer will restart automatically via the other useEffect
              }
            }, 500)
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => {
        if (sentenceBuildTimerRef.current) {
          clearInterval(sentenceBuildTimerRef.current)
        }
      }
    }
  }, [currentSection.type, sentenceBuildTimerActive, sentenceBuildTimer, sentenceBuildCurrentIndex, handleSubmit])

  // Fix Dictation timer useEffect (around line 650)
  useEffect(() => {
    if (currentSection.type === 'Dictation' && dictationTimerActive) {
      dictationTimerRef.current = setInterval(() => {
        setDictationTimer(prev => {
          if (prev <= 1) {
            clearInterval(dictationTimerRef.current)
            setDictationTimerActive(false)

            // Save current dictation answer before moving to next (if present)
            const currentQ = currentSection.questions[dictationCurrentIndex];
            const assessmentId = currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id;
            if (currentQ && assessmentId) {
              // Use the latest answer from the ref!
              const latestAnswer = dictationAnswersRef.current[currentQ.id]?.trim() || "not attempted";
              try {
                dispatch(saveQuestionResponse(
                  currentSection.questionId,
                  latestAnswer,
                  assessmentId,
                  currentQ.id,
                  'dictation'
                ));
              } catch (error) {
                // Ignore Redux middleware error - response is still saved
                console.log('Redux error ignored - response saved successfully');
              }
            }
            // Mark this question as visited, even if answer is empty
            if (currentQ) {
              setVisitedQuestions(prev => ({
                ...prev,
                [`${currentPage}-${currentQ.id}`]: true
              }));
            }

            // Auto-move to next question after timer ends
            setTimeout(() => {
              if (dictationCurrentIndex < currentSection.questions.length - 1) {
                setDictationCurrentIndex(dictationCurrentIndex + 1)
                setDictationTimer(25)
                // Timer will start automatically via the other useEffect
              }
            }, 500)
            return 0
          }
          return prev - 1
        })
      }, 1000)
      return () => {
        if (dictationTimerRef.current) clearInterval(dictationTimerRef.current)
      }
    }
  }, [currentSection.type, dictationTimerActive, dictationCurrentIndex, currentPage])

  // Count words function
  const countWords = (text) => {
    return text.trim().split(/\s+/).filter(word => word.length > 0).length
  }
  const renderQuestionType = () => {
    switch (currentSection.type) {
      case 'Video Response':
        return renderVideoSection()

      case 'Question Based Response':
        return renderQuestionBasedResponse()

      case 'Email Writing':
        return renderEmailWriting()

      case 'Dictation':
        return renderDictation()

      case 'Sentence Completion':
        return renderSentenceCompletion()

      case 'Sentence Build':
        return renderSentenceBuild()

      case 'Paragraph Reading':
      case 'Audio Question':
      default:
        return renderDefaultSection()
    }
  }

  const renderDefaultSection = () => {
    const shouldShowAudioQuestions =
      currentSection.type === 'Audio Question' &&
      completedAudioSections.includes(currentSection.questionId) &&
      !showAudioCompleteModal &&
      !audioReplayRequested;
    return (
      <Section>
        {currentSection.type === 'Audio Question' &&
          currentSection.paragraph && (
            <>
              <div>
                <InfoContainer>
                  <InfoIcon style={{ fontSize: '16px', marginRight: '8px' }}>
                    i
                  </InfoIcon>
                  <InfoText>
                    Listen to the audio clip carefully and answer the
                    questions based on it.
                  </InfoText>
                </InfoContainer>

                <InfoContainer>
                  <div
                    style={{
                      marginTop: '20px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      width: '80%',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '14px',
                        fontWeight: '500',
                        marginBottom: '8px',
                        alignSelf: 'flex-start',
                      }}
                    >
                      <strong>Play the audio clip when ready</strong>
                    </div>
                    <div style={{ width: '100%' }}>
                      <AudioPlayer
                        ref={audioPlayerRef}
                        url={currentSection.audioUrl}
                        onAudioComplete={() => {
                          // Increment play count for this question
                          setAudioPlayCount(prev => ({
                            ...prev,
                            [currentSection.questionId]: (prev[currentSection.questionId] || 0) + 1
                          }));

                          // If first play, show modal; if second play, auto-continue to questions
                          const count = (audioPlayCount[currentSection.questionId] || 0) + 1;
                          if (count === 1) {
                            setCompletedAudioSections(prev => [...prev, currentSection.questionId]);
                            setShowAudioCompleteModal(true);
                          } else if (count === 2) {
                            setCompletedAudioSections(prev => [...prev, currentSection.questionId]);
                            setShowAudioCompleteModal(false);
                            setAudioReplayRequested(false);
                            setAudioQuestionsTimerActive(true); // Auto-start questions timer
                          }
                        }}
                        isAlreadyCompleted={completedAudioSections.includes(currentSection.questionId)}
                        initialPosition={audioPositions[currentSection.questionId] || 0}
                        onTimeUpdate={time => {
                          setAudioPositions({
                            ...audioPositions,
                            [currentSection.questionId]: time,
                          })
                        }}
                        showHeader={false}
                        alignLeft={true}
                        allowReplay={
                          (audioPlayCount[currentSection.questionId] || 0) < 2 &&
                          (showAudioCompleteModal || audioReplayRequested)
                        }
                        disabled={
                          (audioPlayCount[currentSection.questionId] || 0) >= 2
                            ? true
                            : audioReplayRequested
                              ? false
                              : completedAudioSections.includes(currentSection.questionId)
                        }
                      />

                      {showAudioCompleteModal && (
                        <ModalOverlay>
                          <ModalContent>
                            <ModalText>
                              Audio Completed. What would you like to do?
                            </ModalText>
                            <div
                              style={{
                                display: 'flex',
                                gap: '10px',
                                marginTop: '20px',
                                justifyContent: 'center', // Center the buttons horizontally
                                width: '100%',            // Ensure full width for centering
                              }}
                            >
                              <StyledButton onClick={handleAudioContinue}>Continue to Questions</StyledButton>
                              <StyledButton
                                variant="primary"
                                onClick={() => {
                                  if ((audioPlayCount[currentSection.questionId] || 0) < 2) {
                                    setShowAudioCompleteModal(false);
                                    setAudioReplayRequested(true);

                                    // REMOVE ALL DOM PATCHING BELOW!
                                    setTimeout(async () => {
                                      if (audioPlayerRef.current && typeof audioPlayerRef.current.play === 'function') {
                                        await audioPlayerRef.current.play().catch(e => console.error('AudioRef play failed', e))
                                        setAudioIsPlaying(true)
                                      }
                                    }, 50)
                                  }
                                }}
                                disabled={(audioPlayCount[currentSection.questionId] || 0) >= 2}
                              >
                                Listen to Audio Again
                              </StyledButton>
                            </div>
                          </ModalContent>
                        </ModalOverlay>
                      )}
                    </div>
                  </div>
                </InfoContainer>
              </div>
            </>
          )}

        {currentSection.type !== 'Audio Question' &&
          currentSection.type !== 'Paragraph Reading' &&
          currentSection.type !== 'Video Response' &&
          currentSection.paragraph && (
            <Paragraph>
              {formatParagraphWithSpacing(currentSection.paragraph).map(
                (para, index) => (
                  <React.Fragment key={index}>
                    {para}
                    {index <
                      formatParagraphWithSpacing(currentSection.paragraph)
                        .length -
                      1 && <div style={{ margin: '1rem 0' }}></div>}
                  </React.Fragment>
                )
              )}
            </Paragraph>
          )}
        {currentSection.type === 'Paragraph Reading' && (
          <>
            <InfoContainer style={{ marginLeft: '47px' }}>
              <InfoIcon style={{ fontSize: '16px', marginRight: '8px' }}>
                i
              </InfoIcon>
              <InfoText>

                Read the paragraph aloud and then answer the questions
              </InfoText>
            </InfoContainer>



            <StepContainer>
              <StepItem>
                <StepNumber
                  active={!audioBlob && !audioRecording}
                  completed={audioRecording || audioBlob}
                >
                  1
                </StepNumber>
                <StepContent>
                  <StepText>Hit record when ready</StepText>
                  {!audioBlob && !audioRecording && (
                    <ParagraphRecordButton onClick={startAudioRecording}>
                      Record
                      <WhiteRecordIcon />
                    </ParagraphRecordButton>
                  )}
                </StepContent>
              </StepItem>

              <StepItem>
                <StepNumber active={audioRecording} completed={audioBlob}>
                  2
                </StepNumber>
                <StepContent>
                  <StepText>
                    Read the given paragraph aloud and clear
                  </StepText>
                </StepContent>
              </StepItem>

              <ParagraphBox
                style={{
                  marginLeft: '47px',
                  display: paragraphReadingComplete ? 'none' : 'block',
                  marginBottom: '0px',
                }}
              >
                {!audioRecording && !audioBlob && (
                  <BlurredParagraphOverlay>
                    <BlurredParagraphText>
                      Paragraph will be shown once recording starts
                    </BlurredParagraphText>
                  </BlurredParagraphOverlay>
                )}

                <div
                  className={
                    !audioRecording && !audioBlob ? 'blurred-content' : ''
                  }
                >
                  {formatParagraphIntoSentenceGroups(
                    currentSection.paragraph
                  ).map((para, index) => (
                    <React.Fragment key={index}>
                      <p
                        style={{
                          margin: '0 0 1.5rem 0',
                          lineHeight: '1.6',
                          textAlign: 'justify',
                        }}
                      >
                        {para}
                      </p>
                    </React.Fragment>
                  ))}
                </div>

                {audioRecording && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '20px',
                      gap: '12px',
                      alignItems: 'center'
                    }}
                  >
                    <StopRecordingButton onClick={stopAudioRecording}>
                      <TimerDisplay>
                        {formatRecordingTime(PARAGRAPH_READING_MAX_TIME - Math.floor(audioRecordingDuration))}
                      </TimerDisplay>
                      Stop recording
                      <StopRecordIcon />
                    </StopRecordingButton>
                  </div>
                )}
              </ParagraphBox>

              {audioBlob && (
                <SectionContentBox>
                  <AudioContainer
                    style={{
                      marginTop: '20px',
                      marginBottom: '20px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <RecordingSuccessMessage
                      style={{
                        marginTop: '15px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <DoubleTick />
                      <span style={{ marginLeft: '8px', fontSize: '16px' }}>
                        Your audio was recorded successfully
                      </span>
                    </RecordingSuccessMessage>

                    <GreenInfoContainer
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        marginTop: '16px',
                        marginLeft: '47px',
                        width: 'calc(100% - 55px)',
                        marginBottom: 0,
                      }}
                    >
                      {paragraphReadingComplete ? (
                        <span>
                          Time's up! Continue to the questions below.
                        </span>
                      ) : (
                        <>
                          Take{' '}
                          <strong style={{ margin: '0 5px' }}>
                            {silentReadingTime} seconds
                          </strong>{' '}
                          to read the paragraph silently
                        </>
                      )}
                    </GreenInfoContainer>
                  </AudioContainer>
                </SectionContentBox>
              )}

              <StepItem style={{ marginTop: '30px' }}>
                <StepNumber active={audioBlob}>3</StepNumber>
                <StepContent>
                  <StepText>Answer the following questions.<strong>You get 90 seconds to answer.</strong></StepText>
                </StepContent>
              </StepItem>
            </StepContainer>
          </>
        )}

        {/* Move timer to be inline with question instruction */}
        {currentSection.type === 'Paragraph Reading' && audioBlob && (
          <div style={{
            display: paragraphReadingComplete ? 'block' : 'none',
            margin: '0 0 16px 0'
          }}>
            <QuestionInstruction style={{ margin: '0 0 16px 0' }}>
              Select the right answer from the questions below:
            </QuestionInstruction>

            <GreenInfoContainer
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                marginTop: '0',
                marginLeft: '0',
                width: '100%',
                marginBottom: '16px',
              }}
            >
              {(paragraphQuestionsTimeUp || (visitedSections.includes(currentPage) && paragraphQuestionsTimer < 60))
                ? "Time's up! Continue to next section."
                : <>You have <strong style={{ margin: '0 5px' }}>{paragraphQuestionsTimer} seconds</strong> to answer these questions</>}
            </GreenInfoContainer>
          </div>
        )}

        {currentSection.type === 'Audio Question' &&
          completedAudioSections.includes(currentSection.questionId) &&
          !showAudioCompleteModal &&
          !audioReplayRequested && (
            <div style={{
              display: 'block',
              margin: '0 0 16px 0'
            }}>
              <QuestionInstruction style={{ margin: '0 0 16px 0' }}>
                Select the right answer from the questions below:
              </QuestionInstruction>

              <GreenInfoContainer
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  marginTop: '0',
                  marginLeft: '0',
                  width: '100%',
                  marginBottom: '16px',
                }}
              >
                {(audioQuestionsTimeUp || (visitedSections.includes(currentPage) && audioQuestionsTimer < 120))
                  ? "Time's up! Continue to next section."
                  : <>You have <strong style={{ margin: '0 5px' }}>{audioQuestionsTimer} seconds</strong> to answer these questions</>}
              </GreenInfoContainer>
            </div>
          )}

        {currentSection.type === 'Audio Question' &&
          (!shouldShowAudioQuestions) &&
          currentSection.questions.length > 0 && (
            <QuestionsPlaceholder>
              <InfoIcon style={{ fontSize: '16px', marginRight: '8px' }}>
                i
              </InfoIcon>
              Questions will appear here after you complete listening to the audio
            </QuestionsPlaceholder>
          )
        }

        {currentSection.type === 'Paragraph Reading' &&
          !paragraphReadingComplete && (
            <QuestionsPlaceholder style={{ marginLeft: '47px' }}>
              <InfoIcon style={{ fontSize: '16px', marginRight: '8px' }}>
                i
              </InfoIcon>
              Questions will appear here after the reading time completes
            </QuestionsPlaceholder>
          )}



        {(
          (currentSection.type === 'Audio Question' && shouldShowAudioQuestions) ||
          (currentSection.type === 'Paragraph Reading' && paragraphReadingComplete && audioBlob)
        ) && currentSection.questions?.map((question, questionIndex) => {
          const isDisabled =
            (currentSection.type === 'Paragraph Reading' && !audioBlob) ||
            (currentSection.type === 'Paragraph Reading' && !paragraphReadingComplete) ||
            (currentSection.type === 'Paragraph Reading' && paragraphQuestionsTimeUp) ||
            (currentSection.type === 'Paragraph Reading' && isReviewMode()) ||
            (currentSection.type === 'Audio Question' && !completedAudioSections.includes(currentSection.questionId)) ||
            (currentSection.type === 'Audio Question' && audioQuestionsTimeUp) ||
            (currentSection.type === 'Audio Question' && isReviewMode())

          const QuestionComponent = isDisabled ? DisabledQuestion : Question

          // Don't show questions for Audio Question until audio is completed
          if (
            currentSection.type === 'Audio Question' &&
            !completedAudioSections.includes(currentSection.questionId)
          ) {
            return null
          }

          // Don't show questions for Paragraph Reading until conditions are met
          if (
            currentSection.type === 'Paragraph Reading' &&
            (!audioBlob || !paragraphReadingComplete)
          ) {
            return null
          }

          return (
            <QuestionComponent key={questionIndex}>
              <QuestionText style={{ textAlign: 'left' }}>
                {question.question}
              </QuestionText>
              {question.options && (
                <Options>
                  {question.options.map((option, optionIndex) => (
                    <Option key={optionIndex}>
                      <input
                        type="radio"
                        name={`question-${currentPage}-${questionIndex}`}
                        value={option}
                        onChange={() => {
                          // Prevent changes in review mode
                          if (isReviewMode()) return

                          // Start timer on first answer selection for Paragraph Reading
                          if (currentSection.type === 'Paragraph Reading' &&
                            !paragraphQuestionsTimerActive &&
                            !paragraphQuestionsTimeUp) {
                            setParagraphQuestionsTimerActive(true)
                          }

                          // Start timer on first answer selection for Audio Question
                          if (currentSection.type === 'Audio Question' &&
                            !audioQuestionsTimerActive &&
                            !audioQuestionsTimeUp &&
                            completedAudioSections.includes(currentSection.questionId)) {
                            setAudioQuestionsTimerActive(true)
                          }

                          handleOptionSelect(
                            currentSection.questionId,
                            question.id,
                            option
                          )
                        }}
                        disabled={isDisabled || isReviewMode()}
                        checked={
                          getResponseValue(
                            currentSection.questionId,
                            question.id
                          ) === option
                        }
                      />
                      <span style={{
                        color: isReviewMode() ? '#6b7280' : 'inherit',
                        cursor: isReviewMode() ? 'not-allowed' : 'pointer'
                      }}>
                        {option}
                      </span>
                    </Option>
                  ))}
                </Options>
              )}
            </QuestionComponent>
          )
        })}
      </Section>
    )
  }

  const getResponseValue = (questionId, subQuestionId) => {
    const sectionType =
      currentSection.type === 'Paragraph Reading'
        ? 'paragraphReading'
        : 'audioQuestion'

    if (localResponses[sectionType]) {
      const questionEntry = localResponses[sectionType].find(
        q => q.questionId === questionId
      )
      if (questionEntry) {
        const response = questionEntry.responses.find(
          r => r.subQuestionId === subQuestionId
        )
        if (response) {
          return response.selectedOption
        }
      }
    }

    if (currentAssessment?.responses?.[sectionType]) {
      const questionEntry = currentAssessment.responses[sectionType].find(
        q => q.questionId === questionId
      )
      if (questionEntry) {
        const response = questionEntry.responses?.find(
          r => r.subQuestionId === subQuestionId
        )
        if (response) {
          return response.selectedOption
        }
      }
    }

    return null
  }
  useEffect(() => {
    if (currentSection.type === 'Dictation') {
      const questions = currentSection.questions || []
      const currentQ = questions[dictationCurrentIndex]
      if (currentQ) {
        // Reset timer state for new question
        setDictationTimerActive(false)
        setDictationTimer(25)

        // FIXED: Don't auto-start timer - let user play audio first
        // Only start timer if audio was already completed for this question
        if (dictationAudioCompleted[currentQ.audioUrl]) {
          setDictationTimerActive(true)
        }
      }
    }
  }, [dictationCurrentIndex, currentSection.type])
  const handleNext = async () => {
    // trackNextQuestion removed (high-frequency event)
    // First check if section is complete or in review mode
    if (!isCurrentSectionComplete()) {
      // Show a message based on the current section type
      let message = '';
      switch (currentSection.type) {
        case 'Video Response':
          message = 'Please record your video response before proceeding';
          break;
        case 'Paragraph Reading':
          message = audioBlob
            ? 'Please answer all questions before proceeding'
            : 'Please record your paragraph reading before proceeding';
          break;
        case 'Audio Question':
          message = 'Please answer all questions based on the audio before proceeding';
          break;
        case 'Question Based Response':
          message = 'Please write something before proceeding';
          break;
        case 'Email Writing':
          message = 'Please write something in your email response before proceeding';
          break;
        case 'Dictation':
          message = 'Please complete the current dictation sentence before proceeding';
          break;
        case 'Sentence Completion':
          message = 'Please fill in the blank for this sentence before proceeding';
          break;
        case 'Sentence Build':
          message = 'Please arrange the words correctly for this question before proceeding';
          break;
        default:
          message = 'Please complete this section before proceeding';
      }

      setErrorMessage(message);
      setShowError(true);

      setTimeout(() => {
        setShowError(false);
      }, 3000);

      return;
    }

    setShowError(false);

    const assessmentId = currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id;

    // Save current section response based on section type
    if (assessmentId) {
      // Save Question Based Response
      if (currentSection.type === 'Question Based Response' && questionBasedResponse.trim()) {
        try {
          if (!localResponses['questionBasedResponse']) {
            // trackAnswerChanged removed (high-frequency event)
          }

          trackQuestionAnswered(
            currentAssessment.assessment_assigned_id,
            currentAssessment.type,
            currentSection.questionId, currentSection.type, questionBasedResponse.trim(), null, currentAssessment.isCorporate, currentAssessment.entityName)

          dispatch(saveQuestionResponse(
            currentSection.questionId,
            questionBasedResponse.trim(),
            assessmentId,
            null,
            'questionBasedResponse'
          ));
        } catch (error) {
          console.log('Redux error ignored - response saved successfully');
        }
      }

      // ADDED: Save Email Writing Response
      else if (currentSection.type === 'Email Writing' && emailWritingResponse.trim()) {
        try {
          if (!localResponses['emailWriting']) {
            // trackAnswerChanged removed (high-frequency event)
          }

          trackQuestionAnswered(
            currentAssessment.assessment_assigned_id,
            currentAssessment.type,
            currentSection.questionId, currentSection.type, emailWritingResponse.trim(), null, currentAssessment.isCorporate, currentAssessment.entityName)

          dispatch(saveQuestionResponse(
            currentSection.questionId,
            `Subject: ${emailData.subject}\n${emailWritingResponse.trim()}`,
            assessmentId,
            null,
            'emailWriting'
          ));
        } catch (error) {
          console.log('Redux error ignored - response saved successfully');
        }
      }

      // Save Dictation Response
      else if (currentSection.type === 'Dictation') {
        const dictationQuestions = currentSection.questions || [];
        const currentQ = dictationQuestions[dictationCurrentIndex];
        if (currentQ && dictationAnswers[currentQ.id]?.trim()) {
          try {
            if (!localResponses['dictation']) {
              // trackAnswerChanged removed (high-frequency event)
            }

            trackQuestionAnswered(
              currentAssessment.assessment_assigned_id,
              currentAssessment.type,
              currentSection.questionId, currentSection.type, dictationAnswers[currentQ.id].trim(), null, currentAssessment.isCorporate, currentAssessment.entityName)

            dispatch(saveQuestionResponse(
              currentSection.questionId,
              dictationAnswers[currentQ.id].trim(),
              assessmentId,
              currentQ.id,
              'dictation'
            ));
          } catch (error) {
            console.log('Redux error ignored - response saved successfully');
          }
        }
      }

      // Save Sentence Completion Response for current question
      else if (currentSection.type === 'Sentence Completion') {
        const sentenceQuestions = currentSection.questions || [];
        const currentQ = sentenceQuestions[sentenceCompletionCurrentIndex];
        if (currentQ && sentenceCompletionAnswers[currentQ.id]?.trim()) {
          try {
            if (!localResponses['sentenceCompletion']) {
              // trackAnswerChanged removed (high-frequency event)
            }

            trackQuestionAnswered(
              currentAssessment.assessment_assigned_id,
              currentAssessment.type,
              currentSection.questionId, currentSection.type, sentenceCompletionAnswers[currentQ.id].trim(), null, currentAssessment.isCorporate, currentAssessment.entityName)

            dispatch(saveQuestionResponse(
              currentSection.questionId,
              sentenceCompletionAnswers[currentQ.id].trim(),
              assessmentId,
              currentQ.id,
              'sentenceCompletion'
            ));
          } catch (error) {
            console.log('Redux error ignored - response saved successfully');
          }
        }
      }

      // Save Sentence Build Response for current question
      else if (currentSection.type === 'Sentence Build') {
        const sentenceBuildQuestions = currentSection.questions || [];
        const currentQ = sentenceBuildQuestions[sentenceBuildCurrentIndex];
        if (currentQ) {
          let arrangedContent = '';
          let hasUserInteracted = false;

          if (currentQ.type === 'unknown' || currentQ.type === 'word_arrangement') {
            const userSelectedWords = selectedWords[sentenceBuildCurrentIndex];
            if (userSelectedWords && userSelectedWords.length > 0) {
              hasUserInteracted = true;
              arrangedContent = getArrangedSentenceFromIndices(sentenceBuildCurrentIndex, userSelectedWords);
            }
          } else if (currentQ.type === 'sentence_rearrangement') {
            const userParagraphOrder = paragraphOrder[sentenceBuildCurrentIndex];
            if (userParagraphOrder && userParagraphOrder.length > 0) {
              hasUserInteracted = true;
              arrangedContent = getArrangedSentenceFromIndices(sentenceBuildCurrentIndex, userParagraphOrder);
            }
          }

          if (assessmentId) {
            try {
              if (!localResponses['sentenceBuild']) {
                // trackAnswerChanged removed (high-frequency event)
              }

              trackQuestionAnswered(
                currentAssessment.assessment_assigned_id,
                currentAssessment.type,
                currentSection.questionId, currentSection.type, arrangedContent.trim(), null, currentAssessment.isCorporate, currentAssessment.entityName)

              const responseText = hasUserInteracted ? arrangedContent.trim() : "not attempted";

              dispatch(saveQuestionResponse(
                currentSection.questionId,
                responseText,
                assessmentId,
                currentQ.id,
                'sentenceBuild'
              ));
            } catch (error) {
              console.log('Redux error ignored - response saved successfully');
            }
          }
        }
      }
    }

    // Rest of the function remains the same...
    // Handle multi-question sections (Dictation, Sentence Completion, Sentence Build)
    if (currentSection.type === 'Dictation') {
      const dictationQuestions = currentSection.questions || []
      const currentQuestionId = dictationQuestions[dictationCurrentIndex]?.id
      if (currentQuestionId) {
        setVisitedQuestions(prev => ({
          ...prev,
          [`${currentPage}-${currentQuestionId}`]: true
        }))
      }
      if (dictationCurrentIndex < dictationQuestions.length - 1) {
        setDictationCurrentIndex(dictationCurrentIndex + 1)
        setDictationTimer(25)
        setDictationTimerActive(false)
        if (dictationTimerRef.current) {
          clearInterval(dictationTimerRef.current)
        }
        return
      }
      setDictationAudioCompleted({})
    }

    if (currentSection.type === 'Sentence Completion') {
      const sentenceCompletionQuestions = currentSection.questions || []
      const currentQuestionId = sentenceCompletionQuestions[sentenceCompletionCurrentIndex]?.id
      if (currentQuestionId) {
        setVisitedQuestions(prev => ({
          ...prev,
          [`${currentPage}-${currentQuestionId}`]: true
        }))
      }
      if (sentenceCompletionCurrentIndex < sentenceCompletionQuestions.length - 1) {
        setSentenceCompletionTimerActive(false)
        setSentenceCompletionTimer(25)
        if (sentenceCompletionTimerRef.current) {
          clearInterval(sentenceCompletionTimerRef.current)
          sentenceCompletionTimerRef.current = null
        }
        setSentenceCompletionCurrentIndex(sentenceCompletionCurrentIndex + 1)
        return
      }
    }

    if (currentSection.type === 'Sentence Build') {
      const sentenceBuildQuestions = currentSection.questions || [];
      const currentQuestionId = sentenceBuildQuestions[sentenceBuildCurrentIndex]?.id;
      if (currentQuestionId) {
        setVisitedQuestions(prev => ({
          ...prev,
          [`${currentPage}-${currentQuestionId}`]: true
        }));
      }
      if (sentenceBuildCurrentIndex < sentenceBuildQuestions.length - 1) {
        const nextQuestion = sentenceBuildQuestions[sentenceBuildCurrentIndex + 1];
        const nextKey = `${currentPage}-${nextQuestion?.id}`;
        const isNextVisited = visitedQuestions[nextKey];

        if (!isNextVisited) {
          setSentenceBuildTimerActive(false);
          setSentenceBuildTimer(180);
          if (sentenceBuildTimerRef.current) {
            clearInterval(sentenceBuildTimerRef.current);
            sentenceBuildTimerRef.current = null;
          }
        }
        setSentenceBuildCurrentIndex(sentenceBuildCurrentIndex + 1);
        return;
      }
    }

    // Clean up timers when leaving sections
    if (currentSection.type === 'Email Writing') {
      setEmailWritingTimerActive(false)
      if (emailWritingTimerActive || emailWritingTimer < 300) {
        setEmailWritingTimeUp(true)
      }
      setEmailWritingTimer(300)
      if (emailWritingTimerRef.current) {
        clearInterval(emailWritingTimerRef.current)
      }
    }

    if (currentSection.type === 'Paragraph Reading') {
      setParagraphQuestionsTimerActive(false)
      if (paragraphQuestionsTimerActive || paragraphQuestionsTimer < 60) {
        setParagraphQuestionsTimeUp(true)
      }
      setParagraphQuestionsTimer(60)
      if (paragraphQuestionsTimerRef.current) {
        clearInterval(paragraphQuestionsTimerRef.current)
      }
    }

    if (currentSection.type === 'Audio Question') {
      setAudioQuestionsTimerActive(false)
      if (audioQuestionsTimerActive || audioQuestionsTimer < 120) {
        setAudioQuestionsTimeUp(true)
      }
      setAudioQuestionsTimer(120)
      if (audioQuestionsTimerRef.current) {
        clearInterval(audioQuestionsTimerRef.current)
      }
    }

    if (currentSection.type === 'Question Based Response') {
      setImageResponseTimerActive(false)
      if (imageResponseTimerActive || imageResponseTimer < 240) {
        setImageResponseTimeUp(true)
      }
      setImageResponseTimer(240)
      if (imageResponseTimerRef.current) {
        clearInterval(imageResponseTimerRef.current)
      }
    }

    // ADDED: Upload video when leaving Video Response section
    if (currentSection.type === 'Video Response' && videoBlob) {
      const videoAlreadyUploaded = sessionStorage.getItem('assessment_video_uploaded') === 'true';

      if (!videoAlreadyUploaded) {
        console.log("🎥 [NEXT_VIDEO] Uploading video when leaving Video Response section");
        const videoResponseSection = questions.find(section => section.type === 'Video Response');
        const assessmentId = currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id;

        if (videoResponseSection && assessmentId) {
          // Fire-and-forget: backend stores in DB directly, no need to await
          dispatch(uploadVideoResponse(videoBlob, videoResponseSection.questionId, assessmentId));
          console.log("✅ [NEXT_VIDEO] Video upload dispatched (backend will store in DB)");
        } else {
          console.warn("⚠️ [NEXT_VIDEO] Missing videoResponseSection or assessmentId");
        }
      } else {
        console.log("✅ [NEXT_VIDEO] Video already uploaded, skipping");
      }
    }


    // ADDED: Upload audio when leaving Paragraph Reading section
    if (currentSection.type === 'Paragraph Reading' && audioBlob) {
      const audioAlreadyUploaded = sessionStorage.getItem('assessment_audio_uploaded') === 'true';

      if (!audioAlreadyUploaded) {
        console.log("🎵 [NEXT_AUDIO] Uploading audio when leaving Paragraph Reading section");
        const paragraphReadingSection = questions.find(section => section.type === 'Paragraph Reading');
        const assessmentId = currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id;

        if (paragraphReadingSection && assessmentId) {
          // Fire-and-forget: backend stores in DB directly, no need to await
          dispatch(uploadAudioResponse(audioBlob, paragraphReadingSection.questionId, assessmentId));
          console.log("✅ [NEXT_AUDIO] Audio upload dispatched (backend will store in DB)");
        } else {
          console.warn("⚠️ [NEXT_AUDIO] Missing paragraphReadingSection or assessmentId");
        }
      } else {
        console.log("✅ [NEXT_AUDIO] Audio already uploaded, skipping");
      }
    }


    if (currentSection.type === 'Sentence Completion') {
      setSentenceCompletionTimerActive(false)
      setSentenceCompletionTimer(25)
      if (sentenceCompletionTimerRef.current) {
        clearInterval(sentenceCompletionTimerRef.current)
        sentenceCompletionTimerRef.current = null
      }
    }


    // Mark current section as visited when leaving it
    if (!visitedSections.includes(currentPage)) {
      setVisitedSections(prev => [...prev, currentPage])
    }

    // Move to next section
    if (currentPage < questions.length - 1) {
      // trackSectionChanged removed (high-frequency event)
      setCurrentPage(currentPage + 1)

      // Reset question indices when entering new sections
      if (currentSection.type === 'Dictation') {
        setDictationCurrentIndex(0)
        setDictationTimer(25)
        setDictationTimerActive(false)
        if (dictationTimerRef.current) {
          clearInterval(dictationTimerRef.current)
        }
      }
      if (currentSection.type === 'Sentence Completion') {
        setSentenceCompletionCurrentIndex(0)
        setSentenceCompletionTimer(25)
        setSentenceCompletionTimerActive(false)
        if (sentenceCompletionTimerRef.current) {
          clearInterval(sentenceCompletionTimerRef.current)
          sentenceCompletionTimerRef.current = null
        }
      }
      if (currentSection.type === 'Sentence Build') {
        setSentenceBuildCurrentIndex(0)
        setSentenceBuildTimer(180)
        setSentenceBuildTimerActive(false)
        if (sentenceBuildTimerRef.current) {
          clearInterval(sentenceBuildTimerRef.current)
          sentenceBuildTimerRef.current = null
        }
      }
    }
  }

  const handlePrevious = () => {
    // Dictation navigation logic - check if we can go to previous question
    if (currentSection.type === 'Dictation') {
      // If not first dictation question, go to previous dictation question
      if (dictationCurrentIndex > 0) {
        const prevIndex = dictationCurrentIndex - 1
        const prevQuestion = currentSection.questions[prevIndex]

        setDictationCurrentIndex(prevIndex)
        setDictationTimer(25)
        setDictationTimerActive(false)

        // FIXED: Mark the previous question as visited when going back to it
        if (prevQuestion) {
          setVisitedQuestions(prev => ({
            ...prev,
            [`${currentPage}-${prevQuestion.id}`]: true
          }))
        }

        if (dictationTimerRef.current) {
          clearInterval(dictationTimerRef.current)
        }
        return // Do not move to previous section yet
      }
      // If first dictation question, move to previous section
    }

    // Sentence Completion navigation logic
    if (currentSection.type === 'Sentence Completion') {
      // If not first sentence completion question, go to previous question
      if (sentenceCompletionCurrentIndex > 0) {
        // FIXED: Clear timer and reset state immediately
        setSentenceCompletionTimerActive(false)
        setSentenceCompletionTimer(25)
        if (sentenceCompletionTimerRef.current) {
          clearInterval(sentenceCompletionTimerRef.current)
          sentenceCompletionTimerRef.current = null
        }

        // Mark the previous question as visited when going back to it
        const prevIndex = sentenceCompletionCurrentIndex - 1
        const prevQuestion = currentSection.questions[prevIndex]

        setSentenceCompletionCurrentIndex(prevIndex)

        if (prevQuestion) {
          setVisitedQuestions(prev => ({
            ...prev,
            [`${currentPage}-${prevQuestion.id}`]: true
          }))
        }

        return // Do not move to previous section yet
      }
      // If first question, move to previous section
    }

    // Sentence Build navigation logic
    if (currentSection.type === 'Sentence Build') {
      // If not first sentence build question, go to previous question
      if (sentenceBuildCurrentIndex > 0) {
        // Only reset timer if previous question is NOT visited
        const prevIndex = sentenceBuildCurrentIndex - 1
        const prevQuestion = currentSection.questions[prevIndex]
        const prevKey = `${currentPage}-${prevQuestion?.id}`
        if (!visitedQuestions[prevKey]) {
          setSentenceBuildTimerActive(false)
          setSentenceBuildTimer(180)
          if (sentenceBuildTimerRef.current) {
            clearInterval(sentenceBuildTimerRef.current)
            sentenceBuildTimerRef.current = null
          }
        }
        setSentenceBuildCurrentIndex(prevIndex)
        if (prevQuestion) {
          setVisitedQuestions(prev => ({
            ...prev,
            [`${currentPage}-${prevQuestion.id}`]: true
          }))
        }
        return // Do not move to previous section yet
      }
      // If first question, move to previous section
    }

    // Move to previous section
    if (currentPage > 0) {
      const newPage = currentPage - 1
      const previousSection = questions[newPage]

      setCurrentPage(newPage)

      // Set question indices to the last question of the previous section
      if (previousSection.type === 'Dictation') {
        const dictationQuestions = previousSection.questions || []
        const lastQuestionIndex = Math.max(0, dictationQuestions.length - 1)
        setDictationCurrentIndex(lastQuestionIndex)
        setDictationTimer(25)
        setDictationTimerActive(false)

        // FIXED: Mark the question we're going back to as visited
        const lastQuestion = dictationQuestions[lastQuestionIndex]
        if (lastQuestion) {
          setVisitedQuestions(prev => ({
            ...prev,
            [`${newPage}-${lastQuestion.id}`]: true
          }))
        }

        if (dictationTimerRef.current) {
          clearInterval(dictationTimerRef.current)
        }
      }
      if (previousSection.type === 'Sentence Completion') {
        const sentenceCompletionQuestions = previousSection.questions || []
        const lastQuestionIndex = Math.max(0, sentenceCompletionQuestions.length - 1)
        setSentenceCompletionCurrentIndex(lastQuestionIndex)

        // FIXED: Mark the question we're going back to as visited
        const lastQuestion = sentenceCompletionQuestions[lastQuestionIndex]
        if (lastQuestion) {
          setVisitedQuestions(prev => ({
            ...prev,
            [`${newPage}-${lastQuestion.id}`]: true
          }))
        }
      }
      if (previousSection.type === 'Sentence Build') {
        const sentenceBuildQuestions = previousSection.questions || []
        const lastQuestionIndex = Math.max(0, sentenceBuildQuestions.length - 1)
        setSentenceBuildCurrentIndex(lastQuestionIndex)
        setSentenceBuildTimer(180)
        setSentenceBuildTimerActive(false)

        // Mark the question we're going back to as visited
        const lastQuestion = sentenceBuildQuestions[lastQuestionIndex]
        if (lastQuestion) {
          setVisitedQuestions(prev => ({
            ...prev,
            [`${newPage}-${lastQuestion.id}`]: true
          }))
        }

        if (sentenceBuildTimerRef.current) {
          clearInterval(sentenceBuildTimerRef.current)
          sentenceBuildTimerRef.current = null
        }
      }
    }
  }





  // Update the review mode detection functions
  const isReviewMode = () => {
    return visitedSections.includes(currentPage)
  }


  const isCurrentSectionComplete = () => {
    switch (currentSection.type) {
      case 'Paragraph Reading':
        const hasAudio = audioBlob !== null
        const hasAnswers = currentSection.questions?.length > 0
          ? currentSection.questions.every(q => {
            const response = getResponseValue(currentSection.questionId, q.id)
            return response !== null && response !== undefined && response !== ''
          })
          : true // If no questions, just check audio
        return hasAudio && hasAnswers

      case 'Audio Question':
        return currentSection.questions?.every(q => {
          const response = getResponseValue(currentSection.questionId, q.id)
          return response !== null && response !== undefined && response !== ''
        })

      case 'Question Based Response':
        return questionBasedResponse.trim().length > 0

      case 'Email Writing':
        return emailWritingResponse.trim().length > 0;

      case 'Dictation': {
        const currentDictationQuestion = currentSection.questions?.[dictationCurrentIndex];
        return currentDictationQuestion &&
          dictationAnswers[currentDictationQuestion.id]?.trim().length > 0;
      }
      case 'Sentence Completion':
        const currentCompletionQuestion = currentSection.questions?.[sentenceCompletionCurrentIndex];
        return currentCompletionQuestion &&
          sentenceCompletionAnswers[currentCompletionQuestion.id]?.trim().length > 0;

      case 'Sentence Build':
        const currentBuildQuestion = currentSection.questions?.[sentenceBuildCurrentIndex];
        if (!currentBuildQuestion) return false;

        // Check if words have been arranged for current question
        if (currentBuildQuestion.type === 'unknown' || currentBuildQuestion.type === 'word_arrangement') {
          return selectedWords[sentenceBuildCurrentIndex] &&
            selectedWords[sentenceBuildCurrentIndex].length > 0;
        } else if (currentBuildQuestion.type === 'sentence_rearrangement') {
          return paragraphOrder[sentenceBuildCurrentIndex] &&
            paragraphOrder[sentenceBuildCurrentIndex].length > 0;
        }
        return false;

      case 'Video Response':
        return recordedVideo !== null

      default:
        return false;
    }
  }
  const isCurrentQuestionInReviewMode = () => {
    if (currentSection.type === 'Dictation') {
      const currentQuestion = currentSection.questions?.[dictationCurrentIndex]
      if (currentQuestion) {
        return visitedQuestions[`${currentPage}-${currentQuestion.id}`] === true
      }
    } else if (currentSection.type === 'Sentence Completion') {
      const currentQuestion = currentSection.questions?.[sentenceCompletionCurrentIndex]
      if (currentQuestion) {
        return visitedQuestions[`${currentPage}-${currentQuestion.id}`] === true
      }
    } else if (currentSection.type === 'Sentence Build') {
      const currentQuestion = currentSection.questions?.[sentenceBuildCurrentIndex]
      if (currentQuestion) {
        return visitedQuestions[`${currentPage}-${currentQuestion.id}`] === true
      }
    }

    // For other section types, use the section-level review mode
    return visitedSections.includes(currentPage)
  }


  const ViolationModal = ({ onSubmit }) => (
    <FullscreenModalOverlay>
      <FullscreenModalContent>
        <FullscreenTitle style={{ color: '#dc2626' }}>
          Assessment will be auto-submitted
        </FullscreenTitle>
        <FullscreenDescription>
          You&apos;ve violated the rules more than 3 times, so your assessment will be auto-submitted.
        </FullscreenDescription>
        <PrimaryButton
          onClick={onSubmit}
          style={{ background: '#dc2626', color: 'white' }}
        >
          Understood
        </PrimaryButton>
      </FullscreenModalContent>
    </FullscreenModalOverlay>
  )

  const FullscreenReentryModal = ({ onReturn, warningCount, lite = false }) => (
    <FullscreenModalOverlay>
      <FullscreenModalContent>
        <FullscreenTitle>Return to Assessment</FullscreenTitle>
        <FullscreenDescription>
          {lite
            ? 'You left the assessment. For security and proctoring purposes, please stay on this screen until you finish.'
            : 'You have exited the assessment mode. For security and proctoring purposes, you must return to full-page assessment mode to continue.'}
        </FullscreenDescription>
        <InfoContainer>
          <InfoIcon>!</InfoIcon>
          <InfoText>
            <strong>Warning {warningCount}/3:</strong> A fourth violation will result in automatic submission of your assessment
            and will be flagged as suspicious.
          </InfoText>
        </InfoContainer>
        <PrimaryButton onClick={onReturn}>
          {lite ? 'Resume Assessment' : 'Return to Assessment'}
        </PrimaryButton>
      </FullscreenModalContent>
    </FullscreenModalOverlay>
  )


  const renderQuestionBasedResponse = () => {
    const wordCount = countWords(questionBasedResponse)
    const charCount = questionBasedResponse.length
    const isTimeWarning = imageResponseTimer <= 60 && imageResponseTimerActive
    const isReviewMode = visitedSections.includes(currentPage)

    return (
      <Section>
        {/* Header with instructions */}
        <div style={{
          backgroundColor: '#f8f9fa',
          border: '1px solid #e9ecef',
          borderRadius: '8px',
          padding: '24px 32px',
          margin: '0 47px 24px 47px',
        }}>
          <div>
            <h3 style={{
              margin: '0 0 8px 0',
              fontSize: '16px',
              fontWeight: '600',
              color: '#374151'
            }}>
              Image Response
            </h3>
            <div style={{
              fontSize: '14px',
              color: '#6b7280',
              lineHeight: '1.7',
              marginBottom: '0px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px'
            }}>
              <span>
                Describe the image in your own meaningful words, atleast 60 words
              </span>
              {!isReviewMode && (
                <span style={{ color: '#6b7280', fontStyle: 'italic' }}>
                  {/* Tip: Timer starts automatically when you enter this section */}
                </span>
              )}
              {isReviewMode && (
                <span style={{ color: '#dc2626', fontWeight: 500 }}>
                  Review Mode: You can only view your answer, editing is disabled
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Timer container */}
        <GreenInfoContainer
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            margin: '0 47px 24px 47px',
            width: 'calc(100% - 94px)',
          }}
        >
          {(imageResponseTimeUp || (visitedSections.includes(currentPage) && imageResponseTimer < 240))
            ? "Time's up! Please submit your response."
            : <>You have <strong style={{ margin: '0 5px' }}>{Math.floor(imageResponseTimer / 60)}:{(imageResponseTimer % 60).toString().padStart(2, '0')}</strong> to complete this task</>}
        </GreenInfoContainer>

        {/* Two individual containers for image and text box */}
        <TwoColRow>
          {/* Image Container */}
          <PromptCard style={{ padding: 16, minHeight: '260px', background: '#f9fafb' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
              <img
                src={currentSection.imageUrl}
                alt="Assessment question"
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '320px',
                  objectFit: 'cover',
                  borderRadius: '12px',
                  display: 'block'
                }}
                onError={(e) => {
                  e.target.src = '/placeholder-image.jpg'
                }}
              />
            </div>
          </PromptCard>

          {/* Text Box Container */}
          <AnswerCard>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontSize: '15px',
              fontWeight: '500',
              color: '#374151'
            }}>
              Write your answer here
            </label>
            <QuestionBasedTextArea
              onFocus={(e) => {
                setTimeout(() => {
                  e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 300);
              }}
              value={questionBasedResponse}
              onChange={(e) => {
                if (isReviewMode || imageResponseTimeUp) return;
                handleQuestionBasedResponseChange(e.target.value);
              }}
              placeholder={
                isReviewMode || imageResponseTimeUp
                  ? "Time is up! Response saved."
                  : "Write a short descriptive paragraph capturing the scene and mood..."
              }
              maxLength={2000}
              disabled={isReviewMode || imageResponseTimeUp}
              spellCheck={false}
              onPaste={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
              onCopy={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
              onCut={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
              style={{
                minHeight: '320px',
                marginBottom: '12px',
                fontSize: '15px',
                resize: 'vertical',
                backgroundColor: isReviewMode || imageResponseTimeUp ? '#f3f4f6' : '#fff',
                cursor: isReviewMode || imageResponseTimeUp ? 'not-allowed' : 'text'
              }}
            />
            <QuestionBasedWordCount>
              <span>{wordCount}/60 minimum words</span>
            </QuestionBasedWordCount>
          </AnswerCard>
        </TwoColRow>
      </Section>
    )
  }


  const renderEmailWriting = () => {
    const charCount = emailWritingResponse.length;
    const isTimeWarning = emailWritingTimer <= 60 && emailWritingTimerActive;
    const isReviewMode = visitedSections.includes(currentPage);

    return (
      <Section>
        {/* Header with instructions */}
        <div style={{
          backgroundColor: '#f8f9fa',
          border: '1px solid #e9ecef',
          borderRadius: '8px',
          padding: '24px 32px',
          margin: '0 47px 24px 47px'
        }}>
          <div>
            <h3 style={{
              margin: '0 0 8px 0',
              fontSize: '16px',
              fontWeight: '600',
              color: '#374151'
            }}>
              Email Writing
            </h3>
            <div style={{
              fontSize: '14px',
              color: '#6b7280',
              lineHeight: '1.7',
              marginBottom: '0px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px'
            }}>
              <span>
                Write an email on the given topic. Keep it clear and concise.
              </span>
              <span style={{ color: '#6b7280', fontWeight: 500 }}>
                {!isReviewMode ? (
                  ' Tip: Timer starts automatically when you enter this section'
                ) : (
                  '⚠️ Review Mode: You can only view your answer, editing is disabled'
                )}
              </span>
            </div>
          </div>
        </div>

        {/* Timer container */}
        <GreenInfoContainer
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            margin: '0 47px 24px 47px',
            width: 'calc(100% - 94px)',
          }}
        >
          {(emailWritingTimeUp || (visitedSections.includes(currentPage) && emailWritingTimer < 300))
            ? "Time's up! Please submit your response."
            : <>You have <strong style={{ margin: '0 5px' }}>{Math.floor(emailWritingTimer / 60)}:{(emailWritingTimer % 60).toString().padStart(2, '0')}</strong> to complete this email</>}
        </GreenInfoContainer>

        {/* Prompt and text box */}
        <TwoColRow>
          {/* Prompt Container */}
          <PromptCard>
            <div style={{
              fontSize: '15px',
              color: '#374151',
              whiteSpace: 'pre-line'
            }}>
              {currentSection.question}
            </div>
          </PromptCard>

          {/* Text Box Container */}
          <AnswerCard>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontSize: '15px',
              fontWeight: '500',
              color: '#374151'
            }}>
              Subject
            </label>
            <input
              onFocus={(e) => {
                setTimeout(() => {
                  e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 300);
              }}
              type="text"
              value={emailData.subject}
              onChange={(e) => {
                if (isReviewMode || emailWritingTimeUp) return;
                handleEmailDataChange('subject', e.target.value);
              }}
              placeholder={
                isReviewMode || emailWritingTimeUp
                  ? "Time is up! Subject saved."
                  : "Enter the subject of your email"
              }
              maxLength={100}
              disabled={isReviewMode || emailWritingTimeUp}
              style={{
                marginBottom: '16px',
                fontSize: '15px',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                backgroundColor: isReviewMode || emailWritingTimeUp ? '#f3f4f6' : '#fff',
                cursor: isReviewMode || emailWritingTimeUp ? 'not-allowed' : 'text'
              }}
              spellCheck={false}
              onPaste={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
              onCopy={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
              onCut={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
            />
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontSize: '15px',
              fontWeight: '500',
              color: '#374151'
            }}>
              Write your answer here
            </label>
            <TextArea
              onFocus={(e) => {
                setTimeout(() => {
                  e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 300);
              }}
              value={emailWritingResponse}
              onChange={(e) => {
                if (isReviewMode || emailWritingTimeUp) return;
                handleEmailWritingResponseChange(e.target.value);
              }}
              placeholder={
                isReviewMode || emailWritingTimeUp
                  ? "Time is up! Response saved."
                  : "Write your email here"
              }
              style={{
                minHeight: '320px',
                marginBottom: '12px',
                fontSize: '15px',
                resize: 'vertical',
                backgroundColor: isReviewMode || emailWritingTimeUp ? '#f3f4f6' : '#fff',
                cursor: isReviewMode || emailWritingTimeUp ? 'not-allowed' : 'text'
              }}
              maxLength={2000}
              disabled={isReviewMode || emailWritingTimeUp}
              spellCheck={false}
              onPaste={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
              onCopy={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
              onCut={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
            />
          </AnswerCard>
        </TwoColRow>
      </Section>
    )
  }



  const renderDictation = () => {
    const questions = currentSection.questions || [];
    const currentQ = questions[dictationCurrentIndex];

    if (!currentQ) return null;

    const audioCompleted = dictationAudioCompleted[currentQ.audioUrl];
    const isCurrentQuestionReview = isCurrentQuestionInReviewMode();

    return (
      <Section>
        {/* Dictation Section Header */}
        <div style={{
          fontSize: '20px',
          fontWeight: 700,
          color: '#1e293b',
          marginBottom: '18px',
          letterSpacing: '0.5px'
        }}>
          Dictation Section
        </div>
        {/* Top Instruction Box */}
        <div style={{
          background: '#f6f8fc',
          borderRadius: '8px',
          padding: '18px 24px',
          marginBottom: '18px',
          border: '1px solid #e9ecef'
        }}>
          <div style={{ fontSize: '14px', color: '#374151', marginBottom: '2px' }}>
            Listen and type what you hear.
          </div>
        </div>

        {/* Timer Container */}
        <GreenInfoContainer
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            margin: '0 0 18px 0',
            width: '100%',
          }}
        >
          {isCurrentQuestionReview
            ? "Review mode - editing disabled"
            : !audioCompleted
              ? "Play the audio to start the timer"
              : dictationTimer === 0
                ? "Time's up! Continue to next question."
                : <>You have <strong style={{ margin: '0 5px' }}>{dictationTimer} seconds</strong> to write this sentence</>}
        </GreenInfoContainer>

        {/* --- Main Content Box --- */}
        <TwoColRowDictation>
          {/* Left: The New WaveformPlayer */}
          <LeftPane style={{ alignItems: 'center', justifyContent: 'center' }}>
            <div style={{
              width: '100%',
              marginBottom: '18px',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center'
            }}>
              <div style={{ fontWeight: 500, fontSize: '15px' }}>
                Sentence {dictationCurrentIndex + 1} of {questions.length}
              </div>
            </div>

            <div style={{ width: '100%', marginBottom: '12px' }}>
              <WaveformPlayer
                url={currentQ.audioUrl}
                onAudioComplete={() => handleDictationAudioComplete(currentQ.audioUrl)}
                isAlreadyCompleted={audioCompleted}
                key={`dictation-audio-${dictationCurrentIndex}-${currentQ.audioUrl}`}
                allowReplay={false}
                disabled={isCurrentQuestionReview}
              />
            </div>

          </LeftPane>

          {/* Right: Answer Box (RESTORED) */}
          <RightPane style={{ justifyContent: 'center' }}>
            <label style={{
              fontSize: '15px',
              fontWeight: '500',
              marginBottom: '8px',
              color: '#374151'
            }}>
              Write your answer here
            </label>
            <textarea
              onFocus={(e) => {
                setTimeout(() => {
                  e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 300);
              }}
              value={dictationAnswers[currentQ.id] || ''}
              onChange={(e) => {
                if (isCurrentQuestionReview || !audioCompleted || dictationTimer === 0) return;
                handleDictationAnswerChange(currentQ.id, e.target.value);
              }}
              placeholder={
                isCurrentQuestionReview
                  ? "Your submitted answer"
                  : !audioCompleted
                    ? "Play the audio first to start writing"
                    : dictationTimer === 0
                      ? "Time is up! Answer saved."
                      : "Write the sentence exactly as you heard it..."
              }
              disabled={isCurrentQuestionReview || !audioCompleted || dictationTimer === 0}
              maxLength={2000}
              style={{
                minHeight: '120px',
                fontSize: '15px',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                background: isCurrentQuestionReview || !audioCompleted || dictationTimer === 0 ? '#f3f4f6' : '#fff',
                color: '#374151',
                marginBottom: '8px',
                resize: 'vertical',
                cursor: isCurrentQuestionReview || !audioCompleted || dictationTimer === 0 ? 'not-allowed' : 'text'
              }}
              spellCheck={false}
              onPaste={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
              onCopy={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
              onCut={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
            />

          </RightPane>
        </TwoColRowDictation>
      </Section>
    );
  };

  // Update the renderSentenceCompletion function
  const renderSentenceCompletion = () => {
    const questions = currentSection.questions || []
    const currentQ = questions[sentenceCompletionCurrentIndex]

    if (!currentQ) return null

    // Enhanced sentence processing
    let displaySentence = currentQ.sentence || ''

    // Ensure the blank is properly represented
    const blankPattern = /_+/g
    const standardBlank = '_____'

    // Normalize the blank representation first
    displaySentence = displaySentence.replace(blankPattern, standardBlank)

    // Split the sentence at the first blank only
    const firstBlankIndex = displaySentence.indexOf(standardBlank)

    // Default parts if there's an issue with splitting
    let before = displaySentence
    let after = ''

    if (firstBlankIndex !== -1) {
      before = displaySentence.substring(0, firstBlankIndex)
      after = displaySentence.substring(firstBlankIndex + standardBlank.length)

      // Remove any additional blanks from the after part
      after = after.replace(blankPattern, '')
    }

    const isTimeWarning = sentenceCompletionTimer <= 10 && sentenceCompletionTimerActive
    const isCurrentQuestionReview = isCurrentQuestionInReviewMode()

    return (
      <Section>
        {/* Sentence Completion Section Header */}
        <div style={{
          fontSize: '20px',
          fontWeight: 700,
          color: '#1e293b',
          marginBottom: '18px',
          letterSpacing: '0.5px'
        }}>
          Sentence Completion Section
        </div>
        <div style={{
          background: '#f6f8fc',
          borderRadius: '8px',
          padding: '18px 24px',
          marginBottom: '18px',
          border: '1px solid #e9ecef'
        }}>
          <div style={{ fontWeight: 600, fontSize: '15px', marginBottom: '4px' }}>
            Sentence Completion
          </div>
          <div style={{ fontSize: '14px', color: '#374151', marginBottom: '2px' }}>
            Fill in the blank with relevant word as per the context
          </div>
        </div>

        <GreenInfoContainer
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            margin: '0 0 18px 0',
            width: '100%',
          }}
        >
          {isCurrentQuestionReview
            ? "Review mode - editing disabled"
            : sentenceCompletionTimer === 0
              ? "Time's up! Continue to next question."
              : <>You have <strong style={{ margin: '0 5px' }}>{sentenceCompletionTimer} seconds</strong> to complete this sentence</>}
        </GreenInfoContainer>

        {/* Rest of the component remains the same */}
        <TwoColRowFull>
          {/* Left: Question + Timer */}
          <LeftPane style={{ justifyContent: 'center' }}>
            {/* Header with Question Number - timer removed from here */}
            <div style={{
              width: '100%',
              marginBottom: '18px',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center'
            }}>
              <div style={{ fontWeight: 500, fontSize: '15px' }}>
                Sentence {sentenceCompletionCurrentIndex + 1} of {questions.length}
              </div>
            </div>

            <div style={{
              width: '100%',
              background: '#fff',
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              padding: '18px 16px',
              marginBottom: '12px'
            }}>
              <div style={{ fontSize: '15px', fontWeight: 500 }}>
                {before}<span style={{ textDecoration: 'underline', display: 'inline-block', minWidth: '30px' }}>_____</span>{after}
              </div>
            </div>


          </LeftPane>

          {/* Right: Answer Box */}
          <RightPane style={{ justifyContent: 'center' }}>
            <label style={{
              fontSize: '15px',
              fontWeight: '500',
              marginBottom: '8px',
              color: '#374151'
            }}>
              Write only the missing word here
            </label>
            <textarea
              onFocus={(e) => {
                setTimeout(() => {
                  e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 300);
              }}
              value={sentenceCompletionAnswers[currentQ.id] || ''}
              onChange={(e) => {
                if (isCurrentQuestionReview || sentenceCompletionTimer === 0) return;
                handleSentenceCompletionChange(currentQ.id, e.target.value);
              }}
              placeholder={
                isCurrentQuestionReview
                  ? "Your submitted answer"
                  : sentenceCompletionTimer === 0
                    ? "Time is up! Answer saved."
                    : "Complete the sentence..."
              }
              disabled={isCurrentQuestionReview || sentenceCompletionTimer === 0}
              maxLength={2000}
              style={{
                minHeight: '120px',
                fontSize: '15px',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                background: isCurrentQuestionReview || sentenceCompletionTimer === 0 ? '#f3f4f6' : '#fff',
                color: '#374151',
                marginBottom: '8px',
                resize: 'vertical',
                cursor: isCurrentQuestionReview || sentenceCompletionTimer === 0 ? 'not-allowed' : 'text'
              }}
              spellCheck={false}
              onPaste={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
              onCopy={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
              onCut={isUAT ? undefined : (e) => {
                e.preventDefault()
                trackCopyPasteAttempted(currentAssessment.assessment_assigned_id, currentAssessment.type, e.clipboardData.getData('text/plain'), currentAssessment.isCorporate, currentAssessment.entityName);
              }}
            />
          </RightPane>
        </TwoColRowFull>
      </Section>
    )
  }
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const generateArrangedSentence = (question, indices) => {
    if (!question || !indices || !indices.length) return '';

    if (question.type === 'sentence_rearrangement') {
      const sentences = question.jumbledSentences || [];
      if (!Array.isArray(sentences)) return '';
      return indices.map(i => sentences[i]).filter(s => s).join(' ');
    } else {
      // word arrangement
      const rawWords = (question.jumbledWords || '').split(/[,\s]+/).filter(word => word.trim() !== '');
      const words = rawWords.map(word => word.toLowerCase().replace(/[^\w\s]/g, '')).filter(w => w.trim() !== '');
      return indices.map(i => words[i]).filter(w => w).join(' ');
    }
  };

  // Add state to store shuffled words
  const [shuffledWords, setShuffledWords] = useState({});
  useEffect(() => {
    if (currentSection.type === 'Sentence Build') {
      const currentQ = (currentSection.questions || [])[sentenceBuildCurrentIndex];
      const questionKey = currentQ ? `${currentPage}-${currentQ.id}` : null;

      // CRITICAL: If timer is locked, freeze everything immediately
      if (questionKey && sentenceBuildTimerLockedRef.current[questionKey]) {
        console.log('🔒 Timer LOCKED - freezing at 0');

        if (sentenceBuildTimer !== 0) setSentenceBuildTimer(0);
        if (sentenceBuildTimerActive) setSentenceBuildTimerActive(false);

        // Clear any running interval
        if (sentenceBuildTimerRef.current) {
          clearInterval(sentenceBuildTimerRef.current);
          sentenceBuildTimerRef.current = null;
        }

        return; // EXIT EARLY
      }

      // Normal countdown logic
      if (sentenceBuildTimerActive && sentenceBuildTimer > 0) {
        if (sentenceBuildTimerRef.current) {
          clearInterval(sentenceBuildTimerRef.current);
        }

        sentenceBuildTimerRef.current = setInterval(() => {
          setSentenceBuildTimer(prev => {
              if (prev <= 1) {
              clearInterval(sentenceBuildTimerRef.current);
              setSentenceBuildTimerActive(false);

              // PERMANENT LOCK when timer hits 0
              if (questionKey) {
                sentenceBuildTimerLockedRef.current[questionKey] = true;
                console.log('🔐 PERMANENTLY LOCKED question:', questionKey);
              }

              // Save response before moving
              const sentenceBuildQuestions = currentSection.questions || [];
              const currentQ = sentenceBuildQuestions[sentenceBuildCurrentIndex];
              if (currentQ) {
                let arrangedContent = '';
                let hasUserInteracted = false;

                if (currentQ.type === 'unknown' || currentQ.type === 'word_arrangement') {
                  const userSelectedWords = selectedWords[sentenceBuildCurrentIndex];
                  if (userSelectedWords && userSelectedWords.length > 0) {
                    hasUserInteracted = true;
                    arrangedContent = generateArrangedSentence(currentQ, userSelectedWords);
                  }
                } else if (currentQ.type === 'sentence_rearrangement') {
                  const userParagraphOrder = paragraphOrder[sentenceBuildCurrentIndex];
                  const hasInteracted = userInteractedWithParagraph[`${currentPage}-${currentQ.id}`];
                  if (userParagraphOrder && userParagraphOrder.length > 0 && hasInteracted) {
                    hasUserInteracted = true;
                    arrangedContent = generateArrangedSentence(currentQ, userParagraphOrder);
                  }
                }

                const assessmentId = currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id;
                if (assessmentId) {
                  try {
                    const responseText = hasUserInteracted ? arrangedContent.trim() : "not attempted";

                    dispatch(saveQuestionResponse(
                      currentSection.questionId,
                      responseText,
                      assessmentId,
                      currentQ.id,
                      'sentenceBuild'
                    ));
                    console.log(hasUserInteracted ? '✅ Response saved on timer expiry' : '⚠️ Not attempted saved');

                    if (currentQ.type === 'sentence_rearrangement') {
                      console.log('🏁 Sentence rearrangement timer expired - submitting');
                      setTimeout(() => {
                        handleSubmit();
                      }, 500);
                      return 0;
                    }

                    const isLastSection = currentPage === questions.length - 1;
                    const isLastQuestion = sentenceBuildCurrentIndex === sentenceBuildQuestions.length - 1;
                    if (isLastSection && isLastQuestion) {
                      console.log('🏁 Last question timer expired - submitting');
                      setTimeout(() => {
                        handleSubmit();
                      }, 500);
                      return 0;
                    }
                  } catch (error) {
                    console.log('Redux error ignored - response saved successfully');
                  }
                }
              }

              // Auto-move to next question after save
              setTimeout(() => {
                const questions = currentSection.questions || [];
                if (sentenceBuildCurrentIndex < questions.length - 1) {
                  setSentenceBuildCurrentIndex(sentenceBuildCurrentIndex + 1);
                }
              }, 500);

              return 0; // Timer locked at 0
            }
            return prev - 1;
          });
        }, 1000);

        return () => {
          if (sentenceBuildTimerRef.current) {
            clearInterval(sentenceBuildTimerRef.current);
          }
        };
      }
    }
  }, [currentSection.type, sentenceBuildTimerActive, sentenceBuildTimer, sentenceBuildCurrentIndex, currentPage, handleSubmit]);


  // Update the renderSentenceBuild function to properly display shuffled words using dnd-kit
  const renderSentenceBuild = () => {
    const questions = currentSection.questions || [];
    const currentQ = questions[sentenceBuildCurrentIndex];

    if (!currentQ) return null;

    const isWordArrangement = currentQ.type === 'unknown' || currentQ.type === 'word_arrangement';
    const isSentenceRearrangement = currentQ.type === 'sentence_rearrangement';

    const isTimeWarning = sentenceBuildTimer <= 60 && sentenceBuildTimerActive;
    const isCurrentQuestionReview = isCurrentQuestionInReviewMode();

    const questionKey = `${currentPage}-${currentQ.id}`;
    const isTimerLocked = sentenceBuildTimerLockedRef.current[questionKey] || sentenceBuildTimer === 0;

    const isDragDisabled = isCurrentQuestionReview || isTimerLocked;

    let words = [];
    let sentences = [];

    if (isWordArrangement) {
      const rawWords = currentQ.jumbledWords.split(/[,\s]+/).filter(word => word.trim() !== '');
      words = rawWords.map(word =>
        word.toLowerCase().replace(/[^\w\s]/g, '')
      ).filter(word => word.trim() !== '');
    }
    else if (isSentenceRearrangement) {
      if (currentQ.jumbledSentences && Array.isArray(currentQ.jumbledSentences)) {
        sentences = currentQ.jumbledSentences;
      }
    }

    const getCurrentWordOrder = () => {
      // Return array of original indices
      return selectedWords[sentenceBuildCurrentIndex] || words.map((_, i) => i);
    };

    const getCurrentSentenceOrder = () => {
      return paragraphOrder[sentenceBuildCurrentIndex] || shuffledWords[questionKey] || sentences.map((_, i) => i);
    };

    // --- dnd-kit sensors ---
    // --- dnd-kit sensors (moved to component level) ---
    // const sensors = useSensors(...) // Removed from here


    // --- dnd-kit handlers ---
    const handleDragEnd = (event, type) => {
      const { active, over } = event;

      if (!over || active.id === over.id || isDragDisabled) {
        return;
      }

      const activeId = active.id;
      const overId = over.id;

      let currentOrder;
      let newOrder;

      if (type === 'word') {
        currentOrder = getCurrentWordOrder();
        const oldIndex = currentOrder.indexOf(activeId);
        const newIndex = currentOrder.indexOf(overId);
        newOrder = arrayMove(currentOrder, oldIndex, newIndex);

        const updatedSelectedWords = [...(selectedWords || [])];
        updatedSelectedWords[sentenceBuildCurrentIndex] = newOrder;
        setSelectedWords(updatedSelectedWords);
        handleSentenceBuildChange(sentenceBuildCurrentIndex, newOrder, 'word-arrangement');
      } else {
        currentOrder = getCurrentSentenceOrder();
        const oldIndex = currentOrder.indexOf(activeId);
        const newIndex = currentOrder.indexOf(overId);
        newOrder = arrayMove(currentOrder, oldIndex, newIndex);

        const updatedParagraphOrder = [...(paragraphOrder || [])];
        updatedParagraphOrder[sentenceBuildCurrentIndex] = newOrder;
        setParagraphOrder(updatedParagraphOrder);
        handleSentenceBuildChange(sentenceBuildCurrentIndex, newOrder, 'paragraph-ordering');
        setUserInteractedWithParagraph(prev => ({
          ...prev,
          [`${currentPage}-${currentQ.id}`]: true
        }));
      }
    };

    // New Helper: Handle click for swapping (Mobile Friendly / Accessibility)
    const handleMobileItemClick = (index, type) => {
      if (isDragDisabled) return;

      // If nothing selected, select this item
      if (!sentenceBuildSelectedItem) {
        setSentenceBuildSelectedItem({ index, type });
        return;
      }

      // If dragging/selecting cross-types (shouldn't happen but safety check)
      if (sentenceBuildSelectedItem.type !== type) {
        setSentenceBuildSelectedItem({ index, type }); // Switch selection to new type
        return;
      }

      // If clicked the same item, deselect
      if (sentenceBuildSelectedItem.index === index) {
        setSentenceBuildSelectedItem(null);
        return;
      }

      // SWAP ACTION (retaining swap logic for explicit clicks)
      const swapIndices = (order, setOrderFn, changeType) => {
        // This logic swaps POSITIONS in the array, not just values
        // `index` here is the *original index* (id). We need to find *current positions* of these IDs.
        // Actually, wait. The mapped loop provides `currentIndex` (visual position) and `originalIndex` (value/id).
        // The `handleMobileItemClick` passes `originalIndex` because it's called with `originalIndex` (the item ID).
        // NO. I need to pass the *visual index* if I want to swap positions A and B.
        // DndKit works with IDs.
        // Let's modify handleMobileItemClick to accept Keys (IDs).
      };

      // Actually simpler: I will update the logic below in the render to pass the Key (Original Index).
      // Then I find their current index in the array and swap them using arrayMove or swap.
      // User asked for "swap only" on click.

      const sourceId = sentenceBuildSelectedItem.index; // This is actually the ID (original index)
      const targetId = index; // This is the ID (original index)

      if (type === 'word') {
        const currentOrder = getCurrentWordOrder();
        const sourceIdx = currentOrder.indexOf(sourceId);
        const targetIdx = currentOrder.indexOf(targetId);

        if (sourceIdx === -1 || targetIdx === -1) return;

        const newOrder = [...currentOrder];
        // Swap
        const temp = newOrder[sourceIdx];
        newOrder[sourceIdx] = newOrder[targetIdx];
        newOrder[targetIdx] = temp;

        const updatedSelectedWords = [...(selectedWords || [])];
        updatedSelectedWords[sentenceBuildCurrentIndex] = newOrder;
        setSelectedWords(updatedSelectedWords);
        handleSentenceBuildChange(sentenceBuildCurrentIndex, newOrder, 'word-arrangement');
      } else {
        const currentOrder = getCurrentSentenceOrder();
        const sourceIdx = currentOrder.indexOf(sourceId);
        const targetIdx = currentOrder.indexOf(targetId);

        if (sourceIdx === -1 || targetIdx === -1) return;

        const newOrder = [...currentOrder];
        // Swap
        const temp = newOrder[sourceIdx];
        newOrder[sourceIdx] = newOrder[targetIdx];
        newOrder[targetIdx] = temp;

        const updatedParagraphOrder = [...(paragraphOrder || [])];
        updatedParagraphOrder[sentenceBuildCurrentIndex] = newOrder;
        setParagraphOrder(updatedParagraphOrder);
        handleSentenceBuildChange(sentenceBuildCurrentIndex, newOrder, 'paragraph-ordering');
      }

      // Deselect after swap
      setSentenceBuildSelectedItem(null);
    };

    const getCurrentWordArrangement = () => {
      const currentOrder = selectedWords[sentenceBuildCurrentIndex] || words.map((_, i) => i);
      return currentOrder.map(index => words[index]);
    };

    const getCurrentSentenceArrangement = () => {
      const currentOrder = paragraphOrder[sentenceBuildCurrentIndex] || shuffledWords[questionKey];
      if (!currentOrder || !sentences.length) {
        return sentences;
      }
      return currentOrder.map(index => sentences[index]).filter(s => s);
    };

    return (
      <Section>
        {/* Sentence Build Section Header */}
        <div style={{
          fontSize: '20px',
          fontWeight: 700,
          color: '#1e293b',
          marginBottom: '18px',
          letterSpacing: '0.5px'
        }}>
          Sentence Building Section
        </div>

        {/* Instruction Box */}
        <div style={{
          background: '#f6f8fc',
          borderRadius: '8px',
          padding: '18px 24px',
          marginBottom: '18px',
          border: '1px solid #e9ecef'
        }}>
          <div style={{ fontWeight: 600, fontSize: '15px', marginBottom: '4px' }}>
            Sentence Building
          </div>
          <div style={{ fontSize: '14px', color: '#374151', marginBottom: '2px' }}>
            {isWordArrangement
              ? 'Drag and drop or tap to rearrange words into the correct logical order.'
              : "Drag and drop or tap to rearrange sentences into a coherent paragraph."
            }
          </div>
        </div>

        <GreenInfoContainer
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            margin: '0 0 18px 0',
            width: '100%',
            padding: '12px 20px',
            backgroundColor: '#f0fdf4',
            fontSize: '14px',
          }}
        >
          {isCurrentQuestionReview
            ? "Review mode - editing disabled"
            : isTimerLocked
              ? "Time's up! "
              : <>You have <strong style={{ margin: '0 5px' }}>{Math.floor(sentenceBuildTimer / 60)}:{(sentenceBuildTimer % 60).toString().padStart(2, '0')}</strong> to arrange this {isWordArrangement ? 'sentence' : 'paragraph'}</>}
        </GreenInfoContainer>

        <TwoColRowFull>
          {/* Left: Interactive Arrangement Area */}
          <LeftPane>
            {/* Header with question number */}
            <div style={{
              width: '100%',
              marginBottom: '18px',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center'
            }}>
              <div style={{ fontWeight: 500, fontSize: '15px' }}>
                Question {sentenceBuildCurrentIndex + 1} of {questions.length}
              </div>
            </div>

            {/* Word Arrangement */}
            {isWordArrangement && (
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={(e) => handleDragEnd(e, 'word')}
              >
                <SortableContext
                  items={getCurrentWordOrder()}
                  strategy={rectSortingStrategy} // Use Rect strategy for grid-like wrapping
                >
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '12px',
                    minHeight: '160px',
                    padding: '24px',
                    background: '#fff',
                    borderRadius: '12px',
                    border: '2px solid #e9ecef',
                    alignItems: 'center',
                    alignContent: 'flex-start'
                  }}>
                    {getCurrentWordOrder().map((originalIndex) => (
                      <SortableItem
                        key={originalIndex}
                        id={originalIndex}
                        content={words[originalIndex]}
                        type="word"
                        disabled={isDragDisabled}
                        isSelected={sentenceBuildSelectedItem?.index === originalIndex && sentenceBuildSelectedItem?.type === 'word'}
                        onClick={() => handleMobileItemClick(originalIndex, 'word')}
                      />
                    ))}
                  </div>
                </SortableContext>
                <DragOverlay>
                  {/* Optional: Add drag overlay for smoother visuals if needed, but not strictly required as SortableItem handles opacity */}
                </DragOverlay>
              </DndContext>
            )}

            {/* Sentence Rearrangement */}
            {isSentenceRearrangement && sentences.length > 0 && (
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={(e) => handleDragEnd(e, 'sentence')}
              >
                <SortableContext
                  items={getCurrentSentenceOrder()}
                  strategy={verticalListSortingStrategy}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {getCurrentSentenceOrder().map((originalIndex, currentIndex) => (
                      <SortableItem
                        key={originalIndex}
                        id={originalIndex}
                        indexDisplay={currentIndex + 1}
                        content={sentences[originalIndex]}
                        type="sentence"
                        disabled={isDragDisabled}
                        isSelected={sentenceBuildSelectedItem?.index === originalIndex && sentenceBuildSelectedItem?.type === 'sentence'}
                        onClick={() => handleMobileItemClick(originalIndex, 'sentence')}
                      />
                    ))}
                  </div>
                </SortableContext>
              </DndContext>
            )}

            <div style={{
              fontSize: '14px',
              color: '#64748b',
              marginTop: '16px',
              textAlign: 'center',
              fontStyle: 'italic'
            }}>
              Drag and drop to reorder. Tap to select and swap.
            </div>
          </LeftPane>

          {/* Right: Preview Area */}
          <RightPane style={{ justifyContent: 'flex-start' }}>
            <label style={{
              fontSize: '15px',
              fontWeight: '600',
              marginBottom: '12px',
              color: '#1e293b',
              display: 'block'
            }}>
              {isWordArrangement ? 'Preview:' : 'Paragraph Preview:'}
            </label>

            {/* Word arrangement preview */}
            {isWordArrangement && (
              <div style={{
                background: '#fff',
                padding: '24px',
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                minHeight: '120px',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }}>
                <div style={{
                  padding: '20px',
                  background: '#f8fafc',
                  borderRadius: '8px',
                  border: '1px dashed #cbd5e1',
                  minHeight: '80px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '16px',
                  lineHeight: '1.6',
                  textAlign: 'center',
                  color: getCurrentWordArrangement().join(' ') ? '#334155' : '#94a3b8'
                }}>
                  {getCurrentWordArrangement().join(' ') || 'Arrange words to see the sentence here'}
                </div>
              </div>
            )}

            {/* Sentence rearrangement preview */}
            {isSentenceRearrangement && (
              <div style={{
                background: '#fff',
                padding: '24px',
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                minHeight: '240px',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }}>
                <div style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px'
                }}>
                  {getCurrentSentenceArrangement().length > 0 ? (
                    <div style={{
                      padding: '20px',
                      background: '#f8fafc',
                      borderRadius: '8px',
                      border: '1px dashed #cbd5e1',
                      fontSize: '15px',
                      lineHeight: '1.8',
                      color: '#334155'
                    }}>
                      {getCurrentSentenceArrangement().join(' ')}
                    </div>
                  ) : (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%',
                      color: '#94a3b8',
                      fontStyle: 'italic'
                    }}>
                      Arrange sentences to see the paragraph here
                    </div>
                  )}
                </div>
              </div>
            )}
          </RightPane>
        </TwoColRowFull>
      </Section>
    );
  };
  // Resolve (assessmentAssignedId, studentId), mirroring uploadProctorImage.
  const resolveProctorIds = () => {
    const assessmentAssignedId =
      currentAssessment?.assessment_assigned_id ||
      assessment?.assessment_assigned_id ||
      location?.state?.assessmentData?.assessment_assigned_id ||
      location?.state?.assessment_assigned_id
    const otpAssignedId =
      (typeof sessionStorage !== 'undefined' &&
        sessionStorage.getItem('assessment_invite_assigned_id')) || null
    const studentId =
      studentDetails?.id || studentDetails?.studentId || currentAssessment?.studentId ||
      otpAssignedId || assessmentAssignedId
    return { assessmentAssignedId, studentId }
  }

  // Start the MediaPipe gaze collector once on the live hidden proctor video,
  // scoped per section/page. Report-only; no-op without an id.
  const startCollectorIfReady = () => {
    if (proctoringCollectorStarted.current) return
    const { assessmentAssignedId, studentId } = resolveProctorIds()
    if (!assessmentAssignedId || !captureRef.current) return
    proctoringCollectorStarted.current = true
    proctoringCollector.start({
      videoEl: captureRef.current,
      assessmentAssignedId,
      studentId,
      sessionId: null,
      // Communication mixes typed sections (Email Writing, Sentence Completion/Build,
      // Dictation) with spoken ones (Paragraph Reading, Audio/Video Response) —
      // candidates naturally look at the keyboard while typing, so gaze-away/
      // head-turned proctoring is disabled across the whole assessment; reading-
      // from-a-device detection (the signal that matters for speaking sections too)
      // stays on.
      disableGazeEvents: true,
      onSuspicion: () => { snapshotBurstUntilRef.current = Date.now() + 30000 },
    })
    try {
      if (window.screen && window.screen.isExtended === true) {
        proctoringCollector.recordEvent('second_display', { severity: 'high', confidence: 0.8 })
      }
    } catch (_) { /* unsupported → unflagged */ }
    proctoringCollector.setActiveQuestion(currentPage, `section-${currentPage}`)
  }

  const setupProctoringInterval = () => {
    console.log('Setting up new proctoring interval')
    // Clear any existing timer
    if (captureInterval.current) {
      clearTimeout(captureInterval.current)
    }
    const SNAP_MS = 13000
    const SNAP_BURST_MS = 5000
    const runOnce = async () => {
      if (proctoringActive.current) {
        try {
          const imageBlob = await captureImage()
          if (imageBlob) {
            await uploadProctorImage(imageBlob)
          } else if (!recording && captureRef.current) {
            // capture failed & not recording — reset the capture ref so the next
            // tick re-acquires getUserMedia.
            if (captureRef.current.srcObject) {
              captureRef.current.srcObject.getTracks().forEach(track => {
                if (track.readyState === 'live') track.stop()
              })
            }
            captureRef.current.srcObject = null
            captureRef.current = null
            capturingInProgress.current = false
          }
        } catch (error) {
          console.error('Error in capture interval:', error)
          capturingInProgress.current = false
        }
      }
      const inBurst = Date.now() < snapshotBurstUntilRef.current
      captureInterval.current = setTimeout(runOnce, inBurst ? SNAP_BURST_MS : SNAP_MS)
    }
    captureInterval.current = setTimeout(runOnce, 13000)

    return captureInterval.current
  }

  const renderVideoSection = () => {
    return (
      <Section>
        {isModalVisible && (
          <ModalOverlay onClick={handleCloseModal} style={{ zIndex: 9999 }}>
            <ModalContent
              onClick={e => e.stopPropagation()}
              style={{ zIndex: 10000 }}
            >
              <ShortListModalImg>
                <img
                  src={DeleteImage || '/placeholder.svg'}
                  alt="delete confirmation"
                />
              </ShortListModalImg>
              <ModalText>
                Are you sure you want to delete this recording?
              </ModalText>
              <ButtonDiv>
                <Button
                  type="default"
                  onClick={handleCloseModal}
                  style={{
                    height: '38px',
                    marginRight: '10px',
                    borderRadius: '4px',
                  }}
                >
                  No
                </Button>
                <Button
                  type="primary"
                  onClick={handleConfirmDelete}
                  style={{
                    height: '38px',
                    borderRadius: '4px',
                    background: '#4318FF',
                  }}
                >
                  Yes
                </Button>
              </ButtonDiv>
            </ModalContent>
          </ModalOverlay>
        )}

        {showSuccessModal && (
          <SuccessModal
            open={showSuccessModal}
            onCloseClick={handleSuccessModalClose}
            message="Recording deleted successfully!"
            title="Delete Recording"
          />
        )}

        <InfoContainer style={{ marginLeft: '47px' }}>
          <InfoIcon style={{ fontSize: '16px', marginRight: '8px' }}>
            i
          </InfoIcon>
          <InfoText>
            Record your response to the question and make sure{' '}
            <strong>it's at least 1 minute long and at most 2 minutes.</strong>
          </InfoText>
        </InfoContainer>
        {responseLanguage && responseLanguage.toLowerCase() !== 'english' && (
          <LanguageCallout style={{ marginLeft: '47px' }}>
            <LanguageCalloutIcon aria-hidden="true">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="2" y1="12" x2="22" y2="12" />
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
              </svg>
            </LanguageCalloutIcon>
            <LanguageCalloutText>
              Speak your answer in <LanguagePill>{responseLanguage}</LanguagePill>
            </LanguageCalloutText>
          </LanguageCallout>
        )}

        {/* <QuestionsPlaceholder style={{ marginLeft: '47px' }}>
        <InfoIcon style={{ fontSize: '16px', marginRight: '8px' }}>
          i
        </InfoIcon>
        Questions will appear here after you complete the recording
      </QuestionsPlaceholder> */}
        <div
          style={{
            textAlign: 'left',
            margin: '3rem 0 30px 0', // Remove auto centering, add top/bottom margin only
            paddingLeft: '48px',     // Add left padding
            width: '100%',           // Full width
            maxWidth: '100%',        // Remove maxWidth restriction
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >

          <h2
            style={{
              fontSize: '24px',
              fontWeight: '700',
              color: '#000000',
              lineHeight: '1.4',
              textAlign: 'left',
              width: '100%',
            }}
          >
            {currentSection.questions[0]?.question ||
              currentSection.paragraph ||
              'Please record your response to this question.'}
          </h2>
        </div>

        {(recording || preRecordCountdown !== null) && (
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '30px',
            }}
          >
            <div
              style={{
                width: '100%',
                maxWidth: '640px',
                borderRadius: '12px',
                overflow: 'hidden',
                position: 'relative',
                backgroundColor: '#000',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                marginBottom: '16px',
                aspectRatio: '16/9',
              }}
            >
              <VideoOverlay style={{ width: '100%', height: '100%' }}>
                <VideoContainer style={{ width: '100%', height: '100%' }}>
                  <VideoElement
                    ref={videoRef}
                    autoPlay
                    muted
                    playsInline
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '12px',
                      display: 'block',
                    }}
                  />
                </VideoContainer>
              </VideoOverlay>

              {preRecordCountdown !== null && (
                <PreRecordCountdownOverlay role="status" aria-live="assertive">
                  <PreRecordCountdownLabel>
                    Recording starts in
                  </PreRecordCountdownLabel>
                  <PreRecordCountdownNumber key={preRecordCountdown}>
                    {preRecordCountdown}
                  </PreRecordCountdownNumber>
                </PreRecordCountdownOverlay>
              )}

              {recording && (
                <div
                  style={{
                    position: 'absolute',
                    top: '15px',
                    right: '15px',
                    backgroundColor: '#ffffff',
                    color: '#000000',
                    padding: '6px 12px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    zIndex: 10,
                  }}
                >
                  <div
                    style={{
                      width: '10px',
                      height: '10px',
                      backgroundColor: '#FF3B30',
                      borderRadius: '50%',
                      marginRight: '8px',
                    }}
                  ></div>
                  {formatRecordingTime(
                    MAX_RECORDING_TIME - remainingRecordingTime
                  )}
                </div>
              )}
            </div>

            {recording && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '20px',
                  width: '100%',
                }}
              >
                <RecordingCountdownButton
                  onClick={minRecordingReached ? stopRecording : undefined}
                  enabled={minRecordingReached}
                >
                  Stop recording
                  <StopRecordIcon />
                </RecordingCountdownButton>
              </div>
            )}
          </div>
        )}

        {!recording && recordedVideo && (
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '30px',
            }}
          >
            <div
              style={{
                width: '100%',
                maxWidth: '640px',
                borderRadius: '12px',
                overflow: 'hidden',
                position: 'relative',
                backgroundColor: '#000',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                marginBottom: '16px',
              }}
            >
              <video
                src={recordedVideo}
                controls
                playsInline
                webkit-playsinline="true"
                style={{
                  width: '100%',
                  borderRadius: '12px',
                  display: 'block',
                }}
              />
            </div>

            {remainingAttempts > 0 && (
              <div
                style={{
                  marginTop: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <button
                  onClick={handleDeleteClick}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#FF7300',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: '30px',
                    padding: '12px 24px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                    width: '149px',
                    height: '40px',
                  }}
                >
                  Re-record
                  <Retry style={{ marginLeft: '8px' }} />
                </button>
                <div
                  style={{
                    marginTop: '16px',
                    fontSize: '16px',
                  }}
                >
                  You have{' '}
                  <strong style={{ fontWeight: '800' }}>
                    {remainingAttempts}{' '}
                    {remainingAttempts === 1 ? 'chance' : 'chances'}
                  </strong>{' '}
                  left
                </div>
              </div>
            )}
          </div>
        )}

        {!recording && preRecordCountdown === null && !recordedVideo && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: '20px',
              marginBottom: '30px',
            }}
          >
            <ParagraphRecordButton
              onClick={startRecording}
              disabled={remainingAttempts === 0}
            >
              Record
              <WhiteRecordIcon />
            </ParagraphRecordButton>
            <div
              style={{
                marginTop: '16px',
                fontSize: '16px',
              }}
            >
              You have{' '}
              <strong style={{ fontWeight: '800' }}>
                {remainingAttempts}{' '}
                {remainingAttempts === 1 ? 'chance' : 'chances'}
              </strong>{' '}
              left
            </div>
          </div>
        )}
      </Section>
    )
  }

  useEffect(() => {
    if (audioBlob && silentReadingTime > 0 && !paragraphReadingComplete) {
      const timer = setInterval(() => {
        setSilentReadingTime(prev => {
          if (prev <= 1) {
            clearInterval(timer)
            setParagraphReadingComplete(true)
            // Start the questions timer when silent reading ends
            setParagraphQuestionsTimerActive(true)
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => clearInterval(timer)
    }
  }, [audioBlob, silentReadingTime, paragraphReadingComplete])

  useEffect(() => {
    const style = document.createElement('style')
    style.innerHTML = `
    .blurred-content {
      filter: blur(6px);
    }
    .hidden-content {
      display: none;
    }
  `
    document.head.appendChild(style)

    return () => {
      document.head.removeChild(style)
      if (recordingTimer) {
        clearInterval(recordingTimer)
        recordingTimer = null
      }
    }
  }, [])

  const isSectionAnswered = section => {
    switch (section.type) {
      case 'Video Response':
        return recordedVideo !== null

      case 'Question Based Response':
        // Section is answered if user has written something and either time is up OR they have enough words
        const wordCount = countWords(questionBasedResponse)
        return questionBasedResponse.trim().length >= 50 && (questionBasedTimeUp || wordCount >= 60)

      case 'Email Writing':
        return emailWritingResponse.trim().length > 0;
      case 'Dictation':
        return section.questions?.every(q => dictationAnswers[q.id]?.trim().length > 0)

      case 'Sentence Completion':
        return section.questions?.every(q => sentenceCompletionAnswers[q.id]?.trim().length > 0)

      case 'Sentence Build':
        return section.questions?.some((q, qIdx) => {
          if (q.jumbledWords && !q.jumbledWords.startsWith('[')) {
            return selectedWords[qIdx] && selectedWords[qIdx].length > 0
          } else if (q.jumbledWords && q.jumbledWords.startsWith('[')) {
            return paragraphOrder[qIdx] && paragraphOrder[qIdx].length > 0
          }
          return false
        })

      case 'Paragraph Reading':
        const hasAudio = audioBlob !== null
        // Check if all questions are answered
        const hasAnswers = section.questions?.length > 0
          ? section.questions.every(q => {
            const response = getResponseValue(section.questionId, q.id)
            return response !== null && response !== undefined && response !== ''
          })
          : true // If no questions, just check audio
        return hasAudio && hasAnswers

      case 'Audio Question':
        return section.questions?.every(q => {
          const response = getResponseValue(section.questionId, q.id)
          return response !== null && response !== undefined && response !== ''
        })

      default:
        return false
    }
  }

  useEffect(() => {
    return () => {
      if (questionBasedTimerRef.current) {
        clearInterval(questionBasedTimerRef.current)
      }
      if (paragraphQuestionsTimerRef.current) {
        clearInterval(paragraphQuestionsTimerRef.current)
      }
      if (audioQuestionsTimerRef.current) {
        clearInterval(audioQuestionsTimerRef.current)
      }
      if (imageResponseTimerRef.current) {
        clearInterval(imageResponseTimerRef.current)
      }
      if (emailWritingTimerRef.current) {
        clearInterval(emailWritingTimerRef.current)
      }
      if (dictationTimerRef.current) {
        clearInterval(dictationTimerRef.current)
      }
      if (sentenceCompletionTimerRef.current) {
        clearInterval(sentenceCompletionTimerRef.current)
      }
      if (sentenceBuildTimerRef.current) {
        clearInterval(sentenceBuildTimerRef.current)
      }
    }
  }, [])


  const completedSections = () => {
    return questions.filter(section => isSectionAnswered(section)).length
  }

  const calculateProgress = () => {
    if (!questions || questions.length === 0) return 0
    const completed = completedSections()
    return Math.round((completed / questions.length) * 100)
  }

  const isAssessmentComplete = () => {
    return questions.every(section => isSectionAnswered(section))
  }

  useEffect(() => {
    if (recording) {
      setRemainingRecordingTime(MAX_RECORDING_TIME)
      setMinRecordingReached(false)

      timerRef.current = setInterval(() => {
        setRemainingRecordingTime(prev => {
          if (prev === MAX_RECORDING_TIME - MIN_RECORDING_TIME) {
            setMinRecordingReached(true)
          }
          // If timer reaches 0, stop recording immediately
          if (prev === 0) {
            if (mediaRecorder && mediaRecorder.state !== 'inactive') {
              mediaRecorder.stop()
            }
            setRecording(false) // Ensure UI updates
            clearInterval(timerRef.current)
            timerRef.current = null
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => {
        if (timerRef.current) {
          clearInterval(timerRef.current)
          timerRef.current = null
        }
      }
    }
  }, [recording, mediaRecorder])

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
      }
      // NEW: Cleanup full-page mode on unmount
      if (isFullPageMode) {
        restoreLayoutElements()
      }
    }
    // NOTE: camera/proctor teardown intentionally NOT here. This effect re-runs
    // on every `stream`/`isFullPageMode` change; tearing the camera down here
    // killed the single SHARED proctoring+recording stream mid-assessment (and
    // stopped proctoring during a video recording). Camera is released only on
    // real unmount — see the [] effect below.
  }, [stream, isFullPageMode])

  // Release the shared proctoring/recording camera only on real unmount (end of
  // assessment), never on a `stream`/fullscreen change.
  useEffect(() => {
    return () => {
      if (captureInterval.current) {
        clearTimeout(captureInterval.current)
        captureInterval.current = null
      }
      try {
        if (window.proctorStreamTracks) {
          window.proctorStreamTracks.forEach(t => { try { t.stop() } catch (e) {} })
          window.proctorStreamTracks = []
        }
      } catch (e) {}
      try {
        if (captureRef.current && captureRef.current.srcObject) {
          captureRef.current.srcObject.getTracks().forEach(t => { try { t.stop() } catch (e) {} })
        }
        captureRef.current = null
      } catch (e) {}
    }
  }, [])

  // Ensure video stream is attached to video element when stream is available
  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream
    }
  }, [stream, recording, preRecordCountdown])

  const beginRecording = async () => {
    try {
      setRemainingRecordingTime(MAX_RECORDING_TIME)
      setRecording(true)
      recordingRef.current = true
      interruptedRecordingRef.current = false

      // SHARED STREAM: record from the SAME live proctoring stream — do NOT stop
      // proctoring and do NOT open a second camera (fails on mobile). Proctoring
      // keeps capturing snapshots throughout the recording. Camera is released
      // only at assessment end (unmount). The proctor stream is video+audio.
      let mediaStream = captureRef.current && captureRef.current.srcObject
      const hasLiveVideo = mediaStream && mediaStream.getVideoTracks().some(t => t.readyState === 'live')
      if (!hasLiveVideo) {
        // proctoring not up yet — acquire one shared (video+audio) stream and reuse it
        mediaStream = await getUserMediaWithSelectedDevices({
          video: { width: { ideal: 640 }, height: { ideal: 480 }, facingMode: 'user' },
          audio: { sampleRate: 44100, channelCount: 1, echoCancellation: true, noiseSuppression: true },
        })
        if (!captureRef.current) {
          captureRef.current = document.createElement('video')
          mountHiddenProctorVideo(captureRef.current)
          captureRef.current.srcObject = mediaStream
          captureRef.current.autoplay = true
          captureRef.current.muted = true
          await captureRef.current.play().catch(() => {})
          if (!window.proctorStreamTracks) window.proctorStreamTracks = []
          mediaStream.getTracks().forEach(t => window.proctorStreamTracks.push(t))
          proctoringActive.current = true
          if (!captureInterval.current) setupProctoringInterval()
        }
      }

      setStream(mediaStream)

      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream
      }

      // Check for supported MIME types (prioritize webm then mp4)
      const mimeTypes = [
        'video/webm;codecs=vp8,opus',
        'video/webm',
        'video/mp4',
        'video/mp4;codecs=avc1', // H.264
      ];

      let selectedMimeType = '';
      for (const type of mimeTypes) {
        if (typeof MediaRecorder.isTypeSupported === 'function' && MediaRecorder.isTypeSupported(type)) {
          selectedMimeType = type;
          break;
        }
      }

      console.log(`📹 Using MIME type: ${selectedMimeType || 'default(unknown)'}`);

      // Use lower bitrate for smaller file size (500 kbps video)
      const recorderOptions = {
        videoBitsPerSecond: 500000, // 500 kbps for video
        audioBitsPerSecond: 64000   // 64 kbps for audio
      };

      if (selectedMimeType) {
        recorderOptions.mimeType = selectedMimeType;
      }

      // Fallback if codec not supported
      let recorder;
      try {
        recorder = new MediaRecorder(mediaStream, selectedMimeType ? recorderOptions : undefined);
      } catch (e) {
        console.log('Falling back to default MediaRecorder options due to error:', e);
        recorder = new MediaRecorder(mediaStream);
      }
      setMediaRecorder(recorder)
      activeRecorderRef.current = recorder

      recorder.ondataavailable = e => {
        if (e.data.size > 0) {
          chunks.current.push(e.data)
        }
      }

      recorder.onstop = () => {
        const wasInterrupted = interruptedRecordingRef.current
        interruptedRecordingRef.current = false
        recordingRef.current = false
        activeRecorderRef.current = null

        if (wasInterrupted) {
          // iPhone: iOS suspended the camera mid-recording (tab/app switch), so
          // this take is partial/corrupt — discard it and reset to the ready-to-
          // record state. Don't burn an attempt or upload anything; the re-entry
          // warning already told the candidate they left the screen.
          console.log('🎥 [VIDEO] Recording interrupted by background; discarding partial take')
          chunks.current = []
          setRecordedVideo(null)
          setVideoBlob(null)
        } else {
          // Use the actual mimeType from the recorder if possible, else fallback to selected or webm
          const finalMimeType = recorder.mimeType || selectedMimeType || 'video/webm';
          console.log(`📦 Creating blob with type: ${finalMimeType}`);

          const blob = new Blob(chunks.current, { type: finalMimeType })
          const url = URL.createObjectURL(blob)
          setRecordedVideo(url)
          chunks.current = []
          setRemainingAttempts(prev => prev - 1)

          // Log the blob size for debugging
          console.log(`📹 [VIDEO] Recorded video size: ${(blob.size / 1024 / 1024).toFixed(2)} MB`);

          setVideoBlob(blob)

          const videoResponseSection = questions.find(
            section => section.type === 'Video Response'
          )
          const assessmentId =
            currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id

          if (videoResponseSection && blob && assessmentId) {
            console.log(
              '🎥 [VIDEO_IMMEDIATE] Uploading video blob immediately after recording'
            )
            // Capture the in-flight upload promise so handleSubmit can await it.
            inflightVideoUploadRef.current = dispatch(
              uploadVideoResponse(blob, videoResponseSection.questionId, assessmentId)
            )
            console.log(
              '✅ [VIDEO_IMMEDIATE] Video upload dispatched (backend will store in DB)'
            )
          }
        }

        // SHARED STREAM: do NOT stop any tracks — this IS the live proctoring
        // stream and must stay alive (proctoring kept capturing throughout the
        // recording). Nothing to restart. setStream(null) only clears the
        // preview state; the cleanup effect is guarded not to stop this stream.
        setStream(null)
        setRecording(false)
      }

      recorder.start()
      //console.log("Video recording started - proctoring should continue")
    } catch (err) {
      console.error('Error accessing camera:', err)
      setRecording(false)
      recordingRef.current = false
      activeRecorderRef.current = null
      interruptedRecordingRef.current = false

      // Resume proctoring if recording failed to start
      console.log('↩️ [RECORD_FAIL] Resuming proctoring after failed recording start');
      proctoringActive.current = true;
      if (
        !captureInterval.current &&
        currentAssessment?.allowProctoring !== false &&
        timerStarted &&
        !isCompleted
      ) {
        setupProctoringInterval();
      }

      if (err.name === 'NotReadableError' || err.name === 'TrackStartError') {
        alert('Camera may be in use. Please try again momentarily.');
      } else if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
        alert('Camera permission denied. Please allow camera access in your browser settings.');
      } else {
        alert('Error accessing camera. Please check your camera permissions and try again.');
      }
    }
  }

  // Pre-roll: show the live preview with a 3-2-1 count before capture starts, so
  // the candidate isn't recorded mid-fidget the instant they hit Record.
  const startRecording = () => {
    if (preRecordCountdown !== null || recording) return
    const liveStream = captureRef.current && captureRef.current.srcObject
    if (liveStream && liveStream.getVideoTracks().some(t => t.readyState === 'live')) {
      setStream(liveStream)
    }
    setPreRecordCountdown(3)
  }

  useEffect(() => {
    if (preRecordCountdown === null) return
    if (preRecordCountdown === 0) {
      setPreRecordCountdown(null)
      beginRecording()
      return
    }
    const tick = setTimeout(() => setPreRecordCountdown(prev => prev - 1), 1000)
    return () => clearTimeout(tick)
  }, [preRecordCountdown])

  const stopRecording = async () => {
    if (mediaRecorder && mediaRecorder.state !== 'inactive') {
      mediaRecorder.stop()
    }
  }

  const handleCloseModal = () => {
    setIsModalVisible(false)
  }

  const handleAudioComplete = sectionId => {
    setCompletedAudioSections(prev => [...prev, sectionId]);
    setShowAudioCompleteModal(true); // Show modal after audio finishes
  };
  const handleAudioContinue = () => {
    setShowAudioCompleteModal(false);
    setAudioReplayRequested(false);
    setAudioQuestionsTimerActive(true); // Start timer for questions
  };

  const handleAudioReplay = () => {
    setShowAudioCompleteModal(false);
    setAudioReplayRequested(true);
    // Reset completed state to allow replay
    setCompletedAudioSections(prev => prev.filter(id => id !== currentSection.questionId));
  };
  const handleAudioProgress = (sectionId, currentTime) => {
    setAudioPositions(prev => ({
      ...prev,
      [sectionId]: currentTime,
    }))
  }

  const handleConfirmDelete = () => {
    deleteRecording()
    setIsModalVisible(false)
    setShowSuccessModal(true)
  }

  const handleDeleteClick = () => {
    setIsModalVisible(true)
  }

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false)
  }

  const deleteRecording = () => {
    if (recordedVideo) {
      URL.revokeObjectURL(recordedVideo)
      setRecordedVideo(null)
    }
    setVideoBlob(null)
  }


  // Save Email Writing Response
  const handleEmailDataChange = (field, value) => {
    setEmailData(prev => ({ ...prev, [field]: value }))
  }

  const handleEmailWritingResponseChange = (value) => {
    setEmailWritingResponse(value)
  }

  // Update the question based response handler
  const handleQuestionBasedResponseChange = (value) => {
    setQuestionBasedResponse(value)
  }

  // Update the dictation answer handler
  const handleDictationAnswerChange = (questionId, value) => {
    setDictationAnswers(prev => ({ ...prev, [questionId]: value }))
  }

  // Update the sentence completion handler
  const handleSentenceCompletionChange = (questionId, value) => {
    setSentenceCompletionAnswers(prev => ({ ...prev, [questionId]: value }))
  }



  const handleSentenceBuildChange = async (questionIndex, data, type) => {
    // Just update the local state without auto-saving
    if (type === 'word-arrangement') {
      const updatedSelectedWords = [...(selectedWords || [])];
      updatedSelectedWords[questionIndex] = data;
      setSelectedWords(updatedSelectedWords);
    } else if (type === 'paragraph-ordering') {
      const updatedParagraphOrder = [...(paragraphOrder || [])];
      updatedParagraphOrder[questionIndex] = data;
      setParagraphOrder(updatedParagraphOrder);
    }
    // Auto-save functionality removed
  }

  // Add helper functions to get the actual arranged content
  const getArrangedSentenceFromIndices = (questionIndex, indices) => {
    const questions = currentSection.questions || [];
    const currentQ = questions[questionIndex];
    if (!currentQ) return '';

    if (currentQ.type === 'unknown' || currentQ.type === 'word_arrangement') {
      // ...existing code for word arrangement...
      const rawWords = (currentQ.jumbledWords || '')
        .split(/[,\s]+/)
        .filter(word => word.trim() !== '');
      const processedWords = rawWords.map(word =>
        word.toLowerCase().replace(/[^\w\s]/g, '')
      ).filter(word => word.trim() !== '');

      const questionKey = `${currentPage}-${currentQ.id}`;
      const shuffledIndices = shuffledWords[questionKey] || processedWords.map((_, i) => i);

      if (!indices || indices.length === 0) {
        return processedWords.join(' ');
      }

      const userOrder = indices.map(idx => shuffledIndices[idx]);
      return userOrder.map(i => processedWords[i]).join(' ');
    }
    else if (currentQ.type === 'sentence_rearrangement') {
      // FIXED: Backend sends array of sentences - just use them directly!
      const sentences = currentQ.jumbledSentences;

      if (!Array.isArray(sentences)) {
        console.error('❌ jumbledSentences is not an array:', sentences);
        return '';
      }

      // If user has arranged sentences, show their arrangement
      if (indices && indices.length > 0) {
        return indices
          .map(index => sentences[index])
          .filter(s => s)
          .join(' '); // Just join with space - sentences already have punctuation
      }

      // If no arrangement yet, show original order
      return sentences.join(' ');
    }

    return '';
  };
  useEffect(() => {
    if (
      currentSection.type === 'Paragraph Reading' &&
      audioRecording &&
      audioRecordingDuration >= PARAGRAPH_READING_MAX_TIME
    ) {
      stopAudioRecording();
    }
  }, [audioRecordingDuration, audioRecording, currentSection.type]);


  const startAudioRecording = async () => {
    try {
      console.log("🎙️ [AUDIO_START] Starting audio recording");

      // SHARED STREAM: reuse the SAME mic as the live proctoring stream — clone
      // its audio track instead of opening a second mic (a 2nd getUserMedia can
      // glitch/silence the voice recording, esp. iOS). The clone is independent,
      // so stopping it never affects proctoring. Falls back to its own mic if
      // proctoring is off.
      const sharedAudioTrack = captureRef.current && captureRef.current.srcObject
        ? captureRef.current.srcObject.getAudioTracks().find(t => t.readyState === 'live')
        : null;
      const stream = sharedAudioTrack
        ? new MediaStream([sharedAudioTrack.clone()])
        : await getUserMediaWithSelectedDevices({ audio: true });

      setAudioStream(stream);

      // Pick a recordable container — iOS Safari only supports audio/mp4 and
      // throws on audio/webm, so negotiate instead of hard-coding.
      const selectedAudioMime = pickAudioMimeType();
      let recorder;
      try {
        recorder = new MediaRecorder(
          stream,
          selectedAudioMime ? { mimeType: selectedAudioMime } : undefined
        );
      } catch (e) {
        recorder = new MediaRecorder(stream);
      }

      setAudioRecorder(recorder);
      audioChunks.current = [];

      // Handle data availability
      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) {
          audioChunks.current.push(e.data);
        }
      };

      // Start recording
      recorder.start();
      setAudioRecording(true);
      setAudioRecordingDuration(0);

      // Start duration timer
      recordingTimer = setInterval(() => {
        setAudioRecordingDuration(prev => {
          const newDuration = prev + 1;

          // Auto-stop at max time (2.5 minutes)
          if (newDuration >= PARAGRAPH_READING_MAX_TIME) {
            stopAudioRecording();
            return PARAGRAPH_READING_MAX_TIME;
          }

          return newDuration;
        });
      }, 1000);

      console.log("✅ [AUDIO_START] Recording started successfully");
    } catch (error) {
      console.error("❌ [AUDIO_START] Failed to start recording:", error);
      alert("Failed to access microphone. Please check your microphone permissions and try again.");
      setAudioRecording(false);
    }
  };

  const stopAudioRecording = async () => {
    // FIXED: Store the current duration before clearing the timer
    let finalDuration = audioRecordingDuration;

    if (recordingTimer) {
      clearInterval(recordingTimer)
      recordingTimer = null
    }

    if (audioRecorder && audioRecorder.state !== 'inactive') {
      audioRecorder.stop()
      audioStream.getTracks().forEach(track => track.stop())
      setAudioRecording(false)

      // ADDED: Wait for the audio blob to be created and upload immediately
      audioRecorder.onstop = async (e) => {
        // FIXED: Use the stored finalDuration instead of undefined currentRecordingDuration
        const blob = new Blob(audioChunks.current, { type: resolveRecordedMimeType(audioRecorder, null, null, 'audio/webm') })
        setAudioBlob(blob)

        if (audioBlobUrl) {
          URL.revokeObjectURL(audioBlobUrl)
        }

        const url = URL.createObjectURL(blob)
        setAudioBlobUrl(url)
        setAudioDuration(finalDuration) // FIXED: Use finalDuration
        setAudioRemainingAttempts(prev => prev - 1)
        setRecordingPositionBelow(false)

        // ADDED: Upload audio blob immediately to backend (fire-and-forget)
        const paragraphReadingSection = questions.find(section => section.type === 'Paragraph Reading');
        const assessmentId = currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id;

        if (paragraphReadingSection && blob && assessmentId) {
          console.log("🎵 [AUDIO_IMMEDIATE] Uploading audio blob immediately after recording");
          // Capture the in-flight upload promise so handleSubmit can await it.
          inflightAudioUploadRef.current = dispatch(
            uploadAudioResponse(blob, paragraphReadingSection.questionId, assessmentId)
          );
          console.log("✅ [AUDIO_IMMEDIATE] Audio upload dispatched (backend will store in DB)");
        }
      }
    }
  }

  useEffect(() => {
    if (audioRef.current && audioBlobUrl) {
      audioRef.current.currentTime = 0
      setAudioProgress(0)
    }
  }, [audioBlobUrl])

  useEffect(() => {
    return () => {
      if (audioBlobUrl) {
        URL.revokeObjectURL(audioBlobUrl)
      }
    }
  }, [audioBlobUrl])

  const formatRecordingTime = seconds => {
    if (!seconds || isNaN(seconds) || !isFinite(seconds)) {
      return '00:00'
    }
    const mins = Math.floor(seconds / 60)
    const secs = Math.floor(seconds % 60)
    return `${mins.toString().padStart(2, '0')}:${secs
      .toString()
      .padStart(2, '0')}`
  }


  const stopAllMediaStreams = () => {
    proctoringActive.current = false
    if (captureInterval.current) {
      clearTimeout(captureInterval.current)
      captureInterval.current = null
    }
    if (captureRef.current && captureRef.current.srcObject) {
      try {
        captureRef.current.srcObject.getTracks().forEach(track => track.stop())
      } catch (e) { /* noop */ }
      captureRef.current.srcObject = null
    }
    captureRef.current = null
    if (window.proctorStreamTracks) {
      window.proctorStreamTracks.forEach(track => {
        try { track.stop() } catch (e) { /* noop */ }
      })
      window.proctorStreamTracks = []
    }
    if (stream) {
      try { stream.getTracks().forEach(track => track.stop()) } catch (e) { /* noop */ }
    }
    if (audioStream) {
      try { audioStream.getTracks().forEach(track => track.stop()) } catch (e) { /* noop */ }
    }
  }

  const handleSubmit = async ({ force = false } = {}) => {
    // A click on Submit must obey the same mandatory-response rule as Next.
    // Forced submissions are reserved for the overall assessment deadline and
    // proctoring violations, where the candidate is no longer allowed to work.
    if (!force && !isCurrentSectionComplete()) {
      setErrorMessage('Please answer the current question before submitting');
      setShowError(true);
      setTimeout(() => setShowError(false), 3000);
      return;
    }

    console.log('🚀 [SUBMIT_START] Beginning submission process');
    console.log('📊 [SUBMIT_STATE] Current state:', {
      hasVideoBlob: !!videoBlob,
      hasAudioBlob: !!audioBlob,
      videoBlobSize: videoBlob?.size,
      audioBlobSize: audioBlob?.size,
      currentPage,
      questionsLength: questions.length
    });

    setIsSubmitting(true);

    // Flush any in-progress media recordings BEFORE killing streams.
    // On auto-submit (timer expiry mid-recording), recorder.onstop never
    // fires because stopAllMediaStreams() kills the underlying tracks first,
    // so the blob is never built and the upload dispatch never fires.
    // We stop active recorders here and await their onstop (which builds
    // the blob and dispatches the background upload via uploadVideoResponse
    // / uploadAudioResponse). The backend stitches by questionId regardless
    // of when the upload arrives.
    const recordersToFlush = [
      ['video', mediaRecorder],
      ['audio', audioRecorder],
    ].filter(([, r]) => r && r.state === 'recording');
    if (recordersToFlush.length > 0) {
      console.log(`🎥 [SUBMIT_FLUSH] Flushing ${recordersToFlush.length} active recorder(s) before stream teardown`);
      const submitAssessmentId = currentAssessment?.assessment_assigned_id || assessment?.assessment_assigned_id;
      await Promise.all(
        recordersToFlush.map(([kind, recorder]) =>
          new Promise(resolve => {
            const previousOnStop = recorder.onstop;
            recorder.onstop = async (event) => {
              try {
                if (typeof previousOnStop === 'function') {
                  await previousOnStop.call(recorder, event);
                } else if (kind === 'audio') {
                  // audioRecorder.onstop is only wired up inside
                  // stopAudioRecording, so auto-submit mid-recording reaches
                  // here with no handler. Do the blob-build + upload
                  // ourselves so the audio isn't lost.
                  const blob = new Blob(audioChunks.current, { type: resolveRecordedMimeType(recorder, null, null, 'audio/webm') });
                  const paragraphReadingSection = questions.find(s => s.type === 'Paragraph Reading');
                  if (paragraphReadingSection && blob.size > 0 && submitAssessmentId) {
                    console.log('🎵 [SUBMIT_FLUSH] Auto-submitting audio blob from mid-recording');
                    inflightAudioUploadRef.current = dispatch(
                      uploadAudioResponse(blob, paragraphReadingSection.questionId, submitAssessmentId)
                    );
                    setAudioBlob(blob);
                  }
                }
              } catch (e) {
                console.error(`🎥 [SUBMIT_FLUSH] ${kind} onstop failed:`, e);
              } finally {
                resolve();
              }
            };
            try {
              recorder.stop();
            } catch (e) {
              console.error(`🎥 [SUBMIT_FLUSH] ${kind} recorder.stop() failed:`, e);
              resolve();
            }
          })
        )
      );
      console.log('🎥 [SUBMIT_FLUSH] All active recordings finalized');
    }

    // Await any in-flight upload HTTP requests (from this submit's flush
    // OR from the user's earlier manual stop that may not have completed
    // by the time auto-submit fired). uploadVideoResponse/uploadAudioResponse
    // now return a Promise that resolves after the HTTP upload settles.
    const inflightUploads = [
      inflightVideoUploadRef.current,
      inflightAudioUploadRef.current,
    ].filter(p => p && typeof p.then === 'function');
    if (inflightUploads.length > 0) {
      console.log(`📤 [SUBMIT_FLUSH] Awaiting ${inflightUploads.length} in-flight upload(s) to settle`);
      await Promise.allSettled(inflightUploads);
      console.log('📤 [SUBMIT_FLUSH] All in-flight uploads settled');
    }

    stopAllMediaStreams();

    // Get the assessment ID
    const assessmentId = currentAssessment?.assessment_assigned_id ||
      assessment?.assessment_assigned_id ||
      location.state?.assessmentData?.assessment_assigned_id ||
      location.state?.assessment_assigned_id;

    if (!assessmentId) {
      console.error('❌ [SUBMIT_ERROR] Assessment ID resolution failed:', {
        currentAssessment: currentAssessment,
        assessment: assessment,
        locationState: location.state
      });
      alert('No valid assessment ID found for submission');
      setIsSubmitting(false);
      return;
    }

    console.log('✅ [SUBMIT_ID] Assessment ID found:', assessmentId);

    try {
      // Save current responses synchronously
      console.log('💾 [SUBMIT_SAVE] Saving current section responses...');
      await saveCurrentSectionResponses(assessmentId);
      console.log('✅ [SUBMIT_SAVE] Current responses saved');

      // ADDED: Check sessionStorage to see if media was already uploaded
      const videoAlreadyUploaded = sessionStorage.getItem('assessment_video_uploaded') === 'true';
      const audioAlreadyUploaded = sessionStorage.getItem('assessment_audio_uploaded') === 'true';

      console.log('📊 [SUBMIT_STATE] Media upload status:', {
        hasVideoBlob: !!videoBlob,
        hasAudioBlob: !!audioBlob,
        videoAlreadyUploaded,
        audioAlreadyUploaded,
        videoBlobSize: videoBlob?.size,
        audioBlobSize: audioBlob?.size
      });

      // Fire media uploads if needed (fire-and-forget, backend stores in DB directly)
      // These will complete in background - no need to wait

      // Track any defensive re-uploads here so we can await them below.
      const defensiveUploadPromises = [];

      if (videoBlob && !videoAlreadyUploaded) {
        console.log("🎥 [VIDEO_UPLOAD_START] Dispatching video upload");
        const videoResponseSection = questions.find(section => section.type === 'Video Response');
        if (videoResponseSection) {
          const p = dispatch(uploadVideoResponse(videoBlob, videoResponseSection.questionId, assessmentId));
          if (p && typeof p.then === 'function') defensiveUploadPromises.push(p);
          console.log("✅ [VIDEO_UPLOAD_DISPATCHED] Backend will store in DB");
        }
      } else if (videoAlreadyUploaded) {
        console.log("✅ [VIDEO_SKIP] Video already uploaded");
      } else {
        console.log("ℹ️ [VIDEO_SKIP] No video blob to upload");
      }

      if (audioBlob && !audioAlreadyUploaded) {
        console.log("🎵 [AUDIO_UPLOAD_START] Dispatching audio upload");
        const paragraphReadingSection = questions.find(section => section.type === 'Paragraph Reading');
        if (paragraphReadingSection) {
          const p = dispatch(uploadAudioResponse(audioBlob, paragraphReadingSection.questionId, assessmentId));
          if (p && typeof p.then === 'function') defensiveUploadPromises.push(p);
          console.log("✅ [AUDIO_UPLOAD_DISPATCHED] Backend will store in DB");
        }
      } else if (audioAlreadyUploaded) {
        console.log("✅ [AUDIO_SKIP] Audio already uploaded");
      } else {
        console.log("ℹ️ [AUDIO_SKIP] No audio blob to upload");
      }

      // Wait for the defensive re-uploads to settle so the assessment
      // submission carries their server-side acknowledgement.
      if (defensiveUploadPromises.length > 0) {
        console.log(`⏳ [SUBMIT] Awaiting ${defensiveUploadPromises.length} defensive upload(s) to settle...`);
        await Promise.allSettled(defensiveUploadPromises);
        console.log("✅ [SUBMIT] Defensive uploads settled");
      } else {
        // Preserve the original 500ms breathing room for any background dispatch.
        await new Promise(resolve => setTimeout(resolve, 500));
      }
      console.log("✅ [SUBMIT] Proceeding with assessment submission");

      // FIXED: Get the latest state after uploads complete using useStore hook
      console.log("📊 [STATE_FETCH] Fetching latest Redux state...");
      const getLatestState = () => {
        const latestState = store.getState();
        return latestState.assessment.currentAssessment;
      };

      const latestAssessmentState = getLatestState() || currentAssessment || assessment;
      const allResponses = latestAssessmentState?.responses || {};

      console.log("📋 [STATE_RESPONSES] Latest responses after uploads:", {
        hasVideoResponse: !!allResponses.videoResponse,
        videoResponseCount: allResponses.videoResponse?.length || 0,
        hasAudioResponse: !!allResponses.paragraphReading,
        audioResponseCount: allResponses.paragraphReading?.length || 0,
        allResponseKeys: Object.keys(allResponses)
      });

      // ADDED: Verify that video and audio URLs are present
      if (videoBlob && (!allResponses.videoResponse || allResponses.videoResponse.length === 0)) {
        console.warn("⚠️ [VIDEO_VERIFY] Video was uploaded but not found in responses, waiting longer...");
        await new Promise(resolve => setTimeout(resolve, 2000));
        const retryState = getLatestState();
        if (retryState?.responses) {
          console.log("🔄 [VIDEO_RETRY] Retried state fetch:", {
            hasVideoResponse: !!retryState.responses.videoResponse,
            videoResponseCount: retryState.responses.videoResponse?.length || 0
          });
          Object.assign(allResponses, retryState.responses);
        }
      }

      if (audioBlob && (!allResponses.paragraphReading || allResponses.paragraphReading.length === 0)) {
        console.warn("⚠️ [AUDIO_VERIFY] Audio was uploaded but not found in responses, waiting longer...");
        await new Promise(resolve => setTimeout(resolve, 2000));
        const retryState = getLatestState();
        if (retryState?.responses) {
          console.log("🔄 [AUDIO_RETRY] Retried state fetch:", {
            hasAudioResponse: !!retryState.responses.paragraphReading,
            audioResponseCount: retryState.responses.paragraphReading?.length || 0
          });
          Object.assign(allResponses, retryState.responses);
        }
      }

      // Build submission payload with ALL responses
      const submissionPayload = {
        assessment_assigned_id: assessmentId,
        full_name: studentDetails?.full_name || studentDetails?.name || 'Student',
        totalTakenTime: calculateTotalTime(),
        response: allResponses,
        isAutoSubmitted: isAutoSubmittedRef.current,
      };

      console.log("📤 [PAYLOAD_BUILD] Final submission payload:", {
        assessmentId: submissionPayload.assessment_assigned_id,
        fullName: submissionPayload.full_name,
        totalTakenTime: submissionPayload.totalTakenTime,
        responseKeys: Object.keys(submissionPayload.response),
        hasVideoResponse: !!submissionPayload.response.videoResponse,
        videoResponseData: submissionPayload.response.videoResponse,
        hasAudioResponse: !!submissionPayload.response.paragraphReading,
        audioResponseData: submissionPayload.response.paragraphReading
      });

      console.log('🚀 [SUBMIT_FINAL] Submitting to backend:', submissionPayload);

      if (isPractice) {
        await dispatch(submitPracticeAssessment(submissionPayload));
      } else {
        await dispatch(submitAssessment(submissionPayload));
      }

      console.log('✅ [SUBMIT_SUCCESS] Submission completed successfully');

      // ADDED: Clear session storage after successful submission
      sessionStorage.removeItem('assessment_video_uploaded');
      sessionStorage.removeItem('assessment_audio_uploaded');

      // Duplicate trackAssessmentCompleted with wrong arg order removed — correct call is after submission completes

      const timeTaken = assessmentStartTime ? (new Date() - assessmentStartTime) / 1000 : totalDurationSeconds - timeLeft;
      console.log("⏱️ [TIME_TAKEN] Assessment time:", timeTaken, "seconds");

      if (currentAssessment.title === "Assessment #1" || currentAssessment.title === "Assessment #2") {
        const diagnosisNumber = 2 - currentAssessment.CommunicationDiagnosisRemain + 1;
        console.log("📊 [DIAGNOSIS] Tracking diagnosis completion:", diagnosisNumber);
        trackDiagnosisCompleted(diagnosisNumber, null, timeTaken, currentAssessment.assessment_assigned_id, currentAssessment.type, currentAssessment.entityName);
        trackDiagnosisProgressUpdated(
          currentAssessment.assessment_assigned_id,
          currentAssessment.type,
          diagnosisNumber, 2 - diagnosisNumber, currentAssessment.entityName)

        if (diagnosisNumber === 2) {
          console.log("🎓 [PRACTICE_UNLOCK] Unlocking practice mode");
          trackPracticeUnlocked(currentAssessment.type)
        }
      }
      if (currentAssessment.isPractice === "true" || currentAssessment.isPractice === true) {
        trackPracticeSessionCompleted(currentAssessment.assessment_assigned_id, currentAssessment.type, timeTaken);
      }

      // Mark as completed
      setFinalSubmittedTime(timeLeft);
      setCompletedAssessmentData(latestAssessmentState);
      setIsCompleted(true);
      setShowViolationModal(false);
      setShowReentryModal(false);
      setIsFullPageMode(false);
      setIsSubmitting(false);

      console.log("🎉 [SUBMIT_COMPLETE] Assessment submission completed successfully");
      trackAssessmentCompleted(timeTaken, currentAssessment.assessment_assigned_id, currentAssessment.type, currentAssessment.isCorporate, currentAssessment.entityName);
    } catch (error) {
      console.error('❌ [SUBMIT_ERROR] Submit assessment error:', error);
      console.error('❌ [SUBMIT_ERROR_STACK]', error.stack);
      alert(`Failed to submit assessment: ${error.message}. Please try again.`);
      setIsSubmitting(false);
    }
  }




  // Helper function to save current section responses
  const saveCurrentSectionResponses = (assessmentId) => {
    // Save current Question Based Response if we're on that section and haven't saved yet
    if (currentSection.type === 'Question Based Response' && questionBasedResponse.trim()) {
      try {
        console.log('💾 [SUBMIT] Saving Question Based Response on submit:', questionBasedResponse.trim());

        // FIXED: Just save the text response without subQuestionId structure
        dispatch(saveQuestionResponse(
          currentSection.questionId,
          questionBasedResponse.trim(),
          assessmentId,
          null, // No subQuestionId needed
          'questionBasedResponse' // Correct section type
        ));
        console.log('✅ [SUBMIT] Question Based Response dispatched successfully');
      } catch (error) {
        console.error('❌ [SUBMIT] Error saving question based response:', error);
      }
    }


    // Save current Sentence Build Response if we're on that section
    if (currentSection.type === 'Sentence Build') {
      const sentenceBuildQuestions = currentSection.questions || [];
      const questionIndex = sentenceBuildCurrentIndex;
      const currentQ = sentenceBuildQuestions[questionIndex];

      if (currentQ && assessmentId) {
        let arrangedContent = '';

        // UPDATED: Handle the backend type field properly
        // UPDATED: Handle the backend type field properly
        if (currentQ.type === 'unknown' || currentQ.type === 'word_arrangement') {
          // Word arrangement - get the actual arranged sentence
          arrangedContent = generateArrangedSentence(currentQ, selectedWords[questionIndex]);
        } else if (currentQ.type === 'sentence_rearrangement') {
          // Sentence rearrangement - get the actual arranged paragraph
          arrangedContent = generateArrangedSentence(currentQ, paragraphOrder[questionIndex]);
        }

        if (arrangedContent && arrangedContent.trim()) {
          try {
            console.log('💾 [SUBMIT] Saving sentence build response on submit:', arrangedContent.trim());
            dispatch(saveQuestionResponse(
              currentSection.questionId,
              arrangedContent.trim(), // Save the actual arranged content, not indices
              assessmentId,
              currentQ.id,
              'sentenceBuild'
            ));
            console.log('✅ [SUBMIT] Sentence build response dispatched successfully');
          } catch (error) {
            console.error('❌ [SUBMIT] Error saving sentence build response:', error);
          }
        }
      }
    }

    // Save Email Writing Response
    if (currentSection.type === 'Email Writing' && emailWritingResponse.trim()) {
      try {
        dispatch(saveQuestionResponse(
          currentSection.questionId,
          `Subject: ${emailData.subject}\n${emailWritingResponse.trim()}`,
          assessmentId,
          null,
          'emailWriting'
        ));
        console.log('✅ [SUBMIT] Email writing response dispatched successfully');
      } catch (error) {
        console.error('Error saving email writing response on submit:', error);
      }
    }

    // Return a resolved promise since we're not waiting for the dispatch results
    return Promise.resolve();
  }

  // FIXED: Calculate total time function
  const calculateTotalTime = () => {
    const startTime = (currentAssessment || assessment)?.startTime || Date.now()
    const currentTime = Date.now()
    return Math.floor((currentTime - startTime) / 1000) // in seconds
  }



  // Helper functions to collect responses from each section type
  const collectQuestionBasedResponses = () => {
    const responses = []
    questions.forEach(section => {
      if (section.type === 'Question Based Response' && questionBasedResponse.trim()) {
        responses.push({
          questionId: section.questionId,
          answer: questionBasedResponse.trim()
        })
      }
    })
    return responses
  }

  const collectEmailWritingResponses = () => {
    const responses = []
    questions.forEach(section => {
      if (section.type === 'Email Writing' && emailWritingResponse.trim()) {
        responses.push({
          questionId: section.questionId,
          answer: `Subject: ${emailData.subject}\n${emailWritingResponse.trim()}`
        })
      }
    })
    return responses
  }

  const collectDictationResponses = () => {
    const responses = []
    questions.forEach(section => {
      if (section.type === 'Dictation' && Object.keys(dictationAnswers).length > 0) {
        responses.push({
          questionId: section.questionId,
          answers: dictationAnswers
        })
      }
    })
    return responses
  }

  const collectSentenceCompletionResponses = () => {
    const responses = []
    questions.forEach(section => {
      if (section.type === 'Sentence Completion' && Object.keys(sentenceCompletionAnswers).length > 0) {
        responses.push({
          questionId: section.questionId,
          answers: sentenceCompletionAnswers
        })
      }
    })
    return responses
  }

  const collectSentenceBuildResponses = () => {
    const responses = []
    questions.forEach((section, sectionIndex) => {
      if (section.type === 'Sentence Build') {
        const sectionAnswers = {}

        section.questions?.forEach((question, qIdx) => {
          let arrangedContent = '';

          // UPDATED: Handle the backend type field properly
          // UPDATED: Handle the backend type field properly
          if (question.type === 'unknown' || question.type === 'word_arrangement') {
            // Word arrangement - use jumbledWords field
            arrangedContent = generateArrangedSentence(question, selectedWords[qIdx]);
          } else if (question.type === 'sentence_rearrangement') {
            // Sentence rearrangement - use jumbledSentences field
            arrangedContent = generateArrangedSentence(question, paragraphOrder[qIdx]);
          }

          if (arrangedContent && arrangedContent.trim()) {
            sectionAnswers[question.id] = arrangedContent.trim();
          }
        })

        if (Object.keys(sectionAnswers).length > 0) {
          responses.push({
            questionId: section.questionId,
            answers: sectionAnswers
          })
        }
      }
    })
    return responses
  }

  useEffect(() => {
    if (videoBlob) {
      console.log('💾 [VIDEO_BLOB] Saving video blob to localStorage');
      // Store blob reference (we'll upload it later)
      sessionStorage.setItem('assessment_video_blob', 'true');
    }
  }, [videoBlob]);

  useEffect(() => {
    if (audioBlob) {
      console.log('💾 [AUDIO_BLOB] Saving audio blob to localStorage');
      sessionStorage.setItem('assessment_audio_blob', 'true');
    }
  }, [audioBlob]);


  // Update handleTimeUp to check if media was already uploaded
  const handleTimeUp = async () => {
    console.log('⏰ [TIMEUP_START] Timer expired, starting auto-submission');

    try {
      setTimeUp(true)
      setTimerPaused(true)
      proctoringActive.current = false

      if (captureInterval.current) {
        clearTimeout(captureInterval.current)
        captureInterval.current = null
      }

      if (captureRef.current && captureRef.current.srcObject) {
        captureRef.current.srcObject.getTracks().forEach(track => {
          if (track.readyState === 'live') {
            track.stop()
          }
        })
        captureRef.current.srcObject = null
      }

      // FIXED: Check sessionStorage to see if media was already uploaded
      const videoAlreadyUploaded = sessionStorage.getItem('assessment_video_uploaded') === 'true';
      const audioAlreadyUploaded = sessionStorage.getItem('assessment_audio_uploaded') === 'true';

      console.log('📊 [TIMEUP_STATE] Media upload status:', {
        hasVideoBlob: !!videoBlob,
        hasAudioBlob: !!audioBlob,
        videoAlreadyUploaded,
        audioAlreadyUploaded,
        videoBlobSize: videoBlob?.size,
        audioBlobSize: audioBlob?.size
      });

      const uploadPromises = [];

      // Only upload if NOT already uploaded
      if (videoBlob && !videoAlreadyUploaded) {
        console.log("🎥 [TIMEUP_VIDEO] Uploading video response before auto-submit...");
        const videoResponseSection = questions.find(section => section.type === 'Video Response');

        if (videoResponseSection) {
          const videoUploadPromise = dispatch(uploadVideoResponse(videoBlob, videoResponseSection.questionId));
          uploadPromises.push(videoUploadPromise);
        }
      } else if (videoAlreadyUploaded) {
        console.log("✅ [TIMEUP_VIDEO] Video already uploaded, skipping");
      } else {
        console.log("ℹ️ [TIMEUP_VIDEO] No video blob to upload");
      }

      // Only upload if NOT already uploaded
      if (audioBlob && !audioAlreadyUploaded) {
        console.log("🎵 [TIMEUP_AUDIO] Uploading audio response before auto-submit...");
        const paragraphReadingSection = questions.find(section => section.type === 'Paragraph Reading');

        if (paragraphReadingSection) {
          const audioUploadPromise = dispatch(uploadAudioResponse(audioBlob, paragraphReadingSection.questionId));
          uploadPromises.push(audioUploadPromise);
        }
      } else if (audioAlreadyUploaded) {
        console.log("✅ [TIMEUP_AUDIO] Audio already uploaded, skipping");
      } else {
        console.log("ℹ️ [TIMEUP_AUDIO] No audio blob to upload");
      }

      // Wait for uploads to complete
      if (uploadPromises.length > 0) {
        console.log(`⏳ [TIMEUP_WAIT] Waiting for ${uploadPromises.length} media uploads...`);
        const results = await Promise.allSettled(uploadPromises);
        console.log("📋 [TIMEUP_RESULTS]", results.map((r, i) => ({
          index: i,
          status: r.status,
          value: r.status === 'fulfilled' ? r.value : undefined,
          reason: r.status === 'rejected' ? r.reason : undefined
        })));
        console.log("✅ [TIMEUP_UPLOADS] Media uploads completed");

        console.log("⏳ [TIMEUP_STATE_WAIT] Waiting for state update (3s)...");
        await new Promise(resolve => setTimeout(resolve, 3000));
        console.log("✅ [TIMEUP_STATE_WAIT] Wait completed");
      }

      console.log("📤 [TIMEUP_SUBMIT] Calling handleSubmit()...");
      await handleSubmit({ force: true })
      console.log("✅ [TIMEUP_SUBMIT] Submission completed");

      // Clear session storage after successful submission
      sessionStorage.removeItem('assessment_video_uploaded');
      sessionStorage.removeItem('assessment_audio_uploaded');

      trackAssessmentAutoSubmitted(
        currentAssessment.assessment_assigned_id,
        null,
        'time-up',
        currentAssessment.type,
        currentAssessment.isCorporate,
        currentAssessment.entityName
      )
      exitFullPageMode()
      setIsCompleted(true)
      console.log("🎉 [TIMEUP_COMPLETE] Auto-submission completed successfully");
    } catch (error) {
      console.error('❌ [TIMEUP_ERROR] Auto-submit error:', error)
      console.error('❌ [TIMEUP_ERROR_STACK]', error.stack);
      exitFullPageMode()
      alert('Time is up! Assessment auto-submitted.')
      setIsCompleted(true)
    }
  }

  const formatTime = seconds => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`
  }

  // Simplified fullscreen initialization
  useEffect(() => {
    if (isPractice || autoStart) {
      setFullscreenPermissionGranted(true)
      setShowFullscreenModal(false)
      setTimerStarted(true)
      // NEW: Enter full-page mode for practice assessments
      enterFullPageMode()
    }
  }, [isPractice, autoStart])

  // Auto-activate assessment when proctoring is disabled (skip fullscreen modal)
  useEffect(() => {
    if (!proctoringEnabled && !isPractice && !autoStart) {
      setFullscreenPermissionGranted(true)
      setShowFullscreenModal(false)
      setTimerStarted(true)
    }
  }, [proctoringEnabled, isPractice, autoStart])

  // iPhone LITE mode: proctoring is ON but fullscreen cannot be enforced.
  // Auto-activate without showing the fullscreen entry modal so that camera
  // snapshots (gated on fullscreenPermissionGranted) and tab/app-switch
  // detection (gated on assessmentActiveRef -> isFullPageMode) still run.
  // enterFullPageMode() also requests element fullscreen, which simply no-ops
  // on iPhone Safari, but still flips isFullPageMode on and hides chrome.
  useEffect(() => {
    if (proctoringEnabled && !enforceFullscreen && !isPractice && !autoStart) {
      setFullscreenPermissionGranted(true)
      setShowFullscreenModal(false)
      setTimerStarted(true)
      enterFullPageMode()
    }
  }, [proctoringEnabled, enforceFullscreen, isPractice, autoStart])

  // FIXED: Proctoring setup with correct condition check
  useEffect(() => {
    if (
      !fullscreenPermissionGranted ||
      isCompleted ||
      !timerStarted ||
      currentAssessment?.allowProctoring === false // FIXED: Check for explicit false
    ) {
      proctoringActive.current = false
      return
    }

    //console.log("Setting up proctoring captures, recording state:", recording)
    proctoringActive.current = true
    setupProctoringInterval()
      ; (async () => {
        //console.log("Initial proctoring capture")
        try {
          const imageBlob = await captureImage()
          if (imageBlob) {
            await uploadProctorImage(imageBlob)
          }
        } catch (error) {
          console.error('Error in initial capture:', error)
        }
      })()

    return () => {
      //console.log("Cleaning up proctoring interval")
      proctoringActive.current = false
      if (captureInterval.current) {
        clearTimeout(captureInterval.current)
        captureInterval.current = null
      }
      if (captureRef.current && captureRef.current.srcObject) {
        captureRef.current.srcObject.getTracks().forEach(track => {
          if (track.readyState === 'live') {
            track.stop()
          }
        })
        captureRef.current.srcObject = null
      }
    }
  }, [
    fullscreenPermissionGranted,
    isCompleted,
    timerStarted,
    // recording, // REMOVED dependency to prevent race condition with startRecording
    currentAssessment?.allowProctoring,
  ])

  // FIXED: Capture image function with correct proctoring check
  const captureImage = async () => {
    if (currentAssessment?.allowProctoring === false) {
      console.log('Proctoring disabled, skipping capture')
      return null
    }

    if (capturingInProgress.current) {
      console.log('Capture already in progress, skipping this one')
      return null
    }

    capturingInProgress.current = true
    console.log('Starting proctoring capture, recording state:', recording)

    try {
      // Safety timeout to reset the lock if something fails
      const safetyClearTimeout = setTimeout(() => {
        if (capturingInProgress.current) {
          console.log('Safety timeout triggered - resetting capture lock')
          capturingInProgress.current = false
        }
      }, 20000)

      // During recording, we need a separate capture approach
      // During recording, we capture directly from the recording video element
      // This avoids opening a second stream which fails on mobile devices
      if (recording) {
        console.log('Attempting capture from videoRef during active recording')
        try {
          if (videoRef.current && videoRef.current.srcObject && !videoRef.current.paused && !videoRef.current.ended) {

            // Create canvas if needed (reuse existing check)
            if (!canvasRef.current) {
              canvasRef.current = document.createElement('canvas')
              canvasRef.current.width = 640  // Match recording resolution or close to it
              canvasRef.current.height = 480
            }

            const context = canvasRef.current.getContext('2d');
            context.drawImage(
              videoRef.current,
              0,
              0,
              canvasRef.current.width,
              canvasRef.current.height
            );

            // Get blob
            const blob = await new Promise(resolve => {
              canvasRef.current.toBlob(resolve, 'image/jpeg', 0.5)
            })

            clearTimeout(safetyClearTimeout)

            if (blob) {
              console.log('Successfully captured proctoring image from videoRef');
              setCaptureCounter(prev => prev + 1);
              capturingInProgress.current = false;
              return blob;
            }
          } else {
            console.log('VideoRef not ready for capture yet, skipping');
            capturingInProgress.current = false;
            clearTimeout(safetyClearTimeout);
            return null;
          }
        } catch (err) {
          console.error('Error in videoRef capture:', err)
          capturingInProgress.current = false
          clearTimeout(safetyClearTimeout)
          return null
        }

        capturingInProgress.current = false;
        clearTimeout(safetyClearTimeout);
        return null;
      }

      // Normal capture mode when not recording
      console.log('Capturing in normal mode (not recording)')

      // Create a new proctoring stream if needed
      if (!captureRef.current) {
        try {
          console.log('Creating new proctoring stream')
          // video+audio so the SAME stream can also feed the video-response
          // recorder + reading-audio (one shared camera — never a 2nd stream).
          const proctorStream = await getUserMediaWithSelectedDevices({
            video: { width: 640, height: 480 },
            audio: true,
          })

          captureRef.current = document.createElement('video')
          mountHiddenProctorVideo(captureRef.current)
          watchProctorTrack(proctorStream, () => {
            unmountProctorVideo(captureRef.current)
            captureRef.current = null
            window.proctorStreamTracks = []
          })
          captureRef.current.srcObject = proctorStream
          captureRef.current.autoplay = true
          captureRef.current.muted = true
          // iOS Safari requires playsInline or hidden muted videos won't play
          // → MediaPipe gaze silently no-ops. Keep in sync with the
          // interview + other modules' proctor videos.
          captureRef.current.playsInline = true

          // Wait for video to be ready
          await new Promise(resolve => {
            captureRef.current.onloadedmetadata = () => {
              captureRef.current.play().then(resolve).catch(resolve)
            }
            // Fallback timeout
            setTimeout(resolve, 1000)
          })

          if (!canvasRef.current) {
            canvasRef.current = document.createElement('canvas')
            canvasRef.current.width = 640
            canvasRef.current.height = 480
          }

          // Store tracks for cleanup
          if (!window.proctorStreamTracks) {
            window.proctorStreamTracks = []
          }
          proctorStream.getTracks().forEach(track => {
            window.proctorStreamTracks.push(track)
          })

          // Mark proctoring as active
          proctoringActive.current = true
          startCollectorIfReady()
        } catch (err) {
          console.error('Failed to create proctoring stream:', err)
          clearTimeout(safetyClearTimeout)
          capturingInProgress.current = false
          return null
        }
      }

      // Take capture with existing proctoring stream
      try {
        const context = canvasRef.current.getContext('2d')
        // Draw from video
        context.drawImage(
          captureRef.current,
          0,
          0,
          canvasRef.current.width,
          canvasRef.current.height
        )

        // Get blob
        const blob = await new Promise(resolve => {
          canvasRef.current.toBlob(resolve, 'image/jpeg', 0.8)
        })

        // Clear safety timeout
        clearTimeout(safetyClearTimeout)

        if (blob) {
          console.log('Standard proctoring capture completed')
          setCaptureCounter(prev => prev + 1)
          capturingInProgress.current = false
          return blob
        }
      } catch (err) {
        console.error('Error in standard capture mode:', err)
      }

      clearTimeout(safetyClearTimeout)
      capturingInProgress.current = false
      return null
    } catch (error) {
      console.error('Overall capture error:', error)
      capturingInProgress.current = false
      return null
    }
  }

  const uploadProctorImage = async imageBlob => {
    if (!imageBlob) return

    try {
      // FIXED: Get assessment_assigned_id with multiple fallbacks
      const assessmentAssignedId =
        currentAssessment?.assessment_assigned_id ||
        assessment?.assessment_assigned_id ||
        location?.state?.assessmentData?.assessment_assigned_id ||
        location?.state?.assessment_assigned_id

      // FIXED: Get student ID with multiple fallbacks. In the OTP / email-invite
      // flow there is no logged-in studentDetails, so fall back to the invite
      // assigned id and finally the assessmentAssignedId (mirrors AIInterview).
      const otpAssignedId =
        (typeof sessionStorage !== 'undefined' &&
          sessionStorage.getItem('assessment_invite_assigned_id')) || null
      const studentId =
        studentDetails?.id ||
        studentDetails?.studentId ||
        currentAssessment?.studentId ||
        otpAssignedId ||
        assessmentAssignedId

      if (!assessmentAssignedId) {
        console.error('❌ [PROCTORING] No assessment_assigned_id found for proctoring upload')
        return
      }

      if (!studentId) {
        console.error('❌ [PROCTORING] No student ID found for proctoring upload')
        return
      }

      console.log('🔍 [PROCTORING] Communication - Uploading with IDs:', {
        assessmentAssignedId,
        studentId
      })

      const base64Image = await blobToBase64(imageBlob)
      const formData = new FormData()
      const byteCharacters = atob(base64Image)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const imageFile = new Blob([byteArray], { type: 'image/jpeg' })

      formData.append('assessmentAssignedId', assessmentAssignedId) // FIXED: Always include this
      formData.append('studentId', studentId) // FIXED: Always include this
      formData.append('image', imageFile)

      await studentRequest.post(
        'students/assessments/proctoring/uploadImage',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      )

      console.log('✅ [PROCTORING] Communication - Image uploaded successfully')
    } catch (error) {
      console.error('❌ [PROCTORING] Communication - Error processing proctoring image:', error)
      // Don't throw error to avoid breaking the assessment flow
    }
  }
  const blobToBase64 = blob => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1]
        resolve(base64String)
      }
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })
  }

  // iPhone: iOS suspends the proctoring camera while the app/tab is backgrounded
  // and then REJECTS a gesture-less getUserMedia re-acquire (the one fired from
  // the visibilitychange handler), so the camera/green light stays off on
  // return. Call this from the "Resume Assessment" tap — a real user gesture iOS
  // always honours — to drop the dead stream and re-acquire immediately (no
  // setTimeout, so getUserMedia stays bound to the gesture).
  const resumeProctoringAfterReentry = () => {
    try {
      if (captureRef.current && captureRef.current.srcObject) {
        captureRef.current.srcObject.getTracks().forEach(t => { try { t.stop() } catch (_) {} })
        captureRef.current.srcObject = null
      }
    } catch (_) {}
    captureRef.current = null
    try {
      if (window.proctorStreamTracks) {
        window.proctorStreamTracks.forEach(t => { try { t.stop() } catch (_) {} })
        window.proctorStreamTracks = []
      }
    } catch (_) {}
    if (currentAssessment?.allowProctoring !== false && !completedRef.current) {
      proctoringActive.current = true
      if (!captureInterval.current) setupProctoringInterval()
      captureImage().then(b => { if (b) uploadProctorImage(b) }).catch(() => {})
    }
  }

  const FullscreenPermissionModal = () => {
    const requestFullscreenAccess = async () => {
      try {
        await enterFullPageMode() // FIXED: Use enterFullPageMode instead of enterFullscreen
        // Check if fullscreen was successful
        setTimeout(() => {
          if (
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            isFullPageMode // FIXED: Also check isFullPageMode
          ) {
            setFullscreenPermissionGranted(true)
            setShowFullscreenModal(false)
            setTimerStarted(true)
          } else {
            alert(
              'You must enable fullscreen to proceed with the assessment. This is required for proctoring.'
            )
          }
        }, 500)
        if (currentAssessment.title === "Assessment #1" || currentAssessment.title === "Assessment #2") {
          const diagnosisNumber = 2 - currentAssessment.diagnosisRemain + 1;
          trackDiagnosisStarted(diagnosisNumber, currentAssessment.assessment_assigned_id, currentAssessment.type, currentAssessment.entityName);
        }
        trackAssessmentStarted(currentAssessment.assessment_assigned_id, currentAssessment.type, currentAssessment.isCorporate, currentAssessment.entityName);
        trackFullscreenEntered(currentAssessment.assessment_assigned_id, currentAssessment.type, false, currentAssessment.isCorporate, currentAssessment.entityName);
      } catch (error) {
        console.error('Fullscreen error:', error)
        alert(
          'Fullscreen permission is required. Please try again or check your browser settings.'
        )
      }
    }

    return (
      <FullscreenModalOverlay>
        <FullscreenModalContent onClick={e => e.stopPropagation()}>
          <FullscreenTitle>Enable Fullscreen Mode</FullscreenTitle>
          <FullscreenDescription>
            This assessment requires fullscreen mode for proctoring purposes.
            You must enable fullscreen to continue.
          </FullscreenDescription>
          <FullscreenDescription>
            <div style={{ textAlign: 'left', width: '100%' }}>
              <span style={{ marginLeft: '27px' }}>
                <strong>Important:</strong> During this assessment:
              </span>
              <ul style={{ margin: '10px 0' }}>
                <li>Exiting fullscreen is not allowed</li>
                <li>
                  Switching tabs is not allowed (3 warnings; the fourth violation auto-submits)
                </li>
                <li>Browser navigation is disabled</li>
                <li>Key combinations like Alt+Tab are blocked</li>
              </ul>
              Violations may result in automatic submission of your assessment.
            </div>
          </FullscreenDescription>
          <PrimaryButton onClick={requestFullscreenAccess}>
            Accept & Enter Fullscreen
          </PrimaryButton>
        </FullscreenModalContent>
      </FullscreenModalOverlay>
    )
  }

  const FullscreenReentryOverlay = () => {
    return (
      <FullscreenModalOverlay>
        <FullscreenModalContent onClick={e => e.stopPropagation()}>
          <FullscreenTitle>Fullscreen Required</FullscreenTitle>
          <FullscreenDescription>
            You have exited fullscreen mode. For security and proctoring
            purposes, you must return to fullscreen mode to continue the
            assessment.
          </FullscreenDescription>
          <PrimaryButton
            onClick={() => {
              enterFullscreen()
                .then(() => {
                  setShowFullscreenReentryOverlay(false)
                  trackFullscreenEntered(currentAssessment.assessment_assigned_id, currentAssessment.type, true, currentAssessment.isCorporate, currentAssessment.entityName);
                })
                .catch(err => {
                  console.error('Failed to re-enter fullscreen:', err)
                })
            }}
          >
            Return to Fullscreen
          </PrimaryButton>
        </FullscreenModalContent>
      </FullscreenModalOverlay>
    )
  }

  // Timer effect
  useEffect(() => {
    if (timerStarted && !timerPaused && !isCompleted) {
      const timer = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            handleTimeUp()
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => clearInterval(timer)
    }
  }, [timerStarted, timerPaused, isCompleted])

  // FIXED: Handle browser fullscreen changes with better logic
  useEffect(() => {
    assessmentActiveRef.current =
      isFullPageMode && fullscreenPermissionGranted && !isCompleted
    completedRef.current = isCompleted
    handleSubmitRef.current = () => handleSubmit({ force: true })
  }, [isFullPageMode, fullscreenPermissionGranted, isCompleted, handleSubmit])

  // Scope the gaze collector per section/page; stop it on completion so its
  // final events flush. No-op until the collector has started.
  useEffect(() => {
    if (!proctoringCollectorStarted.current) return
    if (isCompleted) {
      try { proctoringCollector.stop() } catch (_) {}
      return
    }
    proctoringCollector.setActiveQuestion(currentPage, `section-${currentPage}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, isCompleted])

  // Tab switch detection (only when proctoring is enabled)
  useEffect(() => {
    if (!proctoringEnabled) return

    function handleVisibilityChange() {
      // Use refs to always get latest state
      if (
        document.visibilityState === 'hidden' &&
        assessmentActiveRef.current &&
        !completedRef.current
      ) {
        const isMobileInterruption = markMobileInterruption()
        // Report-only proctoring: tab/app switch (same-device lookup gaze can't see).
        if (proctoringCollectorStarted.current) {
          proctoringCollector.recordEvent('tab_hidden', {
            severity: 'high',
            confidence: 1,
          })
        }
        // If a video-response recording is live, iOS is about to suspend the
        // capture and kill it. Flag it so onstop (whenever it fires) discards
        // the partial take instead of saving/uploading a corrupt clip.
        if (recordingRef.current) {
          interruptedRecordingRef.current = true
        }
        if (isMobileInterruption) return
        setTabSwitchCount(prev => {
          const newCount = prev + 1
          if (newCount >= MAX_TAB_SWITCH_WARNINGS) {
            setShowViolationModal(true)
            setViolationType('tab-switch')
            trackViolationDetected(currentAssessment.assessment_assigned_id, currentAssessment.type, newCount, 'tab-switch', currentAssessment.isCorporate, currentAssessment.entityName)
            trackAssessmentAutoSubmitted(
              currentAssessment.assessment_assigned_id,
              newCount,
              'violation count exceeded',
              currentAssessment.type,
              currentAssessment.isCorporate,
              currentAssessment.entityName
            )
            // Add 3s delay before auto-submit
            isAutoSubmittedRef.current = true
            setTimeout(() => {
              submitAfterViolation()
            }, 5000)
          } else {
            setShowReentryModal(true)
            trackViolationDetected(currentAssessment.assessment_assigned_id, currentAssessment.type, newCount, 'tab-switch', currentAssessment.isCorporate, currentAssessment.entityName)
          }
          return newCount
        })
      } else if (
        document.visibilityState === 'visible' &&
        !shouldEnforceFullscreen() &&
        assessmentActiveRef.current &&
        !completedRef.current
      ) {
        // iPhone: a video-response recording was active when the app went to the
        // background. iOS killed the capture and it can't resume, so stop the
        // orphaned recorder — its onstop (flagged interrupted) discards the
        // partial take and resets to the ready-to-record state. If iOS already
        // tore the recorder down without firing onstop, reset manually.
        if (recordingRef.current) {
          interruptedRecordingRef.current = true
          try {
            if (activeRecorderRef.current && activeRecorderRef.current.state !== 'inactive') {
              activeRecorderRef.current.stop()
            } else {
              recordingRef.current = false
              activeRecorderRef.current = null
              chunks.current = []
              setRecordedVideo(null)
              setVideoBlob(null)
              setRecording(false)
            }
          } catch (_) {
            recordingRef.current = false
            activeRecorderRef.current = null
            setRecording(false)
          }
          return
        }
        // iPhone only: iOS suspends the camera when the tab/app is backgrounded,
        // so on return the proctor stream is dead (frozen/black frames). Reset
        // the capture ref so the next snapshot re-acquires getUserMedia, and kick
        // one immediately so proctoring resumes instead of staying stopped.
        try {
          if (captureRef.current && captureRef.current.srcObject) {
            captureRef.current.srcObject.getTracks().forEach(t => { try { t.stop() } catch (_) {} })
            captureRef.current.srcObject = null
          }
        } catch (_) {}
        captureRef.current = null
        try {
          if (window.proctorStreamTracks) {
            window.proctorStreamTracks.forEach(t => { try { t.stop() } catch (_) {} })
            window.proctorStreamTracks = []
          }
        } catch (_) {}
        if (proctoringActive.current) {
          if (!captureInterval.current) setupProctoringInterval()
          setTimeout(() => {
            captureImage()
              .then(b => { if (b) uploadProctorImage(b) })
              .catch(() => {})
          }, 800)
        }
      }
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [proctoringEnabled])

  // Fullscreen exit detection (only when fullscreen lockdown is enforced)
  useEffect(() => {
    if (!enforceFullscreen) return

    const handleFullscreenChange = () => {
      const isInFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      )
      if (!isInFullscreen && isMobileInterruptionFullscreenExit()) return
      if (
        assessmentActiveRef.current &&
        !isInFullscreen &&
        !completedRef.current
      ) {
        // Report-only proctoring: fullscreen exit (separate from warning flow).
        if (proctoringCollectorStarted.current) {
          proctoringCollector.recordEvent('fullscreen_exit', { severity: 'medium', confidence: 1 })
        }
        setTabSwitchCount(prev => {
          const newCount = prev + 1
          if (newCount >= MAX_TAB_SWITCH_WARNINGS) {
            setShowViolationModal(true)
            setViolationType('fullscreen-exit')
            trackViolationDetected(currentAssessment.assessment_assigned_id, currentAssessment.type, newCount, 'fullscreen-exit', currentAssessment.isCorporate, currentAssessment.entityName)
            trackAssessmentAutoSubmitted(
              currentAssessment.assessment_assigned_id,
              newCount,
              'violation count exceeded',
              currentAssessment.type,
              currentAssessment.isCorporate,
              currentAssessment.entityName
            )
            // Add 3s delay before auto-submit
            isAutoSubmittedRef.current = true
            setTimeout(() => {
              submitAfterViolation()
            }, 5000)
          } else {
            setShowReentryModal(true)
            trackFullscreenExited(currentAssessment.assessment_assigned_id, currentAssessment.type, newCount, currentAssessment.isCorporate, currentAssessment.entityName)
          }
          return newCount
        })
      }
    }
    document.addEventListener('fullscreenchange', handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', handleFullscreenChange)
    document.addEventListener('MSFullscreenChange', handleFullscreenChange)
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
      document.removeEventListener(
        'webkitfullscreenchange',
        handleFullscreenChange
      )
      document.removeEventListener(
        'mozfullscreenchange',
        handleFullscreenChange
      )
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange)
    }
  }, [enforceFullscreen])

  //detect right-click
  useEffect(() => {
    if (isUAT) return;
    const handleRightClick = (e) => {
      trackRightClick(currentAssessment.assessment_assigned_id, currentAssessment.type, currentAssessment.isCorporate, currentAssessment.entityName);
    }
    document.addEventListener('contextmenu', handleRightClick)
    return () => {
      document.removeEventListener('contextmenu', handleRightClick)
    }
  }, [])

  useEffect(() => {
    if (!assessment) {
      navigate('/assessment')
      return
    }
  }, [assessment, navigate])

  if (!questions || questions.length === 0) {
    return <div>Loading...</div>
  }

  // NEW: Render assessment content
  const renderAssessmentContent = () => (
    <>
      <AssessmentHeader>
        <AssessmentInfo>
          <LogoContainer>
            <PluginLiveLogo />
          </LogoContainer>
          <VerticalSeparator />
          <AssessmentTitle>Communication Assessment</AssessmentTitle>
        </AssessmentInfo>
        <AssessmentTimer>{formatTime(timeLeft)}</AssessmentTimer>
      </AssessmentHeader>
      <ProgressIndicator>
        {/* Main sections - type-based, not positional */}
        {(() => {
          const mainSectionTypes = ['Paragraph Reading', 'Audio Question', 'Video Response'];
          const writingSectionTypes = ['Question Based Response', 'Email Writing', 'Dictation', 'Sentence Completion', 'Sentence Build'];

          const mainSections = questions.filter(s => mainSectionTypes.includes(s.type));
          const writingSections = questions.filter(s => writingSectionTypes.includes(s.type));

          const getIcon = (type) => {
            switch (type) {
              case 'Paragraph Reading':
                return <ParagraphReadingIcon />;
              case 'Audio Question':
                return <ListeningAbilityIcon />;
              case 'Video Response':
                return <SpeakingAbilityIcon />;
              default:
                return null;
            }
          };

          const getDisplayName = (type) => {
            switch (type) {
              case 'Paragraph Reading':
                return 'Reading Ability';
              case 'Audio Question':
                return 'Listening Ability';
              case 'Video Response':
                return 'Speaking Ability';
              default:
                return type;
            }
          };

          // Find the actual index in the full questions array for active/completed checks
          const getQuestionIndex = (section) => questions.indexOf(section);

          return (
            <>
              {mainSections.map((section) => {
                const qIndex = getQuestionIndex(section);
                const completed = (currentPage > qIndex) || isSectionAnswered(section);

                return (
                  <ProgressStep
                    key={section.type}
                    completed={completed}
                    active={qIndex === currentPage}
                  >
                    <StepCircle
                      completed={completed}
                      active={qIndex === currentPage}
                    >
                      {getIcon(section.type)}
                    </StepCircle>
                    <StepLabel>
                      <StepTitle active={qIndex === currentPage}>
                        {getDisplayName(section.type)}
                      </StepTitle>
                    </StepLabel>
                  </ProgressStep>
                );
              })}

              {/* Writing section - grouped by type, not position */}
              {writingSections.length > 0 && (
                <ProgressStep
                  completed={writingSections.every(section => isSectionAnswered(section))}
                  active={writingSections.some(section => questions.indexOf(section) === currentPage)}
                >
                  <StepCircle
                    completed={writingSections.every(section => isSectionAnswered(section))}
                    active={writingSections.some(section => questions.indexOf(section) === currentPage)}
                  >
                    <WritingAbilityIcon />
                  </StepCircle>
                  <StepLabel>
                    <StepTitle active={writingSections.some(section => questions.indexOf(section) === currentPage)}>
                      Written Ability
                    </StepTitle>
                  </StepLabel>
                </ProgressStep>
              )}
            </>
          );
        })()}
      </ProgressIndicator>
      {/* REPLACE THIS ENTIRE SECTION with renderQuestionType() */}
      {renderQuestionType()}
      {showError && (
        <div style={{
          backgroundColor: '#fff8f8',
          border: '1px solid #fee2e2',
          borderRadius: '8px',
          padding: '12px 16px',
          marginTop: '20px',
          marginBottom: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          <div style={{
            color: '#ef4444',
            fontSize: '16px',
            fontWeight: 'bold'
          }}>
            !
          </div>
          <div style={{
            color: '#ef4444',
            fontSize: '14px'
          }}>
            {errorMessage}
          </div>
        </div>
      )}

      <NavigationButtons>
        {/* Back button logic remains unchanged */}
        {/* {currentPage > 0 && !recording && !isSubmitting && (
    <StyledButton
      onClick={handlePrevious}
      disabled={recording || isSubmitting}
      style={{
        background: '#f8f9fa',
        color: '#374151',
        border: '1px solid #e9ecef',
        padding: '12px 24px',
        borderRadius: '8px',
        fontWeight: '500',
        cursor: recording || isSubmitting ? 'not-allowed' : 'pointer',
        opacity: recording || isSubmitting ? 0.5 : 1
      }}
    >
      Back
    </StyledButton>
  )} */}

        {(() => {
          // Helper function to check if we're truly at the end
          const isAtVeryEnd = () => {
            // If not on last section, definitely not at end
            if (currentPage < questions.length - 1) {
              return false;
            }

            // If on last section, check if it's a multi-question section
            const lastSection = questions[questions.length - 1];

            if (lastSection.type === 'Dictation') {
              const dictationQuestions = lastSection.questions || [];
              return dictationCurrentIndex >= dictationQuestions.length - 1;
            }

            if (lastSection.type === 'Sentence Completion') {
              const sentenceQuestions = lastSection.questions || [];
              return sentenceCompletionCurrentIndex >= sentenceQuestions.length - 1;
            }

            if (lastSection.type === 'Sentence Build') {
              const sentenceBuildQuestions = lastSection.questions || [];
              return sentenceBuildCurrentIndex >= sentenceBuildQuestions.length - 1;
            }

            // For single-question sections, if we're on the last section, we're at the end
            return true;
          };

          // Check if current section is completed
          const isSectionCompleted = isCurrentSectionComplete();
          const shouldEnableNext = isSectionCompleted;

          // Determine button tooltip text
          const buttonTooltip = !shouldEnableNext ?
            "Please complete all required responses in this section" :
            "";

          const videoNotRecorded = currentSection.type === 'Video Response' && !recordedVideo
          const submitDisabled = isSubmitting || recording || videoNotRecorded || !isSectionCompleted
          return isAtVeryEnd() ? (
            <StyledButton
              variant="primary"
              onClick={() => handleSubmit()}
              disabled={submitDisabled}
              title={videoNotRecorded
                ? 'Record your video response to submit'
                : !isSectionCompleted
                  ? 'Answer the current question to submit'
                  : undefined}
              style={{
                background: submitDisabled ? '#9ca3af' : '#4f46e5',
                color: 'white',
                border: 'none',
                padding: '12px 32px',
                borderRadius: '8px',
                fontWeight: '600',
                cursor: submitDisabled ? 'not-allowed' : 'pointer',
                boxShadow: '0 2px 4px rgba(79, 70, 229, 0.2)',
                transition: 'all 0.2s ease'
              }}
            >
              {isSubmitting ? (
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid #ffffff',
                    borderTop: '2px solid transparent',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }} />
                  Submitting...
                </span>
              ) : videoNotRecorded ? (
                'Record video to submit'
              ) : !isSectionCompleted ? (
                'Answer required'
              ) : (
                'Submit Assessment'
              )}
            </StyledButton>
          ) : (
            <div style={{ position: 'relative' }}>
              <StyledButton
                variant="primary"
                onClick={handleNext}
                disabled={recording || isSubmitting || !shouldEnableNext}
                style={{
                  background: recording || isSubmitting || !shouldEnableNext ? '#9ca3af' : '#4f46e5',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  fontWeight: '600',
                  cursor: recording || isSubmitting || !shouldEnableNext ? 'not-allowed' : 'pointer',
                  boxShadow: '0 2px 4px rgba(79, 70, 229, 0.2)',
                  transition: 'all 0.2s ease'
                }}
              >
                Next
              </StyledButton>
            </div>
          );
        })()}
      </NavigationButtons>

      <style jsx>{`
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`}</style>
    </>
  )
  if (isCompleted) {
    return (
      <Completion
        assessmentData={completedAssessmentData || assessmentData || assessment}
        submittedTime={finalSubmittedTime || timeLeft}
        setAssessment={setAssessment}
        isPractice={
          isPractice || assessmentData?.isPractice || assessment?.isPractice
        }
      />
    )
  }

  if (proctoringEnabled && showViolationModal) {
    return <ViolationModal onSubmit={submitAfterViolation} />
  }
  if (proctoringEnabled && showReentryModal) {
    return (
      <FullscreenReentryModal
        onReturn={
          enforceFullscreen
            ? async () => {
                setShowReentryModal(false)
                await enterFullPageMode()
              }
            : () => {
                // LITE (iPhone): tab/app-switch re-entry must not request
                // fullscreen — just dismiss and let the student carry on. Also
                // re-acquire the proctoring camera here (gesture-time) so the
                // green light comes back on; iOS won't let us do it from the
                // gesture-less visibilitychange handler.
                setShowReentryModal(false)
                resumeProctoringAfterReentry()
              }
        }
        warningCount={tabSwitchCount}
        lite={!enforceFullscreen}
      />
    )
  }
  return isCompleted ? (
    <Completion
      assessmentData={completedAssessmentData || assessmentData || assessment}
      submittedTime={finalSubmittedTime || timeLeft}
      setAssessment={setAssessment}
      isPractice={
        isPractice || assessmentData?.isPractice || assessment?.isPractice
      }
    />
  ) : (
    <>
      {/* Modals and overlays */}
      {enforceFullscreen && showFullscreenModal && !fullscreenPermissionGranted && (
        <FullscreenPermissionModal />
      )}

      {/* Strictly enforce fullscreen: if exited, only show overlay (only when proctoring enabled) */}
      {proctoringEnabled && showFullscreenReentryOverlay ? (
        <FullscreenReentryOverlay />
      ) : // NEW: Conditional rendering based on full-page mode
        isFullPageMode ? (
          <FullPageOverlay className="exam-shell">
            <FullPageContainer className="exam-scroll">
              <FullPageContent className="exam-scroll">{renderAssessmentContent()}</FullPageContent>
            </FullPageContainer>
          </FullPageOverlay>
        ) : (
          <PageContainer className="exam-shell" style={{ fontFamily: 'Inter, sans-serif' }}>
            <ContentWrapper className="exam-scroll">{renderAssessmentContent()}</ContentWrapper>
          </PageContainer>
        )}

      {/* Success Modal */}
      {showSuccessModal && (
        <SuccessModal
          isVisible={showSuccessModal}
          onClose={handleSuccessModalClose}
          title="Recording Deleted"
          message="Your recording has been successfully deleted. You can now record again."
        />
      )}

      {/* Delete Confirmation Modal */}
      {isModalVisible && (
        <ModalOverlay onClick={handleCloseModal}>
          <ModalContent onClick={e => e.stopPropagation()}>
            <ShortListModalImg
              src={DeleteImage || '/placeholder.svg'}
              alt="Delete"
            />
            <ModalText>
              Are you sure you want to delete this recording?
            </ModalText>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <StyledButton onClick={handleCloseModal}>Cancel</StyledButton>
              <StyledButton variant="primary" onClick={handleConfirmDelete}>
                Delete
              </StyledButton>
            </div>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  )
}

export default CommunicationAssessment
